(function () {
  var SELECTOR = '[data-sa-collection-selector]';
  var pendingCountRequests = new WeakMap();
  var pendingHelpResolutions = new WeakMap();
  var pendingKnowResolutions = new WeakMap();
  var SELECTOR_SCORE_WEIGHTS = {
    availability: 4,
    productRole: 14,
    exactCameraCount: 16,
    recorderRightSize: 12,
    featureFit: 10,
    useCaseFit: 10,
    environmentFit: 8,
    highResolution: 6,
    indoorDeterrencePenalty: -12,
    wrongProductTypePenalty: -20
  };
  var BEST_VALUE_MIN_RATIO = 0.82;
  var BRAND_DEFINITIONS = [
    { key: 'hikvision', label: 'Hikvision', terms: ['hikvision'] },
    { key: 'dahua', label: 'Dahua', terms: ['dahua'] },
    { key: 'axis', label: 'AXIS', terms: ['axis'] },
    { key: 'hanwha', label: 'Hanwha', terms: ['hanwha', 'hanwha vision', 'wisenet'] },
    { key: 'hilook', label: 'HiLook', terms: ['hilook'] },
    { key: 'unv', label: 'UNV', terms: ['unv', 'uniview', 'uniarch'] },
    { key: 'tp-link-vigi', label: 'TP-Link / VIGI', terms: ['tp link', 'tp-link', 'vigi'] },
    { key: 'idis', label: 'IDIS', terms: ['idis'] },
    { key: 'vivotek', label: 'Vivotek', terms: ['vivotek'] }
  ];
  var COLLECTION_INTENTS = {
    'better-night-vision': {
      label: 'Better night vision',
      area: 'outdoors',
      quickFilters: { ir_distance: 'gte-40' },
      nativeFilters: [{ label: 'Night vision', terms: ['night', 'colorvu', 'colourvu', 'darkfighter', 'exir', 'ir'] }]
    },
    'deter-intruders': {
      label: 'Deter intruders',
      area: 'outdoors',
      useCases: ['perimeter-boundary', 'warehouse-perimeter', 'home-exterior'],
      quickFilters: { ir_distance: 'gte-40' },
      nativeFilters: [{ label: 'Audio & deterrence', terms: ['deterrence', 'strobe', 'siren', 'liveguard', 'audio'] }]
    },
    'identify-people-vehicles': {
      label: 'Identify people & vehicles',
      area: 'outdoors',
      useCases: ['driveway-vehicle-entry', 'driveway-entrance', 'car-park'],
      nativeFilters: [{ label: 'Smart features', terms: ['human', 'vehicle', 'acusense', 'ai', 'smd'] }]
    },
    'wide-area-coverage': {
      label: 'Wide area coverage',
      area: 'outdoors',
      useCases: ['large-commercial-property', 'large-outdoor-area', 'warehouse-perimeter']
    },
    'two-way-audio': {
      label: 'Two-way audio',
      area: 'outdoors',
      nativeFilters: [{ label: 'Audio & deterrence', terms: ['two-way', 'two way', 'microphone', 'speaker', 'audio'] }]
    },
    'not-sure': {
      label: 'Help me choose'
    }
  };

  var AREA_USE_CASES = {
    'front-door-entry-security': [
      'home-entrance-deliveries',
      'reception-entry',
      'gate-boom-gate',
      'home-exterior',
      'reception-corridors',
      'perimeter-boundary'
    ],
    'driveway-perimeter-security': [
      'driveway-vehicle-entry',
      'driveway-entrance',
      'long-driveway-rural',
      'perimeter-boundary',
      'gate-boom-gate',
      'large-outdoor-area',
      'warehouse-perimeter',
      'large-commercial-property'
    ],
    'shop-floor-sales-area-security': [
      'retail-floor',
      'checkout-register',
      'reception-entry',
      'wide-room-360',
      'retail-shop',
      'stockroom-back-office',
      'office'
    ],
    'security-cabinet': [
      'cabinet-high-value',
      'stockroom-back-office',
      'office-workplace',
      'office',
      'reception-corridors'
    ],
    'car-parks-garages-security': [
      'car-park',
      'driveway-vehicle-entry',
      'gate-boom-gate',
      'large-outdoor-area',
      'perimeter-boundary'
    ],
    'hallways-corridors-security': [
      'hallway-corridor',
      'reception-corridors',
      'wide-room-360',
      'reception-entry'
    ],
    'stockrooms-back-offices-security': [
      'stockroom-back-office',
      'cabinet-high-value',
      'warehouse-interior',
      'office'
    ],
    'loading-docks-security': [
      'loading-dock-service-yard',
      'loading-areas',
      'driveway-vehicle-entry',
      'warehouse-perimeter',
      'large-outdoor-area'
    ],
    'construction-areas-security': [
      'large-outdoor-area',
      'gate-boom-gate',
      'perimeter-boundary',
      'loading-dock-service-yard',
      'large-commercial-property'
    ],
    'reception-perimeter-security': [
      'reception-entry',
      'home-entrance-deliveries',
      'perimeter-boundary',
      'gate-boom-gate',
      'reception-corridors'
    ]
  };

  var INDUSTRY_USE_CASES = {
    'home-family-security': [
      'home-entrance-deliveries',
      'driveway-vehicle-entry',
      'home-exterior',
      'home-interior',
      'perimeter-boundary'
    ],
    'elderly-carer-monitoring': [
      'reception-entry',
      'home-entrance-deliveries',
      'home-interior',
      'reception-corridors',
      'hallway-corridor',
      'home-exterior'
    ],
    'shop-farm-and-rural-property-security-equipment': [
      'farm-rural-property',
      'long-driveway-rural',
      'gate-boom-gate',
      'large-outdoor-area',
      'perimeter-boundary',
      'driveway-vehicle-entry'
    ],
    'shop-warehouse-and-logistics-security-equipment': [
      'loading-dock-service-yard',
      'warehouse-interior',
      'warehouse-perimeter',
      'stockroom-back-office',
      'gate-boom-gate',
      'large-commercial-property',
      'driveway-vehicle-entry',
      'perimeter-boundary',
      'large-outdoor-area'
    ],
    'shop-construction-and-remote-surveillance-security-equipment': [
      'large-outdoor-area',
      'gate-boom-gate',
      'perimeter-boundary',
      'warehouse-perimeter',
      'loading-dock-service-yard',
      'large-commercial-property'
    ],
    'shop-retail-shops-storefront-security-equipment': [
      'retail-floor',
      'checkout-register',
      'stockroom-back-office',
      'reception-entry',
      'wide-room-360',
      'home-entrance-deliveries'
    ],
    'traffic-control-temporary-sites': [
      'driveway-vehicle-entry',
      'gate-boom-gate',
      'large-outdoor-area',
      'car-park',
      'perimeter-boundary'
    ],
    'shop-property-management-and-airbnb-security-equipment': [
      'home-entrance-deliveries',
      'reception-entry',
      'reception-corridors',
      'hallway-corridor',
      'car-park',
      'perimeter-boundary',
      'home-exterior'
    ],
    'shop-schools-and-private-colleges-security-equipment': [
      'reception-entry',
      'reception-corridors',
      'hallway-corridor',
      'car-park',
      'perimeter-boundary',
      'large-outdoor-area',
      'driveway-vehicle-entry'
    ],
    'shop-healthcare-security-equipment-for-practices-and-clinics': [
      'reception-entry',
      'healthcare-clinic',
      'reception-corridors',
      'hallway-corridor',
      'stockroom-back-office',
      'car-park',
      'home-entrance-deliveries'
    ]
  };

  var INDUSTRY_SCHEMAS = {
    'home-family-security': {
      status: 'pending_admin_collection_resource',
      locationQuestion: 'Where around the home needs coverage?',
      useCaseQuestion: 'What household concern matters most?'
    },
    'elderly-carer-monitoring': {
      status: 'pending_admin_collection_resource',
      locationQuestion: 'Where will care monitoring be useful?',
      useCaseQuestion: 'What do you need to monitor?'
    },
    'shop-farm-and-rural-property-security-equipment': {
      status: 'pending_admin_collection_resource',
      locationQuestion: 'Where on the property will it be installed?',
      useCaseQuestion: 'What rural risk matters most?'
    },
    'shop-warehouse-and-logistics-security-equipment': {
      status: 'working_collection',
      locationQuestion: 'Where in the warehouse or yard?',
      useCaseQuestion: 'What logistics area needs attention?'
    },
    'shop-construction-and-remote-surveillance-security-equipment': {
      status: 'working_collection',
      locationQuestion: 'Where on the site will it be installed?',
      useCaseQuestion: 'What site risk matters most?'
    },
    'shop-retail-shops-storefront-security-equipment': {
      status: 'working_collection',
      locationQuestion: 'Where in the store will it be used?',
      useCaseQuestion: 'What retail area needs attention?'
    },
    'traffic-control-temporary-sites': {
      status: 'pending_admin_collection_resource',
      locationQuestion: 'Where will the temporary setup be used?',
      useCaseQuestion: 'What traffic or temporary-site need matters most?'
    },
    'shop-property-management-and-airbnb-security-equipment': {
      status: 'working_collection',
      locationQuestion: 'Where on the property needs coverage?',
      useCaseQuestion: 'What property-management need matters most?'
    },
    'shop-schools-and-private-colleges-security-equipment': {
      status: 'working_collection',
      locationQuestion: 'Where on campus will it be used?',
      useCaseQuestion: 'What school area needs attention?'
    },
    'shop-healthcare-security-equipment-for-practices-and-clinics': {
      status: 'working_collection',
      locationQuestion: 'Where in the clinic will it be used?',
      useCaseQuestion: 'What healthcare area needs attention?'
    }
  };

  var COMMON_NEED_PRESETS = {
    'package-theft': {
      label: 'Package theft',
      productType: 'camera',
      area: 'outdoors',
      useCases: ['home-entrance-deliveries', 'reception-entry'],
      notes: 'We have preselected front-entry monitoring. Choose the remaining details to refine the recommendation.'
    },
    'package-monitoring': {
      label: 'Package monitoring',
      productType: 'camera',
      area: 'outdoors',
      useCases: ['home-entrance-deliveries'],
      notes: 'We have preselected front-entry monitoring. Choose the remaining details to refine the recommendation.'
    },
    'equipment-theft': {
      label: 'Equipment theft',
      productType: 'kit',
      area: 'outdoors',
      cameraCount: '4',
      useCases: ['large-outdoor-area', 'large-commercial-property', 'warehouse-perimeter'],
      quickFilters: {
        ir_distance: 'gte-40'
      },
      notes: 'We have preselected outdoor site coverage. Choose the remaining details before viewing recommendations.'
    },
    'equipment-protection': {
      label: 'Equipment protection',
      productType: 'kit',
      area: 'outdoors',
      cameraCount: '4',
      useCases: ['large-outdoor-area', 'farm-rural-property', 'warehouse-perimeter'],
      quickFilters: {
        ir_distance: 'gte-40'
      },
      notes: 'We have preselected outdoor equipment coverage. Choose the remaining details before viewing recommendations.'
    },
    'equipment-storage': {
      label: 'Equipment storage',
      productType: 'kit',
      area: 'outdoors',
      cameraCount: '4',
      useCases: ['large-outdoor-area', 'large-commercial-property'],
      notes: 'We have preselected outdoor site coverage. Choose the remaining details before viewing recommendations.'
    },
    'loading-dock-monitoring': {
      label: 'Loading dock monitoring',
      productType: 'kit',
      area: 'outdoors',
      cameraCount: '4',
      useCases: ['loading-areas', 'loading-dock-service-yard', 'warehouse-perimeter'],
      notes: 'We have preselected loading-area monitoring. Choose the remaining details before viewing recommendations.'
    },
    'loading-activity': {
      label: 'Loading activity',
      productType: 'kit',
      area: 'outdoors',
      cameraCount: '4',
      useCases: ['loading-areas', 'loading-dock-service-yard'],
      notes: 'We have preselected loading-area monitoring. Choose the remaining details before viewing recommendations.'
    },
    'site-gates': {
      label: 'Site gates',
      productType: 'camera',
      area: 'outdoors',
      useCases: ['gate-boom-gate', 'driveway-vehicle-entry'],
      notes: 'We have preselected gate and site-entry monitoring. Choose the remaining details before viewing recommendations.'
    },
    'gate-monitoring': {
      label: 'Gate monitoring',
      productType: 'camera',
      area: 'outdoors',
      useCases: ['gate-boom-gate', 'driveway-vehicle-entry'],
      notes: 'We have preselected gate monitoring. Choose the remaining details before viewing recommendations.'
    },
    'vehicle-identification': {
      label: 'Vehicle identification',
      productType: 'camera',
      area: 'outdoors',
      useCases: ['driveway-vehicle-entry', 'car-park', 'gate-boom-gate'],
      quickFilters: {
        ir_distance: 'gte-40'
      },
      notes: 'We have preselected vehicle approach monitoring. Choose the remaining details before viewing recommendations.'
    },
    'after-hours-alerts': {
      label: 'After-hours alerts',
      productType: 'kit',
      area: 'outdoors',
      cameraCount: '4',
      useCases: ['large-outdoor-area', 'large-commercial-property', 'perimeter-boundary'],
      quickFilters: {
        ir_distance: 'gte-40'
      },
      notes: 'We have preselected outdoor after-hours coverage. Choose the remaining details before viewing recommendations.'
    },
    'after-hours-monitoring': {
      label: 'After-hours monitoring',
      productType: 'kit',
      area: 'outdoors',
      cameraCount: '4',
      useCases: ['large-outdoor-area', 'large-commercial-property', 'perimeter-boundary'],
      quickFilters: {
        ir_distance: 'gte-40'
      },
      notes: 'We have preselected outdoor after-hours coverage. Choose the remaining details before viewing recommendations.'
    },
    'after-hours-protection': {
      label: 'After-hours protection',
      productType: 'kit',
      area: 'outdoors',
      cameraCount: '4',
      useCases: ['loading-areas', 'large-outdoor-area', 'perimeter-boundary'],
      quickFilters: {
        ir_distance: 'gte-40'
      },
      notes: 'We have preselected after-hours outdoor coverage. Choose the remaining details before viewing recommendations.'
    },
    'remote-viewing': {
      label: 'Remote viewing',
      productType: 'kit',
      area: 'outdoors',
      useCases: ['large-outdoor-area', 'home-exterior', 'farm-rural-property'],
      notes: 'We have preselected a remote-viewing starting point. Choose the remaining details before viewing recommendations.'
    },
    'perimeter-protection': {
      label: 'Perimeter protection',
      productType: 'kit',
      area: 'outdoors',
      cameraCount: '4',
      useCases: ['perimeter-boundary', 'warehouse-perimeter', 'large-commercial-property'],
      quickFilters: {
        ir_distance: 'gte-40'
      },
      notes: 'We have preselected perimeter coverage. Choose the remaining details before viewing recommendations.'
    },
    'stock-protection': {
      label: 'Stock protection',
      productType: 'camera',
      area: 'indoors',
      useCases: ['stockroom-back-office', 'retail-floor', 'warehouse-interior'],
      notes: 'We have preselected stock-area monitoring. Choose the remaining details before viewing recommendations.'
    },
    'shop-floor-coverage': {
      label: 'Shop-floor coverage',
      productType: 'camera',
      area: 'indoors',
      useCases: ['retail-floor', 'wide-room-360'],
      notes: 'We have preselected retail floor coverage. Choose the remaining details before viewing recommendations.'
    },
    'checkout-pos-monitoring': {
      label: 'Checkout/POS monitoring',
      productType: 'camera',
      area: 'indoors',
      useCases: ['checkout-register', 'retail-floor'],
      notes: 'We have preselected checkout monitoring. Choose the remaining details before viewing recommendations.'
    },
    'warehouse-loading-docks': {
      label: 'Warehouse loading docks',
      productType: 'kit',
      area: 'outdoors',
      cameraCount: '4',
      useCases: ['loading-dock-service-yard', 'loading-areas', 'warehouse-perimeter'],
      notes: 'We have preselected warehouse loading and service-yard coverage. Choose the remaining details before viewing recommendations.'
    },
    'warehouse-stockrooms': {
      label: 'Warehouse stockrooms',
      productType: 'camera',
      area: 'indoors',
      useCases: ['stockroom-back-office', 'warehouse-interior'],
      notes: 'We have preselected warehouse stock and internal storage coverage. Choose the remaining details before viewing recommendations.'
    },
    'retail-shop-floor': {
      label: 'Retail shop floor',
      productType: 'camera',
      area: 'indoors',
      useCases: ['retail-floor', 'wide-room-360'],
      notes: 'We have preselected retail floor coverage. Choose the remaining details before viewing recommendations.'
    },
    'retail-stockroom': {
      label: 'Retail stockroom',
      productType: 'camera',
      area: 'indoors',
      useCases: ['stockroom-back-office', 'retail-floor'],
      notes: 'We have preselected retail stockroom monitoring. Choose the remaining details before viewing recommendations.'
    },
    'airbnb-entry': {
      label: 'Airbnb entry monitoring',
      productType: 'camera',
      area: 'outdoors',
      useCases: ['home-entrance-deliveries', 'reception-entry'],
      notes: 'We have preselected property entry monitoring. Choose the remaining details before viewing recommendations.'
    },
    'school-entries': {
      label: 'School entries',
      productType: 'camera',
      area: 'outdoors',
      useCases: ['reception-entry', 'driveway-vehicle-entry', 'perimeter-boundary'],
      notes: 'We have preselected school entry and perimeter monitoring. Choose the remaining details before viewing recommendations.'
    },
    'entrance-monitoring': {
      label: 'Entrance monitoring',
      productType: 'camera',
      area: 'outdoors',
      useCases: ['reception-entry', 'home-entrance-deliveries'],
      notes: 'We have preselected entry and visitor movement monitoring. Choose the remaining details before viewing recommendations.'
    },
    'reception-monitoring': {
      label: 'Reception monitoring',
      productType: 'camera',
      area: 'indoors',
      useCases: ['reception-entry', 'reception-corridors'],
      notes: 'We have preselected reception and waiting-area monitoring. Choose the remaining details before viewing recommendations.'
    },
    'shared-area-coverage': {
      label: 'Shared area coverage',
      productType: 'camera',
      area: 'indoors',
      useCases: ['reception-corridors', 'hallway-corridor', 'wide-room-360'],
      notes: 'We have preselected shared internal area coverage. Choose the remaining details before viewing recommendations.'
    },
    'clinic-reception': {
      label: 'Clinic reception',
      productType: 'camera',
      area: 'indoors',
      useCases: ['healthcare-clinic', 'reception-entry', 'reception-corridors'],
      notes: 'We have preselected clinic reception coverage. Choose the remaining details before viewing recommendations.'
    }
  };

  var COMMON_NEED_ALIASES = {
    'warehouse-loading-docks': 'loading-dock-monitoring',
    'loading-docks': 'loading-dock-monitoring',
    'loading-activity': 'loading-dock-monitoring',
    'warehouse-stockrooms': 'stock-protection',
    'stockrooms': 'stock-protection',
    'warehouse-perimeter': 'perimeter-protection',
    'after-hours-alerts': 'after-hours-monitoring',
    'after-hours-protection': 'after-hours-monitoring',
    'after-hours-deterrence': 'after-hours-monitoring',
    'stock-loss': 'stock-protection',
    'perimeter-awareness': 'perimeter-protection',
    'entry-monitoring': 'entrance-monitoring',
    'public-entrances': 'entrance-monitoring',
    'visitor-access': 'entrance-monitoring',
    'visitor-management': 'entrance-monitoring',
    'pickup-drop-off-areas': 'vehicle-identification',
    'common-area-coverage': 'shared-area-coverage',
    'remote-property-viewing': 'remote-viewing'
  };

  function canonicalCommonNeedSlug(slug) {
    slug = normalise(slug || '').replace(/\s+/g, '-');
    return COMMON_NEED_ALIASES[slug] || slug;
  }

  function normalise(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function slugify(value) {
    return normalise(value).replace(/\s+/g, '-');
  }

  function normaliseBrandKey(value) {
    var candidate = slugify(value || '');
    if (!candidate) return '';
    var matched = BRAND_DEFINITIONS.find(function (brand) {
      return brand.key === candidate || slugify(brand.label) === candidate || brand.terms.some(function (term) {
        return slugify(term) === candidate;
      });
    });
    return matched ? matched.key : candidate;
  }

  function brandDefinitionForKey(key) {
    var brandKey = normaliseBrandKey(key);
    return BRAND_DEFINITIONS.find(function (brand) { return brand.key === brandKey; }) || null;
  }

  function customerFacingBrandLabel(product) {
    var detected = brandDefinitionForKey(detectedProductBrandKey(product));
    return detected ? detected.label : String(product && product.vendor || '').trim();
  }

  function productTags(product) {
    var tags = product && Array.isArray(product.tags) ? product.tags : [];
    if (!tags.length && product && product.matchText) tags = String(product.matchText).match(/sa_[a-z0-9_-]+/gi) || [];
    return tags.map(function (tag) { return String(tag || ''); }).filter(Boolean);
  }

  function detectedProductBrandKey(product) {
    var tagText = normalise(productTags(product).join(' '));
    var titleText = normalise(product && product.title);
    var fallbackText = normalise([
      product && product.vendor,
      product && product.url,
      product && product.matchText
    ].join(' '));
    var matched = BRAND_DEFINITIONS.find(function (brand) {
      return brand.terms.some(function (term) { return titleText.indexOf(normalise(term)) !== -1; });
    }) || BRAND_DEFINITIONS.find(function (brand) {
      return brand.terms.some(function (term) { return tagText.indexOf(normalise(term)) !== -1; });
    }) || BRAND_DEFINITIONS.find(function (brand) {
      return brand.terms.some(function (term) { return fallbackText.indexOf(normalise(term)) !== -1; });
    });
    return matched ? matched.key : '';
  }

  function brandFromUrl() {
    return normaliseBrandKey(new URLSearchParams(window.location.search).get('sa_brand') || '');
  }

  function activeBrandPreference(root) {
    if (!root) return brandFromUrl();
    return normaliseBrandKey(root.getAttribute('data-sa-brand-preference') || brandFromUrl() || '');
  }

  function setBrandPreference(root, brandKey) {
    if (!root) return false;
    var key = normaliseBrandKey(brandKey || '');
    if (key) root.setAttribute('data-sa-brand-preference', key);
    else root.removeAttribute('data-sa-brand-preference');
    hideKnownCollectionContext(root);
    return true;
  }

  function isAreaSelector(root) {
    return root.getAttribute('data-selector-context') === 'area';
  }

  function isIndustrySelector(root) {
    return root.getAttribute('data-selector-context') === 'industry';
  }

  function currentIndustrySchema(root) {
    if (!isIndustrySelector(root)) return null;
    return INDUSTRY_SCHEMAS[root.getAttribute('data-collection-handle') || ''] || null;
  }

  function isSubmitted(root) {
    return root.getAttribute('data-selector-submitted') === 'true';
  }

  function setSubmitted(root, submitted) {
    root.setAttribute('data-selector-submitted', submitted ? 'true' : 'false');
  }

  function areaAllowedUseCases(root) {
    if (!isAreaSelector(root)) return [];
    return AREA_USE_CASES[root.getAttribute('data-collection-handle') || ''] || [];
  }

  function scopedAllowedUseCases(root) {
    var handle = root.getAttribute('data-collection-handle') || '';
    if (isAreaSelector(root)) return AREA_USE_CASES[handle] || [];
    if (isIndustrySelector(root)) return INDUSTRY_USE_CASES[handle] || [];
    return [];
  }

  function applyIndustrySchema(root) {
    var schema = currentIndustrySchema(root);
    if (!schema) return;
    root.setAttribute('data-industry-resource-status', schema.status || 'working_collection');

    var productLegend = root.querySelector('[data-sa-selector-panel="help"] [data-question-key="product_type"] legend');
    if (productLegend) productLegend.textContent = 'What are you choosing?';

    var areaLegend = root.querySelector('[data-sa-selector-panel="help"] [data-question-key="area"] legend');
    if (areaLegend) areaLegend.textContent = schema.locationQuestion || 'Where will it be installed?';

    var useCaseLegend = root.querySelector('[data-sa-selector-panel="help"] [data-question-key="use_case"] legend');
    if (useCaseLegend) useCaseLegend.textContent = schema.useCaseQuestion || 'What needs attention most?';
  }

  function readableFilterLabels(filters) {
    return dedupeLabels(filters.map(function (filter) {
      return filter.label || filter.value || filter.filterLabel;
    })).filter(Boolean);
  }

  function selectedHelpLabelFilters(root) {
    var labels = [];
    Array.prototype.slice.call(root.querySelectorAll('[data-sa-selector-panel="help"] input:checked')).forEach(function (input) {
      if (isInHiddenContext(input) || input.value === '') return;
      var label = input.getAttribute('data-label');
      if (!label) {
        var strong = input.closest('label') ? input.closest('label').querySelector('strong') : null;
        label = strong ? strong.textContent : input.value;
      }
      labels.push({ name: 'sa_selector_label', value: label, label: label });
    });
    Array.prototype.slice.call(root.querySelectorAll('[data-sa-selector-panel="help"] select')).forEach(function (select) {
      if (!select.value || isInHiddenContext(select)) return;
      labels.push({ name: 'sa_selector_label', value: select.value, label: select.options[select.selectedIndex].textContent });
    });
    return labels;
  }

  function dedupeLabels(labels) {
    return labels.filter(function (label, index, source) {
      return label && source.indexOf(label) === index;
    });
  }

  function dispatchAnalytics(root, eventName, detail) {
    var payload = Object.assign({
      collection_handle: root.getAttribute('data-collection-handle') || '',
      selector_mode: root.getAttribute('data-active-mode') || root.getAttribute('data-default-mode') || ''
    }, detail || {});

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, payload));
    root.dispatchEvent(new CustomEvent('sa:collection-selector:' + eventName, { bubbles: true, detail: payload }));
  }

  function productSearchText(product) {
    if (product._search) return product._search;
    return normalise([
      product.title,
      product.type,
      product.vendor,
      product.canonicalRole,
      product.productRole,
      product.resolution,
      product.nightVision,
      product.cameraCount,
      product.cameraFormFactor,
      product.lensType,
      product.recorderChannels,
      product.poePorts,
      product.includedStorage,
      product.sku,
      product.matchText,
      productTags(product).join(' '),
      (product.badges || []).join(' ')
    ].join(' '));
  }

  function rawProductText(product) {
    return [
      product && product.title,
      product && product.type,
      product && product.vendor,
      product && product.canonicalRole,
      product && product.productRole,
      product && product.resolution,
      product && product.nightVision,
      product && product.cameraCount,
      product && product.cameraFormFactor,
      product && product.lensType,
      product && product.recorderChannels,
      product && product.poePorts,
      product && product.includedStorage,
      product && product.sku,
      product && product.matchText,
      productTags(product).join(' '),
      ((product && product.badges) || []).join(' ')
    ].join(' ');
  }

  function firstNumber(value) {
    if (value === null || typeof value === 'undefined' || value === '') return null;
    if (typeof value === 'number' && !Number.isNaN(value)) return value;
    var match = String(value).match(/\d+(?:\.\d+)?/);
    return match ? Number(match[0]) : null;
  }

  function parseMoney(value) {
    var amount = String(value || '').replace(/[^0-9.]+/g, '');
    return amount ? Number(amount) : null;
  }

  function parseCameraCount(product) {
    var explicit = firstNumber(product && product.cameraCount);
    if (explicit) return explicit;
    var text = productSearchText(product);
    var patterns = [
      /(?:^|\s)(\d{1,2})\s*x\s+(?:[a-z0-9]+\s+){0,10}cameras?\b/,
      /(?:^|\s)(\d{1,2})\s+(?:[a-z0-9]+\s+){0,10}cameras?\b/,
      /(?:^|\s)(\d{1,2})\s*cameras?\b/
    ];
    for (var i = 0; i < patterns.length; i += 1) {
      var match = text.match(patterns[i]);
      if (match) return Number(match[1]);
    }
    if (/\b(?:kit|package|bundle|nvr|dvr|recorder)\b/.test(text)) {
      var kitCount = text.match(/(?:^|\s)(\d{1,2})\s*x\s+(?:[a-z0-9.+/-]+\s+){0,12}(?:tioc|colorvu|colourvu|acusense|wizsense|darkfighter|turrets?|eyeballs?|bullets?|domes?|ptz|cameras?)\b/);
      if (kitCount) return Number(kitCount[1]);
    }
    return null;
  }

  function parseRecorderChannels(product) {
    var explicit = firstNumber(product && product.recorderChannels);
    if (explicit) return explicit;
    var text = rawProductText(product);
    var match = text.match(/(?:^|[^0-9])(\d{1,2})\s*(?:ch|channel|channels)\s*(?:nvr|recorder)?\b/i);
    return match ? Number(match[1]) : null;
  }

  function parseResolutionMp(product) {
    var explicit = firstNumber(product && product.resolution);
    if (explicit) return explicit;
    var text = rawProductText(product);
    var mp = text.match(/(?:^|[^0-9])(\d{1,2})\s*mp\b/i);
    if (mp) return Number(mp[1]);
    if (/\b4k\b/i.test(text)) return 8;
    return null;
  }

  function inferCameraShape(product) {
    var explicit = normalise(product && product.cameraFormFactor);
    var text = productSearchText(product);
    if (explicit.indexOf('ptz') !== -1 || text.indexOf('ptz') !== -1) return 'ptz';
    if (explicit.indexOf('fisheye') !== -1 || text.indexOf('fisheye') !== -1 || text.indexOf('360') !== -1 || text.indexOf('panoramic') !== -1) return 'fisheye';
    if (explicit.indexOf('bullet') !== -1 || text.indexOf('bullet') !== -1) return 'bullet';
    if (explicit.indexOf('dome') !== -1 || text.indexOf('dome') !== -1) return 'dome';
    if (explicit.indexOf('turret') !== -1 || explicit.indexOf('eyeball') !== -1 || text.indexOf('turret') !== -1 || text.indexOf('eyeball') !== -1) return 'turret';
    return 'unknown';
  }

  function hasTerm(text, term) {
    var value = normalise(term);
    if (!value) return false;
    return text.indexOf(value) !== -1;
  }

  function hasAnyTerm(text, terms) {
    return terms.some(function (term) {
      return hasTerm(text, term);
    });
  }

  function canonicalRoleSlug(value) {
    var role = normalise(value || '').replace(/\s+/g, '-');
    if (role === 'cctv-kit' || role === 'complete-kit' || role === 'camera-kit' || role === 'security-kit') return 'cctv-kit';
    if (role === 'camera') return 'fixed-camera';
    if (role === 'accessory' || role === 'accessory-component' || role === 'supporting-product' || role === 'other-supporting') return 'supporting-product';
    if (role === 'network-switch') return 'networking-peripheral';
    if (role === 'nvr' || role === 'dvr') return 'recorder';
    return role;
  }

  function hasAccessoryIntent(product) {
    var text = productSearchText(product);
    var strongAccessoryTerms = [
      'wall mount',
      'pole mount',
      'ceiling mount',
      'parapet mount',
      'bracket',
      'mount bracket',
      'mounting bracket',
      'bracket to suit',
      'mount to suit',
      'to suit',
      'pendant kit',
      'pendant mount',
      'junction box',
      'back box',
      'base plate',
      'adaptor',
      'adapter',
      'housing',
      'enclosure',
      'illuminator',
      'power supply',
      'poe switch',
      'injector',
      'hard drive',
      'sd card',
      'microsd',
      'memory card',
      'display monitor',
      'lcd monitor',
      'led monitor',
      'test monitor',
      'rack mount',
      'cable',
      'conduit'
    ];
    var hddOnlyAccessory = /\bhdd\b/.test(text) && !hasAnyTerm(text, [
      'kit',
      'package',
      'bundle',
      'camera',
      'cameras',
      'turret',
      'bullet',
      'dome',
      'eyeball',
      'ptz',
      'nvr',
      'dvr',
      'recorder',
      'tioc',
      'colorvu',
      'colourvu',
      'acusense',
      'wizsense'
    ]);
    return hasAnyTerm(' ' + text + ' ', strongAccessoryTerms) || /\bmonitor\b/.test(text) || hddOnlyAccessory;
  }

  function hasKitMerchandisingEvidence(product) {
    var text = productSearchText(product);
    return hasAnyTerm(text, [
      'cctv kit',
      'security kit',
      'camera kit',
      'cctv camera kit',
      'package',
      'bundle',
      'channel nvr',
      'ch nvr'
    ]);
  }

  function hasRecorderEvidence(product, recorderChannels) {
    var text = productSearchText(product);
    return Boolean(recorderChannels) || hasAnyTerm(text, ['nvr', 'dvr', 'recorder', 'channel nvr', 'ch nvr']);
  }

  function hasCameraEvidence(product, cameraCount) {
    var text = productSearchText(product);
    return Boolean(cameraCount) || hasAnyTerm(text, ['camera', 'cameras', 'bullet', 'dome', 'turret', 'eyeball', 'ptz', 'fisheye']);
  }

  function inferProductRole(product) {
    var canonicalRole = canonicalRoleSlug(product && (product.canonicalRole || product.productRole));
    var text = productSearchText(product);
    var cameraCount = parseCameraCount(product);
    var recorderChannels = parseRecorderChannels(product);
    if (hasAccessoryIntent(product)) return 'supporting-product';
    if (canonicalRole) return canonicalRole;
    if (hasAnyTerm(text, ['intercom', 'door station', 'doorbell'])) return 'intercom';
    if (hasAnyTerm(text, ['alarm', 'siren', 'sensor', 'detector']) && !hasAnyTerm(text, ['camera', 'cctv'])) return 'alarm';
    if (text.indexOf('nvr') !== -1 || text.indexOf('recorder') !== -1) {
      if (text.indexOf('kit') === -1 && text.indexOf('package') === -1 && text.indexOf('bundle') === -1) return 'recorder';
    }
    if (hasKitMerchandisingEvidence(product) && hasCameraEvidence(product, cameraCount) && hasRecorderEvidence(product, recorderChannels)) return 'cctv-kit';
    if (text.indexOf('ptz') !== -1) return 'ptz-camera';
    if (text.indexOf('fisheye') !== -1 || text.indexOf('360') !== -1 || text.indexOf('panoramic') !== -1) return 'wide-area-camera';
    if (text.indexOf('camera') !== -1 || text.indexOf('bullet') !== -1 || text.indexOf('dome') !== -1 || text.indexOf('turret') !== -1 || text.indexOf('eyeball') !== -1) return 'fixed-camera';
    return 'unknown';
  }

  function inferEnvironment(product) {
    var text = productSearchText(product);
    var outdoor = text.indexOf('outdoor') !== -1 ||
      text.indexOf('ip66') !== -1 ||
      text.indexOf('ip67') !== -1 ||
      text.indexOf('ip68') !== -1 ||
      text.indexOf('weather') !== -1 ||
      text.indexOf('bullet') !== -1 ||
      text.indexOf('driveway') !== -1 ||
      text.indexOf('perimeter') !== -1 ||
      text.indexOf('boundary') !== -1 ||
      text.indexOf('car park') !== -1 ||
      text.indexOf('garage') !== -1 ||
      text.indexOf('loading dock') !== -1 ||
      text.indexOf('loading area') !== -1 ||
      text.indexOf('service yard') !== -1 ||
      text.indexOf('farm') !== -1 ||
      text.indexOf('rural') !== -1 ||
      text.indexOf('gate') !== -1 ||
      text.indexOf('front door') !== -1 ||
      text.indexOf('home exterior') !== -1;
    var indoor = text.indexOf('indoor') !== -1 ||
      text.indexOf('dome') !== -1 ||
      text.indexOf('fisheye') !== -1 ||
      text.indexOf('panoramic') !== -1 ||
      text.indexOf('hallway') !== -1 ||
      text.indexOf('corridor') !== -1 ||
      text.indexOf('reception') !== -1 ||
      text.indexOf('stockroom') !== -1 ||
      text.indexOf('back office') !== -1 ||
      text.indexOf('shop floor') !== -1 ||
      text.indexOf('retail shop') !== -1 ||
      text.indexOf('office') !== -1 ||
      text.indexOf('healthcare') !== -1 ||
      text.indexOf('clinic') !== -1;
    if (outdoor && indoor) return 'mixed';
    if (outdoor) return 'outdoors';
    if (indoor) return 'indoors';
    return 'unknown';
  }

  function inferCapabilities(product) {
    var text = productSearchText(product);
    return {
      fullColourNight: text.indexOf('colorvu') !== -1 || text.indexOf('colourvu') !== -1 || text.indexOf('full colour') !== -1 || text.indexOf('full color') !== -1 || text.indexOf('tioc') !== -1 || text.indexOf('dual light') !== -1,
      aiDetection: text.indexOf('acusense') !== -1 || text.indexOf('wizsense') !== -1 || text.indexOf('human') !== -1 || text.indexOf('vehicle') !== -1 || text.indexOf('smd') !== -1 || text.indexOf('ai') !== -1,
      activeDeterrence: text.indexOf('active deterrence') !== -1 || text.indexOf('tioc') !== -1 || text.indexOf('strobe') !== -1 || text.indexOf('siren') !== -1 || text.indexOf('liveguard') !== -1,
      audio: text.indexOf('microphone') !== -1 || text.indexOf('built in mic') !== -1 || text.indexOf('built-in mic') !== -1 || text.indexOf('two way') !== -1 || text.indexOf('two-way') !== -1 || text.indexOf('audio') !== -1,
      opticalZoom: text.indexOf('optical zoom') !== -1 || text.indexOf('motorised') !== -1 || text.indexOf('motorized') !== -1 || text.indexOf('varifocal') !== -1
    };
  }

  function productFacts(product) {
    if (!product) return {};
    if (product._selectorFacts) return product._selectorFacts;
    if (product.selectorHardFacts) {
      var hardFacts = product.selectorHardFacts || {};
      var matrixCameraCount = firstNumber(hardFacts.cameraCount);
      var matrixRecorderChannels = firstNumber(hardFacts.recorderChannels);
      var matrixResolution = firstNumber(hardFacts.resolutionMp);
      var inferredCameraCount = parseCameraCount(product);
      var inferredRecorderChannels = parseRecorderChannels(product);
      var evidenceCameraCount = inferredCameraCount !== null ? inferredCameraCount : matrixCameraCount;
      var evidenceRecorderChannels = inferredRecorderChannels !== null ? inferredRecorderChannels : matrixRecorderChannels;
      var strongCompleteKitEvidence = hasKitMerchandisingEvidence(product) &&
        hasCameraEvidence(product, evidenceCameraCount) &&
        hasRecorderEvidence(product, evidenceRecorderChannels);
      var hardFactsAccessoryOnly = hardFacts.isAccessory === true && !strongCompleteKitEvidence;
      var matrixRole = canonicalRoleSlug(hardFacts.productRole || '');
      if ((matrixRole === 'supporting-product' || matrixRole === 'unknown' || !matrixRole) && strongCompleteKitEvidence) {
        matrixRole = 'cctv-kit';
      }
      if (matrixCameraCount === null && strongCompleteKitEvidence) matrixCameraCount = evidenceCameraCount;
      if (matrixRecorderChannels === null && strongCompleteKitEvidence) matrixRecorderChannels = evidenceRecorderChannels;
      if (matrixResolution === null) matrixResolution = parseResolutionMp(product);
      var matrixFacts = {
        brand: hardFacts.brand || detectedProductBrandKey(product) || 'unknown',
        productRole: matrixRole,
        cameraCount: matrixCameraCount,
        recorderChannels: matrixRecorderChannels,
        poePorts: firstNumber(hardFacts.poePorts),
        resolutionMp: matrixResolution,
        cameraShape: hardFacts.cameraShape && hardFacts.cameraShape !== 'unknown' ? hardFacts.cameraShape : inferCameraShape(product),
        environment: hardFacts.environment && hardFacts.environment !== 'unknown' ? hardFacts.environment : inferEnvironment(product),
        expansionHeadroom: matrixCameraCount !== null && matrixRecorderChannels !== null ? matrixRecorderChannels - matrixCameraCount : null,
        price: parseMoney(product.price),
        compareAtPrice: parseMoney(product.compareAtPrice),
        capabilities: product.selectorCapabilities || inferCapabilities(product)
      };
      matrixFacts.isAccessory = hardFactsAccessoryOnly || (matrixFacts.productRole !== 'cctv-kit' && hasAccessoryIntent(product)) || [
        'supporting-product',
        'accessory-component',
        'storage',
        'networking-peripheral',
        'software-licence',
        'other-supporting',
        'excluded',
        'review',
        'recorder',
        'nvr'
      ].indexOf(matrixFacts.productRole) !== -1;
      matrixFacts.completeKitVerified = hardFacts.completeKitVerified === true || (matrixFacts.productRole === 'cctv-kit' &&
        !matrixFacts.isAccessory &&
        matrixFacts.cameraCount !== null &&
        matrixFacts.recorderChannels !== null &&
        matrixFacts.cameraCount > 0 &&
        matrixFacts.recorderChannels >= matrixFacts.cameraCount);
      product._selectorFacts = matrixFacts;
      return matrixFacts;
    }
    var cameraCount = parseCameraCount(product);
    var recorderChannels = parseRecorderChannels(product);
    var facts = {
      brand: detectedProductBrandKey(product) || 'unknown',
      productRole: inferProductRole(product),
      cameraCount: cameraCount,
      recorderChannels: recorderChannels,
      poePorts: firstNumber(product.poePorts),
      resolutionMp: parseResolutionMp(product),
      cameraShape: inferCameraShape(product),
      environment: inferEnvironment(product),
      expansionHeadroom: cameraCount !== null && recorderChannels !== null ? recorderChannels - cameraCount : null,
      price: parseMoney(product.price),
      compareAtPrice: parseMoney(product.compareAtPrice),
      capabilities: inferCapabilities(product)
    };
    facts.isAccessory = hasAccessoryIntent(product) || [
      'supporting-product',
      'accessory-component',
      'storage',
      'networking-peripheral',
      'software-licence',
      'other-supporting',
      'excluded',
      'review'
    ].indexOf(facts.productRole) !== -1;
    facts.completeKitVerified = facts.productRole === 'cctv-kit' &&
      !facts.isAccessory &&
      facts.cameraCount !== null &&
      facts.recorderChannels !== null &&
      facts.cameraCount > 0 &&
      facts.recorderChannels >= facts.cameraCount;
    product._selectorFacts = facts;
    return facts;
  }

  function selectedCameraCount(answers) {
    var value = (answers.camera_count || [])[0];
    if (!value) return null;
    return value === '10' ? 10 : Number(value);
  }

  function recorderRightSizeScore(product, answers) {
    var requested = selectedCameraCount(answers);
    var facts = productFacts(product);
    var cameraCount = facts.cameraCount;
    var channels = facts.recorderChannels;
    if ((answers.product_type || [])[0] !== 'kit') return { score: 0, label: '', reason: '' };
    if (!cameraCount || !channels || !requested) return { score: 0, label: 'unknown', reason: 'Missing camera count or recorder channel facts' };
    if (channels < cameraCount) return { score: -100, label: 'under-capacity', reason: 'Recorder has fewer channels than included cameras' };

    var headroom = channels - cameraCount;
    if (requested === 4) {
      if (cameraCount !== 4) return { score: -100, label: 'wrong-camera-count', reason: 'Included camera count does not match the selected quantity' };
      if (channels === 4) return { score: 12, label: 'right-sized', reason: '4 cameras with 4CH recorder' };
      if (channels === 8) return { score: 9, label: 'expansion-friendly', reason: '4 cameras with useful 8CH expansion headroom' };
      return { score: 4, label: 'oversized', reason: '4 cameras with large recorder headroom' };
    }
    if (requested === 6) {
      if (cameraCount !== 6) return { score: -100, label: 'wrong-camera-count', reason: 'Included camera count does not match the selected quantity' };
      if (channels === 8) return { score: 12, label: 'right-sized', reason: '6 cameras with 8CH recorder' };
      if (channels === 16) return { score: 7, label: 'expansion-friendly', reason: '6 cameras with 16CH expansion capacity' };
      return { score: Math.max(2, 8 - Math.abs(headroom)), label: 'acceptable', reason: 'Recorder capacity supports included cameras' };
    }
    if (requested === 8) {
      if (cameraCount !== 8) return { score: -100, label: 'wrong-camera-count', reason: 'Included camera count does not match the selected quantity' };
      if (channels === 8) return { score: 12, label: 'right-sized', reason: '8 cameras with 8CH recorder' };
      if (channels === 16) return { score: 8, label: 'expansion-friendly', reason: '8 cameras with 16CH expansion capacity' };
      return { score: Math.max(2, 8 - Math.abs(headroom)), label: 'acceptable', reason: 'Recorder capacity supports included cameras' };
    }
    if (requested >= 10) {
      if (cameraCount < 10) return { score: -100, label: 'wrong-camera-count', reason: 'Included camera count is below the selected 10+ range' };
      if (channels >= cameraCount) return { score: channels === 16 ? 12 : 8, label: 'right-sized', reason: 'Recorder capacity supports the selected 10+ camera package' };
    }
    return { score: 0, label: 'unknown', reason: 'Insufficient recorder right-sizing evidence' };
  }

  function productCommonNeedText(product) {
    if (product._commonNeedSearch) return product._commonNeedSearch;
    product._commonNeedSearch = normalise([
      product.commonNeedText,
      product.commonNeed,
      product.commonNeeds,
      product.industryCommonNeed,
      product.industryCommonNeeds,
      (product.commonNeedSlugs || []).join(' ')
    ].join(' ')).replace(/\s+/g, '-');
    return product._commonNeedSearch;
  }

  function productHasCommonNeedMapping(product, slug) {
    var needSlug = canonicalCommonNeedSlug(slug);
    var mappedText = productCommonNeedText(product);
    var needText = normalise(needSlug).replace(/\s+/g, ' ');
    var slugText = normalise(String(needSlug || '').replace(/-/g, ' '));
    return Boolean(
      needSlug &&
      mappedText &&
      (
        mappedText.indexOf(needText) !== -1 ||
        mappedText.indexOf(slugText) !== -1 ||
        mappedText.replace(/\s+/g, '-').indexOf(needSlug) !== -1
      )
    );
  }

  function compactBadge(label) {
    var text = String(label || '').trim();
    var lower = text.toLowerCase();
    if (lower.indexOf('8mp 4k') !== -1) return '8MP 4K';
    if (lower.indexOf('6mp resolution') !== -1) return '6MP';
    if (lower.indexOf('4mp resolution') !== -1) return '4MP';
    if (lower.indexOf('12mp') !== -1) return '12MP';
    if (lower.indexOf('built-in microphone') !== -1) return 'Built-in mic';
    if (lower.indexOf('full-colour') !== -1 || lower.indexOf('full colour') !== -1 || lower.indexOf('colorvu') !== -1) return 'Full-colour';
    if (lower.indexOf('active deterrence') !== -1 || lower.indexOf('tioc') !== -1 || lower.indexOf('liveguard') !== -1) return 'Deterrence';
    if (lower.indexOf('human') !== -1 || lower.indexOf('vehicle') !== -1 || lower.indexOf('acusense') !== -1 || lower.indexOf('wizsense') !== -1) return 'AI detection';
    if (lower.indexOf('poe') !== -1) return 'PoE';
    return text.length > 24 ? text.slice(0, 21) + '...' : text;
  }

  function isCustomerFacingFeatureBadge(label) {
    var text = String(label || '').trim();
    var lower = text.toLowerCase();
    return Boolean(text) &&
      lower.indexOf('sa_') === -1 &&
      lower.indexOf('class=') === -1 &&
      lower.indexOf('style=') === -1 &&
      lower.indexOf('product_description_dot') === -1 &&
      lower.indexOf('<') === -1 &&
      lower.indexOf('>') === -1 &&
      lower.indexOf('&lt;') === -1 &&
      lower.indexOf('&gt;') === -1 &&
      lower.indexOf('script') === -1 &&
      lower.indexOf('onclick') === -1 &&
      lower.indexOf('onerror') === -1 &&
      lower.indexOf('onload') === -1;
  }

  function getSectionId() {
    var productGrid = document.getElementById('product-grid');
    return productGrid ? productGrid.dataset.id : '';
  }

  function getCurrentSort() {
    var params = new URLSearchParams(window.location.search);
    return params.get('sort_by') || '';
  }

  function isInHiddenContext(input) {
    if (!input) return true;
    if (input.hidden) return true;
    if (input.closest('[hidden]')) return true;
    var group = input.closest('[data-sa-filter-group], [data-sa-product-type-group], [data-sa-native-quick-filter], [data-sa-help-context-group]');
    if (group && group.hidden) return true;
    if (typeof window !== 'undefined' && typeof window.getComputedStyle === 'function') {
      var element = input;
      while (element && element.nodeType === 1) {
        var style = window.getComputedStyle(element);
        if (style.display === 'none' || style.visibility === 'hidden') return true;
        element = element.parentElement;
      }
    }
    return false;
  }

  function filterFromInput(input) {
    return {
      name: input.name,
      value: input.value,
      label: input.getAttribute('data-label') || input.value,
      filterLabel: input.getAttribute('data-filter-label') || '',
      filterType: input.getAttribute('data-filter-type') || '',
      count: Number(input.getAttribute('data-count') || 0),
      urlToAdd: input.getAttribute('data-url-to-add') || '',
      urlToRemove: input.getAttribute('data-url-to-remove') || ''
    };
  }

  function selectorMode(root) {
    return root.getAttribute('data-selector-mode') || 'none';
  }

  function forcedProductType(root) {
    var mode = selectorMode(root);
    if (mode === 'cctv_camera') return 'camera';
    if (mode === 'cctv_kit') return 'kit';
    return '';
  }

  function isCompactPresentation(root) {
    return root.getAttribute('data-selector-presentation') === 'compact';
  }

  function setCompactOpen(root, open) {
    if (!isCompactPresentation(root)) return;
    var isOpen = Boolean(open);
    root.classList.toggle('is-compact-open', isOpen);
    root.setAttribute('data-compact-open', isOpen ? 'true' : 'false');
    var activeMode = root.getAttribute('data-active-mode') || 'help';
    Array.prototype.slice.call(root.querySelectorAll('[data-sa-compact-open]')).forEach(function (button) {
      var mode = button.getAttribute('data-sa-compact-open') || 'help';
      button.setAttribute('aria-expanded', isOpen && mode === activeMode ? 'true' : 'false');
      if (root.id) button.setAttribute('aria-controls', root.id);
    });
    Array.prototype.slice.call(root.querySelectorAll('[data-sa-compact-close]')).forEach(function (button) {
      button.hidden = !isOpen;
      button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (root.id) button.setAttribute('aria-controls', root.id);
    });
  }

  function knownCollectionContext(root) {
    return {
      brand: root.getAttribute('data-known-brand') || '',
      brandPreference: activeBrandPreference(root),
      cameraStyle: root.getAttribute('data-known-camera-style') || '',
      installation: root.getAttribute('data-known-installation') || root.getAttribute('data-inferred-installation') || '',
      resolution: root.getAttribute('data-known-resolution') || '',
      technology: root.getAttribute('data-known-technology') || ''
    };
  }

  function knownTechnologyTerms(value) {
    var key = normalise(value);
    if (!key) return [];
    var map = {
      colorvu: ['colorvu', 'colourvu', 'full colour', 'full color'],
      colourvu: ['colorvu', 'colourvu', 'full colour', 'full color'],
      tioc: ['tioc', 'three in one', 'three-in-one', 'full colour', 'full color', 'active deterrence'],
      wizsense: ['wizsense', 'smd'],
      acusense: ['acusense'],
      darkfighter: ['darkfighter'],
      starlight: ['starlight'],
      thermal: ['thermal'],
      tandemvu: ['tandemvu']
    };
    return map[key] || [key];
  }

  function optionTextForTechnology(input, group) {
    return normalise([
      input.getAttribute('data-label') || '',
      input.value || '',
      input.getAttribute('data-filter-label') || '',
      input.getAttribute('data-filter-type') || '',
      group ? group.getAttribute('data-filter-label') || '' : ''
    ].join(' '));
  }

  function selectableFilterInputs(group) {
    return Array.prototype.slice.call(group.querySelectorAll('input[type="checkbox"]')).filter(function (input) {
      return input.checked || Number(input.getAttribute('data-count') || 0) > 0;
    });
  }

  function filterGroupRepeatsKnownTechnology(group, knownTechnology) {
    var terms = knownTechnologyTerms(knownTechnology);
    if (!terms.length) return false;
    var inputs = selectableFilterInputs(group);
    if (!inputs.length) return false;
    return inputs.every(function (input) {
      var text = optionTextForTechnology(input, group);
      return terms.some(function (term) { return text.indexOf(normalise(term)) !== -1; });
    });
  }

  function currentUniverseProducts(root) {
    return (root._selectorProducts || []).filter(function (product) {
      return product.source === 'current' && product.available !== false;
    });
  }

  function distinctKnownFacts(root, getter) {
    var values = [];
    currentUniverseProducts(root).forEach(function (product) {
      var value = getter(productFacts(product), product);
      if (value === null || typeof value === 'undefined' || value === '' || value === 'unknown') return;
      value = String(value);
      if (values.indexOf(value) === -1) values.push(value);
    });
    return values;
  }

  function isSingleKnownUniverseValue(root, getter) {
    return distinctKnownFacts(root, getter).length === 1;
  }

  function inferredKnownInstallation(root) {
    var explicit = root.getAttribute('data-known-installation') || '';
    if (explicit === 'indoors' || explicit === 'outdoors') return explicit;
    var environments = distinctKnownFacts(root, function (facts) { return facts.environment; }).filter(function (value) {
      return value === 'indoors' || value === 'outdoors';
    });
    return environments.length === 1 ? environments[0] : '';
  }

  function syncInferredKnownInstallation(root) {
    var explicit = root.getAttribute('data-known-installation') || '';
    var inferred = inferredKnownInstallation(root);
    if (!explicit && inferred) {
      root.setAttribute('data-inferred-installation', inferred);
    } else {
      root.removeAttribute('data-inferred-installation');
    }
    return explicit || inferred;
  }

  function clearSelectorQuestionValue(root, key) {
    Array.prototype.slice.call(root.querySelectorAll('[data-question-key="' + key + '"]')).forEach(function (group) {
      Array.prototype.slice.call(group.querySelectorAll('input')).forEach(function (input) {
        if (input.type === 'checkbox') {
          input.checked = false;
          return;
        }
        if (input.type === 'radio') {
          input.checked = input.value === '';
        }
      });
      Array.prototype.slice.call(group.querySelectorAll('select')).forEach(function (select) {
        select.value = '';
      });
    });
    if (root._selectorExternalAnswers) delete root._selectorExternalAnswers[key];
  }

  function hideSelectorQuestion(root, key, hidden, clearValue) {
    Array.prototype.slice.call(root.querySelectorAll('[data-question-key="' + key + '"]')).forEach(function (group) {
      group.hidden = Boolean(hidden);
      if (hidden) group.removeAttribute('data-required');
    });
    if (hidden && clearValue) clearSelectorQuestionValue(root, key);
  }

  function setCheckedValue(group, value) {
    if (!group || !value) return;
    var input = findInputByValue(group, value);
    if (input) input.checked = true;
  }

  function findInputByValue(scope, value) {
    if (!scope || !value) return null;
    var inputs = Array.prototype.slice.call(scope.querySelectorAll('input'));
    return inputs.find(function (input) {
      return input.value === value;
    }) || null;
  }

  function setHelpRadioValue(root, key, value) {
    var group = root.querySelector('[data-sa-selector-panel="help"] [data-question-key="' + key + '"]');
    var input = findInputByValue(group, value);
    if (!input || input.disabled || input.closest('[hidden]')) return false;
    if (input.type === 'radio') {
      Array.prototype.slice.call(group.querySelectorAll('input[type="radio"]')).forEach(function (radio) {
        if (radio.name === input.name) radio.checked = false;
      });
    }
    input.checked = true;
    return true;
  }

  function setHelpSelectValue(root, key, value) {
    var group = root.querySelector('[data-sa-selector-panel="help"] [data-question-key="' + key + '"]');
    var select = group ? group.querySelector('select') : null;
    if (!select || !value || select.closest('[hidden]')) return false;
    var option = Array.prototype.slice.call(select.options).find(function (item) {
      return item.value === value;
    });
    if (!option) return false;
    select.value = value;
    return true;
  }

  function setFirstSupportedHelpValue(root, key, values) {
    return (values || []).some(function (value) {
      return setHelpRadioValue(root, key, value) || setHelpSelectValue(root, key, value);
    });
  }

  function commonNeedSlugFromUrl() {
    var params = new URLSearchParams(window.location.search);
    return canonicalCommonNeedSlug(params.get('sa_need') || '');
  }

  function humaniseSlug(slug) {
    return String(slug || '').split('-').filter(Boolean).map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' ');
  }

  function answersForCommonNeedSlug(slug) {
    slug = canonicalCommonNeedSlug(slug);
    var preset = COMMON_NEED_PRESETS[slug];
    if (!preset) return null;
    var answers = {};
    if (preset.productType) answers.product_type = [preset.productType];
    if (preset.area) answers.area = [preset.area];
    if (preset.cameraCount) answers.camera_count = [preset.cameraCount];
    if (preset.useCases && preset.useCases.length) answers.use_case = [preset.useCases[0]];
    Object.keys(preset.quickFilters || {}).forEach(function (key) {
      if (preset.quickFilters[key]) answers[key] = [preset.quickFilters[key]];
    });
    return answers;
  }

  function currentPrimaryProducts(products, answers) {
    return (products || []).filter(function (product) {
      return product.source === 'current' && isEligibleForPrimaryRecommendation(product, answers || {});
    });
  }

  function explicitCommonNeedProducts(products, slug, answers) {
    return currentPrimaryProducts(products, answers).filter(function (product) {
      return productHasCommonNeedMapping(product, slug);
    }).sort(function (a, b) {
      return scoreProduct(b, answers || {}) - scoreProduct(a, answers || {});
    });
  }

  function selectorTaxonomyProducts(products, answers) {
    if (!answers) return [];
    var attempts = [
      { minimumScore: 8, requireCoreIntent: true },
      { minimumScore: 8, requireCoreIntent: false },
      { minimumScore: 6, requireCoreIntent: true },
      { minimumScore: 6, requireCoreIntent: false }
    ];
    var matches = [];
    attempts.some(function (settings) {
      matches = rankedProducts(products || [], answers, 'current', settings);
      return matches.length > 0;
    });
    return matches;
  }

  function recommendProductsForCommonNeed(products, slug, options) {
    var settings = Object.assign({ max: 8 }, options || {});
    var canonicalSlug = canonicalCommonNeedSlug(slug);
    var preset = COMMON_NEED_PRESETS[canonicalSlug] || null;
    var answers = answersForCommonNeedSlug(canonicalSlug) || {};
    if (settings.brand) answers.brand_preference = [normaliseBrandKey(settings.brand)];
    var explicitMatches = explicitCommonNeedProducts(products || [], canonicalSlug, answers).filter(function (product) {
      return !answers.brand_preference || !answers.brand_preference[0] || detectedProductBrandKey(product) === answers.brand_preference[0];
    });
    if (explicitMatches.length) {
      return {
        slug: canonicalSlug,
        label: preset ? preset.label : humaniseSlug(canonicalSlug),
        mapped: Boolean(preset),
        matchType: 'manual',
        total: explicitMatches.length,
        products: explicitMatches.slice(0, settings.max)
      };
    }

    if (!preset) {
      return {
        slug: canonicalSlug,
        label: humaniseSlug(canonicalSlug),
        mapped: false,
        matchType: 'none',
        total: 0,
        products: []
      };
    }

    var taxonomyMatches = selectorTaxonomyProducts(products || [], answers);
    return {
      slug: canonicalSlug,
      label: preset.label || humaniseSlug(canonicalSlug),
      mapped: true,
      matchType: taxonomyMatches.length ? 'taxonomy' : 'none',
      total: taxonomyMatches.length,
      products: taxonomyMatches.slice(0, settings.max)
    };
  }

  function clearCommonNeedNotice(root) {
    var notice = root.querySelector('[data-sa-common-need-state]');
    if (notice) notice.remove();
    root.removeAttribute('data-common-need');
  }

  function renderCommonNeedNotice(root, slug, preset, mapped) {
    clearCommonNeedNotice(root);
    var questions = root.querySelector('[data-sa-selector-panel="help"] [data-sa-help-questions]');
    if (!questions) return;
    var notice = document.createElement('div');
    notice.className = 'sa-collection-selector__need-state';
    notice.setAttribute('data-sa-common-need-state', '');
    notice.innerHTML = '<span>Starting with:</span><strong></strong><small></small><button type="button" data-sa-common-need-clear>Clear</button>';
    notice.querySelector('strong').textContent = preset.label || humaniseSlug(slug);
    notice.querySelector('small').textContent = mapped ? (preset.notes || 'Choose the remaining details before viewing recommendations.') : 'This need keeps you in the current destination. Choose the structured questions below to refine products.';
    questions.insertBefore(notice, questions.firstChild);
    root.setAttribute('data-common-need', slug);
  }

  function applyCommonNeedSlugToRoot(root, products, slug, options) {
    slug = canonicalCommonNeedSlug(slug);
    if (!root || !slug) return false;
    var preset = COMMON_NEED_PRESETS[slug] || { label: humaniseSlug(slug) };
    var mapped = Boolean(COMMON_NEED_PRESETS[slug]);
    var settings = Object.assign({ submit: false, scroll: false, open: false, focus: false }, options || {});
    if (Object.prototype.hasOwnProperty.call(settings, 'brand')) {
      setBrandPreference(root, settings.brand);
    }

    setMode(root, 'help', products);
    setSubmitted(root, false);

    if (mapped) {
      if (preset.productType) {
        setHelpRadioValue(root, 'product_type', preset.productType);
        syncContextualControls(root, 'help', true);
      }
      if (preset.area) {
        setHelpRadioValue(root, 'area', preset.area);
        syncHelpUseCaseContext(root, true);
      }
      if (preset.cameraCount) {
        setHelpSelectValue(root, 'camera_count', preset.cameraCount);
      }
      setFirstSupportedHelpValue(root, 'use_case', preset.useCases || []);
      Object.keys(preset.quickFilters || {}).forEach(function (key) {
        setHelpRadioValue(root, key, preset.quickFilters[key]);
      });
    }

    syncContextualControls(root, 'help', false);
    enforceLimits(root);
    updateQuickFilterSummaries(root);
    renderCommonNeedNotice(root, slug, preset, mapped);
    if (settings.submit) setSubmitted(root, true);
    updateHelp(root, products);
    if (settings.open) {
      setCompactOpen(root, true);
      if (settings.focus) {
        window.setTimeout(function () {
          var focusTarget = root.querySelector('[data-sa-selector-panel="help"] input:not([disabled]), [data-sa-selector-panel="help"] select:not([disabled]), [data-sa-selector-panel="help"] button:not([disabled])');
          if (focusTarget && typeof focusTarget.focus === 'function') focusTarget.focus({ preventScroll: true });
        }, 0);
      }
    }
    if (settings.scroll) {
      window.setTimeout(function () {
        root.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      }, 0);
    }
    return true;
  }

  function applyCommonNeedFromUrl(root, products) {
    var slug = commonNeedSlugFromUrl();
    if (!slug) {
      clearCommonNeedNotice(root);
      return false;
    }
    var collectionHandle = root ? root.getAttribute('data-collection-handle') || '' : '';
    var presetCollections = window.SA_COLLECTION_NEED_PRESETS && window.SA_COLLECTION_NEED_PRESETS.collections;
    var presetCollection = collectionHandle && presetCollections ? presetCollections[collectionHandle] : null;
    if (presetCollection) {
      clearCommonNeedNotice(root);
      return false;
    }
    return applyCommonNeedSlugToRoot(root, products, slug);
  }

  function clearHelpSelections(root) {
    var panel = root.querySelector('[data-sa-selector-panel="help"]');
    if (!panel) return;
    clearCommonNeedNotice(root);
    root._selectorExternalAnswers = {};
    root.removeAttribute('data-sa-prefill-priority');
    root.removeAttribute('data-sa-prefill-night');
    Array.prototype.slice.call(panel.querySelectorAll('input')).forEach(function (input) {
      if (input.type === 'checkbox') {
        input.checked = false;
        return;
      }
      if (input.type === 'radio') {
        input.checked = input.value === '';
      }
    });
    Array.prototype.slice.call(panel.querySelectorAll('select')).forEach(function (select) {
      select.value = '';
    });
  }

  function setNativeQuickFilterByLabel(root, filterLabel, preferredTerms) {
    var panel = root.querySelector('[data-sa-selector-panel="help"]');
    if (!panel || !filterLabel) return false;
    var wantedLabel = normalise(filterLabel);
    var groups = Array.prototype.slice.call(panel.querySelectorAll('[data-sa-native-quick-filter]')).filter(function (group) {
      return normalise(group.getAttribute('data-filter-label') || '') === wantedLabel && !group.hidden && !group.closest('[hidden]');
    });
    var terms = (preferredTerms || []).map(normalise);
    return groups.some(function (group) {
      var inputs = Array.prototype.slice.call(group.querySelectorAll('input[type="checkbox"]')).filter(function (input) {
        return !input.disabled && !input.closest('[hidden]');
      });
      if (!inputs.length) return false;
      var preferred = inputs.find(function (input) {
        var label = normalise(input.getAttribute('data-label') || input.value || '');
        return terms.some(function (term) { return term && label.indexOf(term) !== -1; });
      });
      (preferred || inputs[0]).checked = true;
      return true;
    });
  }

  function openCompactSelector(root, mode, products, options) {
    var settings = Object.assign({ scroll: false, focus: false }, options || {});
    var nextMode = mode === 'know' ? 'know' : 'help';
    setCompactOpen(root, true);
    setMode(root, nextMode, products || root._selectorProducts || []);
    setCompactOpen(root, true);
    if (settings.focus) {
      window.setTimeout(function () {
        var activePanel = root.querySelector('[data-sa-selector-panel="' + nextMode + '"]');
        var focusTarget = activePanel ? activePanel.querySelector('input:not([disabled]), select:not([disabled]), button:not([disabled])') : null;
        if (focusTarget && typeof focusTarget.focus === 'function') focusTarget.focus({ preventScroll: true });
      }, 0);
    }
    if (settings.scroll) {
      window.setTimeout(function () {
        root.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      }, 0);
    }
  }

  function applyCollectionIntentToRoot(root, products, slug, options) {
    if (!root || !slug) return false;
    var intent = COLLECTION_INTENTS[slug];
    if (!intent) return false;
    var settings = Object.assign({ scroll: false, focus: true }, options || {});

    openCompactSelector(root, 'help', products, { scroll: settings.scroll, focus: false });
    clearHelpSelections(root);
    setSubmitted(root, false);
    applyDefaultProductType(root, 'help');
    syncContextualControls(root, 'help', true);

    if (intent.area) {
      setHelpRadioValue(root, 'area', intent.area);
      syncHelpUseCaseContext(root, true);
    }
    if (intent.cameraCount) {
      setHelpSelectValue(root, 'camera_count', intent.cameraCount);
    }
    setFirstSupportedHelpValue(root, 'use_case', intent.useCases || []);
    Object.keys(intent.quickFilters || {}).forEach(function (key) {
      setHelpRadioValue(root, key, intent.quickFilters[key]);
    });
    (intent.nativeFilters || []).forEach(function (filter) {
      setNativeQuickFilterByLabel(root, filter.label, filter.terms);
    });

    syncContextualControls(root, 'help', false);
    enforceLimits(root);
    updateQuickFilterSummaries(root);
    if (slug !== 'not-sure') {
      renderCommonNeedNotice(root, slug, {
        label: intent.label || humaniseSlug(slug),
        notes: 'Starting from the selected need. Adjust the questions below to refine these results.'
      }, true);
    }
    updateHelp(root, products || root._selectorProducts || []);
    if (settings.focus) {
      window.setTimeout(function () {
        var firstChanged = root.querySelector('[data-sa-selector-panel="help"] input:checked:not([value=""]), [data-sa-selector-panel="help"] select:not([value=""])');
        var fallback = root.querySelector('[data-sa-selector-panel="help"] input:not([disabled]), [data-sa-selector-panel="help"] select:not([disabled])');
        var target = firstChanged || fallback;
        if (target && typeof target.focus === 'function') target.focus({ preventScroll: true });
      }, 0);
    }
    dispatchAnalytics(root, 'selector_collection_shortcut_selected', { intent: slug });
    return true;
  }

  function answerValues(value) {
    if (Array.isArray(value)) return value.filter(Boolean).map(String);
    if (typeof value === 'string') {
      return value.split(',').map(function (item) { return item.trim(); }).filter(Boolean);
    }
    if (value === null || typeof value === 'undefined' || value === false) return [];
    return [String(value)];
  }

  function setExternalHelpAnswers(root, answers) {
    var external = {};
    ['priority', 'night'].forEach(function (key) {
      var values = answerValues(answers[key]);
      if (values.length) external[key] = values;
      if (values.length) {
        root.setAttribute('data-sa-prefill-' + key, values.join(','));
      } else {
        root.removeAttribute('data-sa-prefill-' + key);
      }
    });
    root._selectorExternalAnswers = external;
  }

  function applyAnswersToRoot(root, products, answers, options) {
    if (!root || !answers) return false;
    var settings = Object.assign({ scroll: false, focus: true, submit: false }, options || {});
    var answerMap = answers || {};
    var selectorProducts = products || root._selectorProducts || [];

    openCompactSelector(root, 'help', selectorProducts, { scroll: settings.scroll, focus: false });
    clearHelpSelections(root);
    setSubmitted(root, false);
    setExternalHelpAnswers(root, answerMap);
    applyDefaultProductType(root, 'help');

    answerValues(answerMap.product_type).some(function (value) {
      return setHelpRadioValue(root, 'product_type', value);
    });
    syncContextualControls(root, 'help', true);

    answerValues(answerMap.area).some(function (value) {
      return setHelpRadioValue(root, 'area', value);
    });
    syncHelpUseCaseContext(root, true);

    answerValues(answerMap.camera_count).some(function (value) {
      return setHelpSelectValue(root, 'camera_count', value);
    });
    answerValues(answerMap.use_case).some(function (value) {
      return setHelpRadioValue(root, 'use_case', value);
    });

    ['camera_shape', 'ir_distance', 'priority', 'night'].forEach(function (key) {
      answerValues(answerMap[key]).some(function (value) {
        return setHelpRadioValue(root, key, value) || setHelpSelectValue(root, key, value);
      });
    });

    syncContextualControls(root, 'help', false);
    syncAreaOptions(root);
    enforceLimits(root);
    updateQuickFilterSummaries(root);
    if (settings.submit) setSubmitted(root, true);
    updateHelp(root, selectorProducts);

    if (settings.focus) {
      window.setTimeout(function () {
        var target = null;
        Object.keys(answerMap).some(function (key) {
          var group = root.querySelector('[data-sa-selector-panel="help"] [data-question-key="' + key + '"]');
          target = group ? group.querySelector('input:checked:not([value=""]), select') : null;
          return Boolean(target);
        });
        if (!target) target = root.querySelector('[data-sa-selector-panel="help"] input:not([disabled]), [data-sa-selector-panel="help"] select:not([disabled])');
        if (target && typeof target.focus === 'function') target.focus({ preventScroll: true });
      }, 0);
    }

    dispatchAnalytics(root, 'selector_answers_prefilled', { answer_keys: Object.keys(answerMap).join(',') });
    return true;
  }

  function prefillKnownCollectionContext(root) {
    var installation = syncInferredKnownInstallation(root);
    var known = knownCollectionContext(root);
    var helpPanel = root.querySelector('[data-sa-selector-panel="help"]');
    if (!helpPanel) return;
    if (installation) {
      setCheckedValue(helpPanel.querySelector('[data-question-key="area"]'), installation);
    }
    if (known.cameraStyle) {
      setCheckedValue(helpPanel.querySelector('[data-question-key="camera_shape"]'), known.cameraStyle);
    }
  }

  function hideKnownCollectionContext(root) {
    syncInferredKnownInstallation(root);
    var known = knownCollectionContext(root);
    var forced = forcedProductType(root);
    var type = selectedProductType(root, root.getAttribute('data-active-mode') || 'help') || defaultProductTypeForFamily(root);
    var singleBrand = isSingleKnownUniverseValue(root, function (facts) { return facts.brand; });
    var singleShape = isSingleKnownUniverseValue(root, function (facts) { return facts.cameraShape; });
    var singleResolution = isSingleKnownUniverseValue(root, function (facts) { return facts.resolutionMp; });
    var singleKitCount = type === 'kit' && isSingleKnownUniverseValue(root, function (facts) { return facts.cameraCount; });
    var preferredBrand = known.brand || known.brandPreference || (singleBrand ? distinctKnownFacts(root, function (facts) { return facts.brand; })[0] : '');
    Array.prototype.slice.call(root.querySelectorAll('[data-sa-brand-filter-hidden]')).forEach(function (group) {
      group.hidden = false;
      group.removeAttribute('data-sa-brand-filter-hidden');
    });
    Array.prototype.slice.call(root.querySelectorAll('[data-sa-product-type-group]')).forEach(function (group) {
      group.hidden = Boolean(forced);
    });

    hideSelectorQuestion(root, 'area', Boolean(known.installation));
    hideSelectorQuestion(root, 'camera_shape', Boolean(known.cameraStyle) || singleShape);
    hideSelectorQuestion(root, 'camera_count', type !== 'kit' || singleKitCount, type !== 'kit');

    Array.prototype.slice.call(root.querySelectorAll('[data-sa-filter-group]')).forEach(function (group) {
      var label = normalise(group.getAttribute('data-filter-label') || '');
      var type = normalise(group.getAttribute('data-filter-type') || '');
      if (known.cameraStyle && (label.indexOf('camera type') !== -1 || label.indexOf('form factor') !== -1)) {
        group.hidden = true;
      }
      if ((known.resolution || singleResolution) && (label.indexOf('resolution') !== -1 || type.indexOf('resolution') !== -1)) {
        group.hidden = true;
      }
      if (preferredBrand && (label.indexOf('brand') !== -1 || label.indexOf('manufacturer') !== -1 || type.indexOf('vendor') !== -1)) {
        if (!group.hidden) group.setAttribute('data-sa-brand-filter-hidden', '');
        group.hidden = true;
      }
      if (known.technology && filterGroupRepeatsKnownTechnology(group, known.technology)) {
        group.hidden = true;
      }
    });

    Array.prototype.slice.call(root.querySelectorAll('[data-sa-native-quick-filter]')).forEach(function (group) {
      var hide = known.technology && filterGroupRepeatsKnownTechnology(group, known.technology);
      group.hidden = Boolean(hide);
      if (hide) {
        Array.prototype.slice.call(group.querySelectorAll('input[type="checkbox"]')).forEach(function (input) {
          input.checked = false;
        });
      }
    });
  }

  function selectedProductType(root, panelName) {
    var forced = forcedProductType(root);
    if (forced) return forced;
    var panel = root.querySelector('[data-sa-selector-panel="' + panelName + '"]');
    var selected = panel ? panel.querySelector('[data-sa-product-type-group] input:checked') : null;
    return selected ? selected.value : '';
  }

  function selectedKnowFilters(root) {
    var productType = selectedProductType(root, 'know');
    var filters = productTypeNativeFilters(root, productType);
    Array.prototype.slice.call(root.querySelectorAll('[data-sa-selector-panel="know"] input[type="checkbox"]:checked')).forEach(function (input) {
      if (isInHiddenContext(input)) return;
      filters.push(filterFromInput(input));
    });

    Array.prototype.slice.call(root.querySelectorAll('[data-sa-selector-panel="know"] select[data-sa-filter-select]')).forEach(function (select) {
      if (!select.value || isInHiddenContext(select)) return;
      var option = select.options[select.selectedIndex];
      filters.push({
        name: option.getAttribute('data-param-name') || '',
        value: option.value,
        label: option.textContent || option.value,
        filterLabel: select.getAttribute('data-filter-label') || '',
        filterType: select.getAttribute('data-filter-type') || '',
        count: Number(option.getAttribute('data-count') || 0),
        urlToAdd: option.getAttribute('data-url-to-add') || '',
        urlToRemove: option.getAttribute('data-url-to-remove') || ''
      });
    });

    Array.prototype.slice.call(root.querySelectorAll('[data-sa-selector-panel="know"] [data-sa-kit-count-select]')).forEach(function (select) {
      if (!select.value || isInHiddenContext(select)) return;
      filters = filters.concat(filtersForCameraCount(root, select.value));
    });

    filters = filters.concat(selectedKnowPriceFilters(root));
    filters = filters.concat(selectedBrandNativeFilters(root));

    filters = dedupeFilters(filters);

    return filters;
  }

  function selectedShapeFromFilters(filters) {
    var selectedShape = '';
    (filters || []).some(function (filter) {
      var group = normalise([filter.filterLabel, filter.filterType].join(' '));
      var label = normalise(filter.label || filter.value || '');
      if (group.indexOf('camera type') === -1 && group.indexOf('camera shape') === -1 && group.indexOf('form factor') === -1 && group.indexOf('shape') === -1) return false;
      if (label.indexOf('turret') !== -1 || label.indexOf('eyeball') !== -1) selectedShape = 'turret';
      else if (label.indexOf('dome') !== -1) selectedShape = 'dome';
      else if (label.indexOf('bullet') !== -1) selectedShape = 'bullet';
      else if (label.indexOf('ptz') !== -1) selectedShape = 'ptz';
      else if (label.indexOf('fisheye') !== -1 || label.indexOf('360') !== -1 || label.indexOf('panoramic') !== -1) selectedShape = 'fisheye';
      return Boolean(selectedShape);
    });
    return selectedShape;
  }

  function selectedCameraCountFromFilters(root, filters) {
    var selected = root.querySelector('[data-sa-selector-panel="know"] [data-sa-kit-count-select]');
    if (selected && selected.value && !isInHiddenContext(selected)) return selected.value;
    var count = '';
    (filters || []).some(function (filter) {
      var group = normalise([filter.filterLabel, filter.filterType].join(' '));
      var label = normalise(filter.label || filter.value || '');
      if (group.indexOf('camera count') === -1 && group.indexOf('package') === -1 && group.indexOf('bundle') === -1) return false;
      var match = label.match(/(?:^|\s)(4|6|8|10)\s*(?:camera|cameras|x)?\b/);
      if (match) count = match[1];
      return Boolean(count);
    });
    return count;
  }

  function selectedKnowAnswers(root, filters) {
    var productType = selectedProductType(root, 'know') || defaultProductTypeForFamily(root);
    var answers = {};
    if (productType) answers.product_type = [productType];
    var known = knownCollectionContext(root);
    var shape = known.cameraStyle || selectedShapeFromFilters(filters);
    var count = selectedCameraCountFromFilters(root, filters);
    var brand = activeBrandPreference(root);
    if (known.installation) answers.area = [known.installation];
    if (shape) answers.camera_shape = [shape];
    if (productType === 'kit' && count) answers.camera_count = [count];
    if (brand) answers.brand_preference = [brand];
    return answers;
  }

  function dedupeFilters(filters) {
    return filters.filter(function (filter, index, source) {
      if (!filter.name || filter.value === '') return false;
      return source.findIndex(function (item) {
        return item.name === filter.name && item.value === filter.value;
      }) === index;
    });
  }

  function selectedNativeQuickFilters(root, panelName) {
    var panel = root.querySelector('[data-sa-selector-panel="' + panelName + '"]');
    if (!panel) return [];
    return dedupeFilters(Array.prototype.slice.call(panel.querySelectorAll('[data-sa-native-quick-filter] input[type="checkbox"]:checked')).filter(function (input) {
      return !isInHiddenContext(input);
    }).map(filterFromInput));
  }

  function selectedKnowPriceFilters(root) {
    var filters = [];
    Array.prototype.slice.call(root.querySelectorAll('[data-sa-price-input]')).forEach(function (input) {
      if (isInHiddenContext(input)) return;
      if (!input.value) return;
      filters.push({
        name: input.name,
        value: input.value,
        label: (input.dataset.saPriceInput === 'min' ? 'Min price ' : 'Max price ') + input.value,
        filterLabel: 'Price',
        filterType: 'price_range',
        count: 0,
        urlToAdd: '',
        urlToRemove: ''
      });
    });

    return filters;
  }

  function selectorContextParams(root) {
    var params = {};
    var need = root ? root.getAttribute('data-common-need') || commonNeedSlugFromUrl() : commonNeedSlugFromUrl();
    var brand = root ? activeBrandPreference(root) : brandFromUrl();
    if (need) params.sa_need = need;
    if (brand) params.sa_brand = brand;
    return params;
  }

  function buildSearchParams(filters, options) {
    var settings = options || {};
    var params = new URLSearchParams();
    var context = settings.root && settings.preserveContext !== false ? selectorContextParams(settings.root) : {};
    if (context.sa_need) params.set('sa_need', context.sa_need);
    if (context.sa_brand) params.set('sa_brand', context.sa_brand);
    var sortBy = settings.preserveSort ? getCurrentSort() : '';
    if (sortBy) params.set('sort_by', sortBy);
    filters.forEach(function (filter) {
      if (filter.name && filter.value !== '') params.append(filter.name, filter.value);
    });
    return params;
  }

  function buildFilterUrl(root, filters) {
    var collectionUrl = root.getAttribute('data-collection-url') || window.location.pathname;
    var query = buildSearchParams(filters, { preserveSort: true, root: root }).toString();
    return collectionUrl + (query ? '?' + query : '') + '#collection-products';
  }

  function setCtaState(link, enabled, label, href) {
    if (!link) return;
    link.hidden = false;
    link.removeAttribute('aria-hidden');
    link.textContent = label;
    link.href = href || '#collection-products';
    link.setAttribute('aria-disabled', enabled ? 'false' : 'true');
    link.classList.toggle('is-disabled', !enabled);
    if (enabled) {
      link.removeAttribute('tabindex');
    } else {
      link.setAttribute('tabindex', '-1');
    }
  }

  function setPrimaryCtaHidden(link, hidden) {
    if (!link) return;
    link.hidden = Boolean(hidden);
    if (hidden) {
      link.setAttribute('aria-hidden', 'true');
      link.setAttribute('aria-disabled', 'true');
      link.setAttribute('tabindex', '-1');
    } else {
      link.removeAttribute('aria-hidden');
    }
  }

  function scrollToRecommendations(root) {
    var target = root && (root.querySelector('.sa-collection-selector__recommendations') || root.querySelector('[data-sa-selector-summary]'));
    if (!target) return;
    var behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    window.requestAnimationFrame(function () {
      window.setTimeout(function () {
        target.scrollIntoView({
          behavior: behavior,
          block: 'start'
        });
      }, 0);
    });
  }

  function buildSelectorAssertion(root, recommendations, snapshot, count, filters) {
    var products = root._selectorProducts || [];
    var handles = snapshot && snapshot.handles ? snapshot.handles.slice() : [];
    var canonicalProducts = handles.length ? productsFromNativeSnapshot(products, snapshot) : (recommendations || []);
    var canonicalIds = canonicalProducts.map(function (product) { return String(product.id || ''); }).filter(Boolean);
    var recommendedIds = (recommendations || []).map(function (product) { return String(product.id || ''); }).filter(Boolean);
    var subsetPass = recommendedIds.every(function (id) { return canonicalIds.indexOf(id) !== -1; });
    return {
      filters: (filters || []).map(function (filter) {
        return {
          name: filter.name,
          value: filter.value,
          label: filter.label,
          filterLabel: filter.filterLabel || ''
        };
      }),
      canonicalMatchingCount: typeof count === 'number' ? count : null,
      canonicalMatchingHandles: handles,
      canonicalMatchingIds: canonicalIds,
      recommendedIds: recommendedIds,
      recommendedCount: recommendedIds.length,
      subsetPass: recommendedIds.length > 0 ? subsetPass : null
    };
  }

  function setViewMoreState(root, enabled, count, filters, snapshot, recommendations) {
    var button = root.querySelector('[data-sa-view-matching-products]');
    if (!button) return;
    root._selectorCanonicalState = enabled ? {
      filters: (filters || []).slice(),
      count: typeof count === 'number' ? count : null,
      assertion: buildSelectorAssertion(root, recommendations || [], snapshot || null, count, filters || [])
    } : null;
    button.hidden = !enabled;
    button.disabled = !enabled;
    button.textContent = typeof count === 'number' && count > 0 ? 'View all ' + productCountLabel(count) : 'View matching products';
  }

  function openExpertHelp(root, opener) {
    dispatchAnalytics(root, 'selector_expert_help_clicked');
    var modal = root.querySelector('[data-sa-selector-question-modal]') || document.querySelector('[data-sa-selector-question-modal]');
    if (modal && typeof modal.show === 'function') {
      modal.show(opener || root.querySelector('[data-sa-expert-help]'));
      return true;
    }
    var modalOpener = document.querySelector('[data-sa-question-modal-open], [data-sa-open-question-modal], .sa-question-modal-trigger');
    if (modalOpener) {
      modalOpener.click();
      return true;
    }
    window.location.href = '/pages/contact-page';
    return false;
  }

  function productCountLabel(count) {
    return count + ' ' + (Number(count) === 1 ? 'product' : 'products');
  }

  function parseProductCount(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var empty = doc.querySelector('#product-grid.collection--empty');
    if (empty) return 0;
    var countNode = doc.getElementById('ProductCount') || doc.getElementById('ProductCountDesktop');
    if (!countNode) return null;
    var match = (countNode.textContent || '').replace(/,/g, '').match(/\d+/);
    return match ? Number(match[0]) : null;
  }

  function updateSelectorCounts(root, html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var nativeInputs = doc.querySelectorAll('#FacetFiltersForm input[type="checkbox"]');
    var nativeMap = {};
    Array.prototype.slice.call(nativeInputs).forEach(function (input) {
      var key = input.name + '::' + input.value;
      var label = input.closest('label');
      var countNode = label ? label.querySelector('.facet-checkbox__count') : null;
      nativeMap[key] = {
        disabled: input.disabled,
        count: countNode ? (countNode.textContent || '').trim() : ''
      };
    });

    Array.prototype.slice.call(root.querySelectorAll('input[type="checkbox"][data-filter-label]')).forEach(function (input) {
      var native = nativeMap[input.name + '::' + input.value];
      var small = input.closest('label') ? input.closest('label').querySelector('small') : null;
      if (!native) return;
      input.disabled = native.disabled && !input.checked;
      if (small && native.count !== '') {
        small.textContent = native.count;
        input.setAttribute('data-count', native.count);
      }
      var option = root.querySelector('[data-sa-filter-select] option[data-param-name="' + CSS.escape(input.name) + '"][value="' + CSS.escape(input.value) + '"]');
      if (option && native.count !== '') {
        option.setAttribute('data-count', native.count);
        option.textContent = (input.getAttribute('data-label') || input.value) + ' (' + native.count + ')';
        option.disabled = input.disabled && !input.checked;
      }
    });
    updateQuickFilterSummaries(root);
  }

  function requestNativeCount(root, filters, callback) {
    var sectionId = getSectionId();
    if (!sectionId) {
      callback(null);
      return;
    }

    var controller = pendingCountRequests.get(root);
    if (controller) controller.abort();
    controller = new AbortController();
    pendingCountRequests.set(root, controller);

    var collectionUrl = root.getAttribute('data-collection-url') || window.location.pathname;
    var params = buildSearchParams(filters, { preserveSort: true, root: root });
    params.set('section_id', sectionId);
    fetch(collectionUrl + '?' + params.toString(), { signal: controller.signal })
      .then(function (response) { return response.text(); })
      .then(function (html) {
        updateSelectorCounts(root, html);
        callback(parseProductCount(html));
      })
      .catch(function (error) {
        if (error.name !== 'AbortError') callback(null);
      });
  }

  function fetchNativeCountOnce(root, filters) {
    var sectionId = getSectionId();
    if (!sectionId) return Promise.resolve(null);
    var collectionUrl = root.getAttribute('data-collection-url') || window.location.pathname;
    var params = buildSearchParams(filters, { preserveSort: true, root: root });
    params.set('section_id', sectionId);
    return fetch(collectionUrl + '?' + params.toString())
      .then(function (response) { return response.text(); })
      .then(function (html) {
        return parseProductCount(html);
      })
      .catch(function () {
        return null;
      });
  }

  function productHandleFromUrl(value) {
    try {
      var url = new URL(value || '', window.location.origin);
      var match = url.pathname.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (error) {
      return '';
    }
  }

  function fetchNativeSnapshot(root, filters) {
    var sectionId = getSectionId();
    if (!sectionId) {
      return Promise.resolve({ count: null, handles: [] });
    }
    var collectionUrl = root.getAttribute('data-collection-url') || window.location.pathname;
    var params = buildSearchParams(filters, { preserveSort: true, root: root });
    params.set('section_id', sectionId);
    return fetch(collectionUrl + '?' + params.toString())
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var handles = [];
        Array.prototype.slice.call(doc.querySelectorAll('#product-grid a[href*="/products/"]')).forEach(function (link) {
          var handle = productHandleFromUrl(link.getAttribute('href'));
          if (handle && handles.indexOf(handle) === -1) handles.push(handle);
        });
        updateSelectorCounts(root, html);
        return {
          count: parseProductCount(html),
          handles: handles
        };
      })
      .catch(function () {
        return { count: null, handles: [] };
      });
  }

  function formatSelectorMoney(value) {
    var amount = parseMoney(value);
    return amount === null ? '' : '$' + amount.toLocaleString('en-AU', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function selectorProductFromStorefrontJson(product, root) {
    var variants = Array.isArray(product && product.variants) ? product.variants : [];
    var firstVariant = variants[0] || {};
    var prices = variants.map(function (variant) { return parseMoney(variant.price); }).filter(function (value) { return value !== null; });
    var comparePrices = variants.map(function (variant) { return parseMoney(variant.compare_at_price); }).filter(function (value) { return value !== null; });
    var price = prices.length ? Math.min.apply(Math, prices) : parseMoney(product && product.price);
    var compareAtPrice = comparePrices.length ? Math.max.apply(Math, comparePrices) : parseMoney(product && product.compare_at_price);
    var image = '';
    if (product && Array.isArray(product.images) && product.images.length) image = product.images[0].src || '';
    if (!image && product && product.image) image = product.image.src || product.image || '';
    return {
      id: String(product && product.id || ''),
      variantId: firstVariant.id || '',
      title: product && product.title || '',
      url: '/products/' + (product && product.handle || ''),
      sku: firstVariant.sku || '',
      source: 'current',
      collectionUrl: root.getAttribute('data-collection-url') || window.location.pathname,
      type: product && (product.product_type || product.type) || '',
      vendor: product && product.vendor || '',
      tags: product && product.tags || [],
      available: variants.some(function (variant) { return variant.available !== false; }),
      hasOnlyDefaultVariant: variants.length <= 1,
      price: formatSelectorMoney(price),
      compareAtPrice: compareAtPrice !== null && price !== null && compareAtPrice > price ? formatSelectorMoney(compareAtPrice) : null,
      image: image,
      imageAlt: product && product.title || '',
      cameraCount: '',
      cameraFormFactor: '',
      lensType: '',
      recorderChannels: '',
      poePorts: '',
      includedStorage: '',
      storageCapacity: '',
      resolution: '',
      nightVision: '',
      canonicalRole: '',
      productRole: '',
      roleConfidence: '',
      merchandisingEligibility: '',
      manualReviewRequired: false,
      isCompleteProduct: '',
      priority: 0,
      commonNeedText: '',
      matchText: normalise([
        product && product.title,
        product && (product.product_type || product.type),
        product && product.vendor,
        Array.isArray(product && product.tags) ? product.tags.join(' ') : product && product.tags
      ].join(' ')),
      badges: []
    };
  }

  function selectorProductFromCapabilityMatrix(entry, root) {
    var matrixImage = entry && (entry.image || entry.imageUrl || entry.featuredImage || entry.featured_image) || '';
    return {
      id: String(entry && entry.id || ''),
      variantId: '',
      title: entry && entry.title || '',
      url: entry && entry.url || ('/products/' + (entry && entry.handle || '')),
      sku: '',
      source: 'current',
      collectionUrl: root.getAttribute('data-collection-url') || window.location.pathname,
      type: entry && entry.productType || '',
      vendor: entry && entry.vendor || '',
      tags: [],
      available: entry ? entry.available !== false : false,
      hasOnlyDefaultVariant: true,
      price: formatSelectorMoney(entry && entry.price),
      compareAtPrice: entry && entry.compareAtPrice !== null && entry.compareAtPrice > entry.price ? formatSelectorMoney(entry.compareAtPrice) : null,
      image: matrixImage,
      imageAlt: entry && entry.title || '',
      cameraCount: entry && entry.hardFacts ? entry.hardFacts.cameraCount || '' : '',
      cameraFormFactor: entry && entry.hardFacts ? entry.hardFacts.cameraShape || '' : '',
      lensType: '',
      recorderChannels: entry && entry.hardFacts ? entry.hardFacts.recorderChannels || '' : '',
      poePorts: entry && entry.hardFacts ? entry.hardFacts.poePorts || '' : '',
      includedStorage: '',
      storageCapacity: '',
      resolution: entry && entry.hardFacts ? entry.hardFacts.resolutionMp || '' : '',
      nightVision: '',
      canonicalRole: entry && entry.hardFacts ? entry.hardFacts.productRole || '' : '',
      productRole: entry && entry.hardFacts ? entry.hardFacts.productRole || '' : '',
      roleConfidence: '',
      merchandisingEligibility: '',
      manualReviewRequired: false,
      isCompleteProduct: entry && entry.hardFacts ? entry.hardFacts.completeKitVerified || '' : '',
      priority: entry && entry.merchandisingFit ? entry.merchandisingFit.sourcePriority || 0 : 0,
      commonNeedText: '',
      matchText: normalise([
        entry && entry.title,
        entry && entry.handle,
        entry && entry.vendor,
        entry && entry.productType
      ].join(' ')),
      badges: [],
      selectorHardFacts: entry && entry.hardFacts || null,
      selectorCapabilities: entry && entry.capabilities || null
    };
  }

  function selectorProductHasValue(value) {
    return value !== null && typeof value !== 'undefined' && value !== '';
  }

  function selectorProductDataScore(product) {
    if (!product) return -1;
    var hardFacts = product.selectorHardFacts || {};
    var score = 0;
    if (product.selectorHardFacts) score += 80;
    if (product.selectorCapabilities) score += 10;
    if (canonicalRoleSlug(product.canonicalRole || product.productRole || hardFacts.productRole || '')) score += 20;
    if (selectorProductHasValue(product.merchandisingEligibility)) score += 4;
    if (selectorProductHasValue(product.roleConfidence)) score += 3;
    if (product.isCompleteProduct === true || product.isCompleteProduct === 'true' || hardFacts.completeKitVerified === true) score += 8;
    if (firstNumber(product.cameraCount) !== null || firstNumber(hardFacts.cameraCount) !== null) score += 5;
    if (firstNumber(product.recorderChannels) !== null || firstNumber(hardFacts.recorderChannels) !== null) score += 5;
    if (firstNumber(product.resolution) !== null || firstNumber(hardFacts.resolutionMp) !== null) score += 4;
    if (selectorProductHasValue(product.cameraFormFactor) || selectorProductHasValue(hardFacts.cameraShape)) score += 3;
    if (selectorProductHasValue(product.image)) score += 2;
    if (selectorProductHasValue(product.variantId)) score += 2;
    if (product.tags && product.tags.length) score += 1;
    return score;
  }

  function mergeSelectorProductData(existingProduct, incomingProduct) {
    var incomingWins = selectorProductDataScore(incomingProduct) > selectorProductDataScore(existingProduct);
    var primary = incomingWins ? incomingProduct : existingProduct;
    var fallback = incomingWins ? existingProduct : incomingProduct;
    var mergedProduct = Object.assign({}, fallback || {}, primary || {});
    [
      'id',
      'variantId',
      'sku',
      'url',
      'collectionUrl',
      'type',
      'vendor',
      'price',
      'compareAtPrice',
      'image',
      'imageAlt',
      'commonNeedText',
      'matchText'
    ].forEach(function (field) {
      if (!selectorProductHasValue(mergedProduct[field]) && fallback && selectorProductHasValue(fallback[field])) {
        mergedProduct[field] = fallback[field];
      }
    });
    if ((!mergedProduct.tags || !mergedProduct.tags.length) && fallback && fallback.tags && fallback.tags.length) {
      mergedProduct.tags = fallback.tags.slice();
    }
    if ((!mergedProduct.badges || !mergedProduct.badges.length) && fallback && fallback.badges && fallback.badges.length) {
      mergedProduct.badges = fallback.badges.slice();
    }
    if (typeof mergedProduct.available === 'undefined' && fallback && typeof fallback.available !== 'undefined') {
      mergedProduct.available = fallback.available;
    }
    if (typeof mergedProduct.hasOnlyDefaultVariant === 'undefined' && fallback && typeof fallback.hasOnlyDefaultVariant !== 'undefined') {
      mergedProduct.hasOnlyDefaultVariant = fallback.hasOnlyDefaultVariant;
    }
    delete mergedProduct._selectorFacts;
    delete mergedProduct._commonNeedSearch;
    delete mergedProduct._search;
    mergedProduct._search = productSearchText(mergedProduct);
    return mergedProduct;
  }

  function mergeSelectorProducts(existingProducts, additionalProducts) {
    var byHandle = {};
    var merged = [];
    (existingProducts || []).concat(additionalProducts || []).forEach(function (product) {
      var handle = productHandle(product);
      if (!handle) return;
      if (typeof byHandle[handle] !== 'undefined') {
        merged[byHandle[handle]] = mergeSelectorProductData(merged[byHandle[handle]], product);
        return;
      }
      var mergedProduct = Object.assign({}, product);
      mergedProduct._search = productSearchText(mergedProduct);
      byHandle[handle] = merged.length;
      merged.push(mergedProduct);
    });
    return merged;
  }

  function hydrateMatrixProducts(matrixProducts, storefrontProducts, existingProducts) {
    var byHandle = {};
    (existingProducts || []).concat(storefrontProducts || []).forEach(function (product) {
      var handle = productHandle(product);
      if (handle && !byHandle[handle]) byHandle[handle] = product;
    });
    return (matrixProducts || []).map(function (product) {
      var source = byHandle[productHandle(product)];
      if (!source) return product;
      if (!product.variantId && source.variantId) product.variantId = source.variantId;
      if (!product.sku && source.sku) product.sku = source.sku;
      if (!product.image && source.image) product.image = source.image;
      if ((!product.imageAlt || product.imageAlt === product.title) && source.imageAlt) product.imageAlt = source.imageAlt;
      if ((!product.tags || !product.tags.length) && source.tags && source.tags.length) product.tags = source.tags.slice();
      if ((!product.badges || !product.badges.length) && source.badges && source.badges.length) product.badges = source.badges.slice();
      if (!product.hasOnlyDefaultVariant && source.hasOnlyDefaultVariant) product.hasOnlyDefaultVariant = source.hasOnlyDefaultVariant;
      return product;
    });
  }

  function fetchMatrixCatalogue(root) {
    var matrixUrl = root.getAttribute('data-selector-matrix-url') || '';
    var collectionHandle = root.getAttribute('data-collection-handle') || '';
    if (!matrixUrl || !collectionHandle || typeof fetch !== 'function') return Promise.resolve([]);
    return fetch(matrixUrl)
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .then(function (payload) {
        var matrixProducts = payload && Array.isArray(payload.products) ? payload.products : [];
        return matrixProducts.filter(function (entry) {
          return (entry.collections || []).indexOf(collectionHandle) !== -1;
        }).map(function (entry) {
          return selectorProductFromCapabilityMatrix(entry, root);
        });
      })
      .catch(function () {
        return [];
      });
  }

  function fetchStorefrontCatalogue(root) {
    var collectionUrl = root.getAttribute('data-collection-url') || window.location.pathname;
    var endpoint = collectionUrl.replace(/\/$/, '') + '/products.json';
    var collected = [];

    function fetchPage(page) {
      var url = endpoint + '?limit=250&page=' + page;
      return fetch(url)
        .then(function (response) {
          if (!response.ok) return { products: [] };
          return response.json();
        })
        .then(function (payload) {
          var pageProducts = payload && Array.isArray(payload.products) ? payload.products : [];
          collected = collected.concat(pageProducts.map(function (product) {
            return selectorProductFromStorefrontJson(product, root);
          }));
          if (pageProducts.length >= 250 && page < 20) return fetchPage(page + 1);
          return collected;
        });
    }

    return fetchPage(1);
  }

  function ensureFullCurrentCatalogue(root, products) {
    var existing = products || root._selectorProducts || [];
    if (!root || root._selectorFullCatalogueLoaded) return Promise.resolve(existing);
    if (root._selectorFullCataloguePromise) return root._selectorFullCataloguePromise;
    if (typeof fetch !== 'function') {
      root._selectorFullCatalogueLoaded = true;
      root.setAttribute('data-sa-selector-catalogue-size', String(existing.length));
      root.setAttribute('data-sa-selector-catalogue-source', 'liquid');
      return Promise.resolve(existing);
    }

    root._selectorFullCataloguePromise = fetchMatrixCatalogue(root).then(function (matrixProducts) {
      if (matrixProducts.length) {
        root._selectorFullCatalogueSource = 'matrix';
        return fetchStorefrontCatalogue(root).then(function (storefrontProducts) {
          return hydrateMatrixProducts(matrixProducts, storefrontProducts, existing);
        }).catch(function () {
          return hydrateMatrixProducts(matrixProducts, [], existing);
        });
      }
      root._selectorFullCatalogueSource = 'storefront';
      return fetchStorefrontCatalogue(root);
    }).then(function (additionalProducts) {
      root._selectorFullCatalogueLoaded = true;
      root._selectorProducts = mergeSelectorProducts(existing, additionalProducts);
      root.setAttribute('data-sa-selector-catalogue-size', String(root._selectorProducts.length));
      root.setAttribute('data-sa-selector-catalogue-source', root._selectorFullCatalogueSource || (additionalProducts.length ? 'storefront' : 'liquid'));
      return root._selectorProducts;
    }).catch(function () {
      root._selectorFullCatalogueLoaded = true;
      root._selectorProducts = existing;
      root.setAttribute('data-sa-selector-catalogue-size', String(existing.length));
      root.setAttribute('data-sa-selector-catalogue-source', 'liquid');
      return existing;
    });

    return root._selectorFullCataloguePromise;
  }

  function filterCombinations(filters) {
    var results = [];
    var total = filters.length;
    function walk(start, combo, targetSize) {
      if (combo.length === targetSize) {
        results.push(combo.slice());
        return;
      }
      for (var i = start; i < total; i += 1) {
        combo.push(filters[i]);
        walk(i + 1, combo, targetSize);
        combo.pop();
      }
    }
    for (var size = total; size > 0; size -= 1) {
      walk(0, [], size);
    }
    return results;
  }

  function resolveNativeFilterSet(root, filters, callback) {
    var candidates = filterCombinations(filters).slice(0, 31);
    Promise.all(candidates.map(function (candidate) {
      return fetchNativeCountOnce(root, candidate).then(function (count) {
        return {
          filters: candidate,
          count: Number(count || 0)
        };
      });
    })).then(function (results) {
      var best = results.filter(function (result) {
        return result.count > 0;
      }).sort(function (a, b) {
        if (b.filters.length !== a.filters.length) return b.filters.length - a.filters.length;
        return b.count - a.count;
      })[0] || { filters: [], count: 0 };
      callback(best.filters, best.count);
    }).catch(function () {
      callback([], 0);
    });
  }

  function scrollToProductGrid() {
    var target = document.getElementById('collection-products') || document.querySelector('[data-id="collection-products"], facet-filters-form, #FacetFiltersForm, #FacetFiltersFormMobile');
    if (target) {
      target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      if (typeof target.focus === 'function') target.focus({ preventScroll: true });
      return;
    }
    window.location.hash = 'collection-products';
  }

  function applyNativeQuery(root, query, options) {
    options = Object.assign({ scroll: false, replace: true }, options || {});
    var FacetsConstructor = window.FacetFiltersForm || window.customElements && window.customElements.get('facet-filters-form');
    if (FacetsConstructor && typeof FacetsConstructor.renderPage === 'function') {
      FacetsConstructor.renderPage(query, null, false);
      window.setTimeout(function () {
        var collectionUrl = root.getAttribute('data-collection-url') || window.location.pathname;
        var nextUrl = collectionUrl + (query ? '?' + query : '') + (options.scroll ? '#collection-products' : '');
        history[options.replace ? 'replaceState' : 'pushState']({ searchParams: query }, '', nextUrl);
        if (root._selectorPersonalisedHandles && root._selectorPersonalisedHandles.length) {
          applyPersonalisedGridSubset(root, { nativeFiltersActive: searchParamsHaveNativeFilters(query) });
        }
        if (options.scroll) scrollToProductGrid();
      }, 180);
      return;
    }

    var collectionUrl = root.getAttribute('data-collection-url') || window.location.pathname;
    var nextUrl = collectionUrl + (query ? '?' + query : '') + (options.scroll ? '#collection-products' : '');
    if (options.scroll) {
      window.location.href = nextUrl;
      return;
    }
    history[options.replace ? 'replaceState' : 'pushState']({ searchParams: query }, '', nextUrl);
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  function removeActiveFilterState() {
    var existing = document.querySelector('[data-sa-selector-active-state]');
    if (existing) existing.remove();
  }

  function uniqueHandles(handles) {
    var seen = {};
    return (handles || []).map(function (handle) {
      return String(handle || '').trim();
    }).filter(function (handle) {
      if (!handle || seen[handle]) return false;
      seen[handle] = true;
      return true;
    });
  }

  function productHandlesFromProducts(products) {
    return uniqueHandles((products || []).map(function (product) {
      return productHandle(product);
    }));
  }

  function selectorGridItems() {
    var grid = document.getElementById('product-grid');
    if (!grid) return [];
    var items = Array.prototype.slice.call(grid.querySelectorAll('[data-sa-product-handle]:not([data-sa-selector-injected-product])'));
    if (items.length) return items;
    var seen = [];
    Array.prototype.slice.call(grid.querySelectorAll('a[href*="/products/"]')).forEach(function (link) {
      var item = link.closest('.sa-collection-grid__item, .grid__item, li, article, .card-wrapper') || link;
      if (item.hasAttribute && item.hasAttribute('data-sa-selector-injected-product')) return;
      if (seen.indexOf(item) === -1) seen.push(item);
    });
    return seen;
  }

  function selectorGridItemHandle(item) {
    if (!item) return '';
    var explicit = item.getAttribute('data-sa-product-handle');
    if (explicit) return explicit;
    var link = item.matches && item.matches('a[href*="/products/"]') ? item : item.querySelector('a[href*="/products/"]');
    return link ? productHandleFromUrl(link.getAttribute('href') || '') : '';
  }

  function searchParamsHaveNativeFilters(searchParams) {
    var params = searchParams instanceof URLSearchParams
      ? searchParams
      : new URLSearchParams(searchParams || window.location.search.slice(1));
    var hasFilters = false;
    params.forEach(function (value, name) {
      if (name.indexOf('filter.') === 0 && value !== '') hasFilters = true;
    });
    return hasFilters;
  }

  function selectorProductCountNodes() {
    return Array.prototype.slice.call(document.querySelectorAll('#ProductCount, #ProductCountDesktop, .product-count, .mobile-facets__count'));
  }

  function setSelectorProductCount(count) {
    var label = productCountLabel(count) + ' match your setup';
    selectorProductCountNodes().forEach(function (node) {
      if (!node.getAttribute('data-sa-selector-original-count')) {
        node.setAttribute('data-sa-selector-original-count', node.innerHTML.trim());
      }
      node.textContent = label;
    });
  }

  function restoreSelectorProductCount() {
    selectorProductCountNodes().forEach(function (node) {
      var original = node.getAttribute('data-sa-selector-original-count');
      if (!original) return;
      node.innerHTML = original;
      node.removeAttribute('data-sa-selector-original-count');
    });
  }

  function restorePersonalisedGridSubset(root) {
    removeSelectorInjectedGridItems();
    selectorGridItems().forEach(function (item) {
      item.hidden = false;
      item.removeAttribute('data-sa-selector-hidden-product');
      item.style.removeProperty('display');
    });
    if (root) {
      root._selectorPersonalisedHandles = [];
      root._selectorPersonalisedCount = null;
      root.classList.remove('has-personalised-results');
      root.removeAttribute('data-sa-selector-visible-products');
      root.removeAttribute('data-sa-selector-canonical-products');
      root.removeAttribute('data-sa-selector-catalogue-size');
      root.removeAttribute('data-sa-selector-catalogue-source');
    }
    restoreSelectorProductCount();
  }

  function removeSelectorInjectedGridItems() {
    Array.prototype.slice.call(document.querySelectorAll('[data-sa-selector-injected-product]')).forEach(function (item) {
      item.remove();
    });
  }

  function selectorProductByHandle(root, handle) {
    var products = root && root._selectorProducts || [];
    for (var i = 0; i < products.length; i += 1) {
      if (productHandle(products[i]) === handle) return products[i];
    }
    return null;
  }

  function renderInjectedGridProduct(root, grid, product, templateItem) {
    var wrapper = document.createElement('div');
    wrapper.className = templateItem && templateItem.className
      ? templateItem.className.replace(/\bsa-need-preset-hidden\b/g, '').trim()
      : 'sa-collection-grid__item col-sp-12 col-st-6 col-3';
    if (wrapper.className.indexOf('sa-collection-grid__item') === -1) {
      wrapper.className += ' sa-collection-grid__item';
    }
    wrapper.className += ' sa-selector-injected-grid-item';
    wrapper.setAttribute('data-sa-selector-injected-product', '');
    wrapper.setAttribute('data-sa-product-handle', productHandle(product));
    if (product.id) wrapper.setAttribute('data-sa-product-id', String(product.id));
    wrapper.setAttribute('data-sa-original-index', 'selector');
    wrapper.appendChild(buildCollectionGridProductCard(root, product));
    grid.appendChild(wrapper);
    return wrapper;
  }

  function injectMissingGridProducts(root, handles, visibleHandles, templateItem) {
    var grid = document.getElementById('product-grid');
    if (!grid) return 0;
    var injected = 0;
    handles.forEach(function (handle) {
      if (visibleHandles[handle]) return;
      var product = selectorProductByHandle(root, handle);
      if (!product) return;
      renderInjectedGridProduct(root, grid, product, templateItem);
      visibleHandles[handle] = true;
      injected += 1;
    });
    return injected;
  }

  function applyPersonalisedGridSubset(root, options) {
    var settings = options || {};
    var handles = uniqueHandles(root && root._selectorPersonalisedHandles);
    if (!root || !handles.length) return;
    removeSelectorInjectedGridItems();
    var allowed = {};
    handles.forEach(function (handle) {
      allowed[handle] = true;
    });
    var visibleOnPage = 0;
    var visibleHandles = {};
    var gridItems = selectorGridItems();
    var templateItem = gridItems[0] || null;
    gridItems.forEach(function (item) {
      var handle = selectorGridItemHandle(item);
      var visible = Boolean(handle && allowed[handle]);
      item.hidden = !visible;
      if (visible) {
        visibleOnPage += 1;
        visibleHandles[handle] = true;
        item.removeAttribute('data-sa-selector-hidden-product');
        item.style.removeProperty('display');
      } else {
        item.setAttribute('data-sa-selector-hidden-product', '');
        item.style.setProperty('display', 'none', 'important');
      }
    });
    visibleOnPage += injectMissingGridProducts(root, handles, visibleHandles, templateItem);
    setSelectorProductCount(typeof root._selectorPersonalisedCount === 'number' ? root._selectorPersonalisedCount : handles.length);
    root.classList.add('has-personalised-results');
    root.setAttribute('data-sa-selector-visible-products', String(visibleOnPage));
    root.setAttribute('data-sa-selector-canonical-products', String(typeof root._selectorPersonalisedCount === 'number' ? root._selectorPersonalisedCount : handles.length));
  }

  function setPersonalisedGridSubset(root, source, count) {
    var handles = Array.isArray(source) && source.length && typeof source[0] === 'object'
      ? productHandlesFromProducts(source)
      : uniqueHandles(source);
    if (!handles.length) {
      restorePersonalisedGridSubset(root);
      return;
    }
    root._selectorPersonalisedHandles = handles;
    root._selectorPersonalisedCount = typeof count === 'number' ? count : handles.length;
    applyPersonalisedGridSubset(root, { nativeFiltersActive: searchParamsHaveNativeFilters() });
  }

  function clearSelectorResults(root, options) {
    var settings = Object.assign({ resetNative: true, preserveContext: true, clearCommonNeed: false }, options || {});
    removeActiveFilterState();
    setViewMoreState(root, false, 0, []);
    root._selectorCanonicalState = null;
    restorePersonalisedGridSubset(root);
    if (settings.clearCommonNeed) clearCommonNeedNotice(root);
    pendingHelpResolutions.set(root, '');
    pendingKnowResolutions.set(root, '');
    if (!settings.resetNative) return;
    var query = settings.preserveContext ? buildSearchParams([], { preserveSort: true, root: root }).toString() : '';
    applyNativeQuery(root, query, { scroll: false, replace: true });
  }

  function renderActiveFilterState(root, filters, count) {
    var target = document.getElementById('collection-products') || document.querySelector('[data-id="collection-products"], facet-filters-form, #FacetFiltersForm');
    if (!target) return;
    removeActiveFilterState();

    var state = document.createElement('div');
    state.className = 'sa-selector-active-state';
    state.setAttribute('data-sa-selector-active-state', '');

    var title = document.createElement('div');
    title.className = 'sa-selector-active-state__title';
    var heading = document.querySelector('.sa-security-area__hero h1');
    title.innerHTML = '<strong>Personalised selector results</strong>';
    if (typeof count === 'number') {
      var countText = document.createElement('span');
      countText.textContent = productCountLabel(count) + ' match your setup';
      title.appendChild(countText);
    }
    state.appendChild(title);

    var chips = document.createElement('div');
    chips.className = 'sa-selector-active-state__chips';
    var labels = readableFilterLabels(filters).slice(0, 8);
    if (!labels.length && heading) labels.push(heading.textContent);
    labels.forEach(function (label) {
      var chip = document.createElement('span');
      chip.textContent = label;
      chips.appendChild(chip);
    });
    var clear = document.createElement('button');
    clear.type = 'button';
    clear.textContent = 'Clear personalised results';
    clear.addEventListener('click', function () {
      setSubmitted(root, false);
      clearSelectorResults(root, { preserveContext: true, clearCommonNeed: false });
      if (root.getAttribute('data-active-mode') === 'help') updateHelp(root, root._selectorProducts || []);
      else updateKnow(root);
    });
    chips.appendChild(clear);
    state.appendChild(chips);

    target.parentNode.insertBefore(state, target);
  }

  function applyNativeFilters(root, filters, options) {
    var query = buildSearchParams(filters, { preserveSort: true, root: root }).toString();
    if (!query) return;
    applyNativeQuery(root, query, options);
  }

  function queryFromLink(link) {
    try {
      return new URL(link.href, window.location.origin).searchParams.toString();
    } catch (error) {
      return '';
    }
  }

  function filterCountFromQuery(query) {
    var count = 0;
    new URLSearchParams(query).forEach(function () {
      count += 1;
    });
    return count;
  }

  function navigateFilterLink(root, link) {
    var query = queryFromLink(link);
    if (!query) return;
    applyNativeQuery(root, query, { scroll: false, replace: true });
  }

  function renderKnowSummary(root, filters, count, loading) {
    var heading = root.querySelector('[data-sa-recommendation-heading]');
    var note = root.querySelector('[data-sa-recommendation-note]');
    var list = root.querySelector('[data-sa-product-list]');
    var controls = root.querySelector('[data-sa-carousel-controls]');
    var summary = root.querySelector('[data-sa-selector-summary]');
    var title = root.querySelector('[data-sa-summary-title]');
    var body = root.querySelector('[data-sa-summary-body]');
    var equipment = root.querySelector('[data-sa-summary-equipment]');
    var link = root.querySelector('[data-sa-show-matches]');

    if (controls) controls.hidden = true;
    if (list) list.innerHTML = '';

    summary.classList.toggle('is-ready', filters.length > 0 && count !== 0);
    summary.classList.toggle('is-warning', filters.length > 0 && count === 0);

    if (!filters.length) {
      heading.textContent = 'Popular in this range';
      note.textContent = 'A current product from this collection before you personalise the selector.';
      title.textContent = 'Suggested starting point';
      body.textContent = 'Choose what you are shopping for, then refine the matching products in this collection.';
      equipment.textContent = '';
      renderRecommendationProducts(root, popularProducts(root._selectorProducts || [], 1));
      setCtaState(link, false, 'View matching products', '#collection-products');
      setViewMoreState(root, false, 0, []);
      return;
    }

    var countText = loading || count === null ? 'Checking products...' : productCountLabel(count) + ' match your selections';
    var selectedLabels = filters.map(function (filter) { return filter.label; }).join(', ');
    heading.textContent = count === 0 ? 'No exact matches found' : 'Ready to filter';
    note.textContent = count === 0 ? 'Try removing one requirement, reset the selector, or ask our team for help.' : 'These selections will apply to the live product grid below.';
    title.textContent = count === 0 ? 'No exact matches found' : 'Good starting point:';
    body.textContent = count === 0 ? 'No products match every selected native filter.' : (selectedLabels || productTypeLabel(selectedProductType(root, 'know')) || 'Selected specifications') + ' in this collection.';
    equipment.textContent = count === 0 ? '' : countText + '. These match your selected specifications and popular use cases.';

    if (count === 0 && list) {
      var empty = document.createElement('div');
      empty.className = 'sa-collection-selector__no-match';
      empty.innerHTML = '<strong>No exact matches found</strong><p>Try removing one requirement or reset the selector.</p>';
      list.appendChild(empty);
    }

    var ctaLabel = loading || count === null ? 'Checking products...' : (count > 0 ? 'Recommendations ready' : 'No matching products');
    setCtaState(link, false, ctaLabel, buildFilterUrl(root, filters));
  }

  function addUniqueFeatureLabel(labels, label) {
    var text = String(label || '').trim();
    var key = text.toLowerCase();
    if (!key || labels.some(function (item) { return String(item || '').trim().toLowerCase() === key; })) return;
    labels.push(text);
  }

  function featureBadgeRole(label) {
    var lower = String(label || '').toLowerCase();
    if (/\b\d{1,2}\s*mp\b/.test(lower) || lower.indexOf('4k') !== -1 || lower.indexOf('resolution') !== -1) return 'resolution';
    if (lower.indexOf('acusense') !== -1 || lower.indexOf('wizsense') !== -1 || lower.indexOf('smd') !== -1 || lower.indexOf('human') !== -1 || lower.indexOf('vehicle') !== -1 || lower.indexOf('deterrence') !== -1 || lower.indexOf('tioc') !== -1 || lower.indexOf('liveguard') !== -1) return 'smart';
    if (lower.indexOf('night') !== -1 || lower.indexOf(' ir') !== -1 || lower.indexOf('colorvu') !== -1 || lower.indexOf('colour') !== -1 || lower.indexOf('hybrid light') !== -1 || lower.indexOf('dual light') !== -1) return 'night';
    if (lower.indexOf('poe') !== -1 || lower.indexOf('nvr') !== -1 || lower.indexOf('recorder') !== -1 || lower.indexOf('network') !== -1 || lower.indexOf('channel') !== -1 || lower.indexOf('port') !== -1 || lower.indexOf('cameras') !== -1) return 'network';
    if (lower.indexOf('weather') !== -1 || lower.indexOf('ip66') !== -1 || lower.indexOf('ip67') !== -1 || lower.indexOf('ip68') !== -1 || lower.indexOf('ik10') !== -1 || lower.indexOf('outdoor') !== -1 || lower.indexOf('waterproof') !== -1) return 'weather';
    if (lower.indexOf('mic') !== -1 || lower.indexOf('audio') !== -1 || lower.indexOf('speaker') !== -1 || lower.indexOf('two-way') !== -1) return 'audio';
    if (lower.indexOf('lens') !== -1 || lower.indexOf('varifocal') !== -1 || lower.indexOf('mm') !== -1 || lower.indexOf('turret') !== -1 || lower.indexOf('dome') !== -1 || lower.indexOf('bullet') !== -1 || lower.indexOf('ptz') !== -1) return 'lens';
    if (lower.indexOf('hdd') !== -1 || lower.indexOf('tb') !== -1 || lower.indexOf('storage') !== -1 || lower.indexOf('recording') !== -1) return 'storage';
    return 'default';
  }

  function collectionGridFeatureLabels(product) {
    var labels = [];
    var role = inferProductRole(product);
    var titleText = normalise([
      product && product.title,
      product && product.type,
      product && product.productRole,
      product && product.canonicalRole,
      productTags(product).join(' ')
    ].join(' '));
    var canShowCameraCount = role === 'cctv-kit' ||
      hasKitMerchandisingEvidence(product) ||
      /\b\d{1,2}\s*x\s+(?:[a-z0-9.+/-]+\s+){0,8}cameras\b/.test(titleText) ||
      /\b\d{1,2}\s+cameras\b/.test(titleText);

    (product.badges || []).filter(isCustomerFacingFeatureBadge).forEach(function (badge) {
      var label = compactBadge(badge);
      if (/^\d{1,2}\s+cameras?$/i.test(label) && !canShowCameraCount) return;
      addUniqueFeatureLabel(labels, label);
    });

    var resolution = parseResolutionMp(product);
    if (resolution) addUniqueFeatureLabel(labels, resolution + 'MP');

    var cameraCount = parseCameraCount(product);
    if (cameraCount && canShowCameraCount) addUniqueFeatureLabel(labels, cameraCount + ' Cameras');

    var recorderChannels = parseRecorderChannels(product);
    if (recorderChannels) addUniqueFeatureLabel(labels, recorderChannels + 'CH NVR');

    var shape = inferCameraShape(product);
    var shapeLabels = {
      bullet: 'Bullet',
      dome: 'Dome',
      fisheye: 'Fisheye',
      ptz: 'PTZ',
      turret: 'Turret'
    };
    if (shapeLabels[shape]) addUniqueFeatureLabel(labels, shapeLabels[shape]);

    var text = productSearchText(product);
    if (text.indexOf('acusense') !== -1) addUniqueFeatureLabel(labels, 'AcuSense');
    if (text.indexOf('wizsense') !== -1 || text.indexOf('smd') !== -1) addUniqueFeatureLabel(labels, 'WizSense');
    if (text.indexOf('tioc') !== -1 || text.indexOf('active deterrence') !== -1) addUniqueFeatureLabel(labels, 'Deterrence');
    if (text.indexOf('colorvu') !== -1 || text.indexOf('colourvu') !== -1) addUniqueFeatureLabel(labels, 'ColorVu');
    if (text.indexOf('hybrid light') !== -1 || text.indexOf('dual light') !== -1) addUniqueFeatureLabel(labels, 'Hybrid Light');
    if (/\bir\b/.test(text) || text.indexOf('night') !== -1) addUniqueFeatureLabel(labels, 'IR Night');
    if (text.indexOf('mic') !== -1 || text.indexOf('audio') !== -1 || text.indexOf('speaker') !== -1) addUniqueFeatureLabel(labels, 'Mic');
    if (inferEnvironment(product) === 'outdoor') addUniqueFeatureLabel(labels, 'Outdoor');

    return labels.filter(isCustomerFacingFeatureBadge).slice(0, 8);
  }

  function buildCollectionGridProductCard(root, product) {
    var article = document.createElement('article');
    article.className = 'product-card product-card--collection btn-quickview-hover position-relative hover-area product-card-image--contain';
    article.dataset.productId = product.id || '';
    article.dataset.productHandle = productHandle(product);

    var priceValue = parseMoney(product.price);
    var compareValue = parseMoney(product.compareAtPrice);
    var onSale = product.compareAtPrice && compareValue !== null && priceValue !== null && compareValue > priceValue;

    var badgeContainer = document.createElement('div');
    badgeContainer.className = 'badge__container badge--fixed';
    if (product.available === false) {
      var soldOutBadge = document.createElement('span');
      soldOutBadge.className = 'badge badge--sold_out';
      soldOutBadge.textContent = 'Sold out';
      badgeContainer.appendChild(soldOutBadge);
    } else if (onSale) {
      var saleBadge = document.createElement('span');
      saleBadge.className = 'badge';
      saleBadge.textContent = 'Sale';
      badgeContainer.appendChild(saleBadge);
    }
    var shippingBadge = document.createElement('span');
    shippingBadge.className = 'badge badge--shipping';
    shippingBadge.textContent = 'Free shipping';
    badgeContainer.appendChild(shippingBadge);
    article.appendChild(badgeContainer);

    var imageHolder = document.createElement('div');
    imageHolder.className = 'product-card__image-holder mb15';
    var imageLink = document.createElement('a');
    imageLink.className = 'product-card__image image-hover-scaling__image border__radius';
    imageLink.href = product.url || '#';
    imageLink.setAttribute('aria-label', product.title || 'View product');
    imageLink.style.setProperty('--aspect-ratio', '1');
    if (product.image) {
      var img = document.createElement('img');
      img.src = product.image;
      img.alt = product.imageAlt || product.title || '';
      img.loading = 'lazy';
      img.width = 400;
      img.height = 400;
      imageLink.appendChild(img);
    }
    imageHolder.appendChild(imageLink);
    article.appendChild(imageHolder);

    var body = document.createElement('div');
    body.className = 'product-card__container mt--first-child-0';

    var titleWrapper = document.createElement('div');
    titleWrapper.className = 'mt5 body2';
    var title = document.createElement('a');
    title.className = 'product-card__heading';
    title.href = product.url || '#';
    title.textContent = product.title || 'View product';
    titleWrapper.appendChild(title);
    body.appendChild(titleWrapper);

    var price = document.createElement('div');
    price.className = 'price' + (onSale ? ' price--on-sale' : '');
    var priceContainer = document.createElement('div');
    priceContainer.className = 'price__container';
    if (product.price) {
      var salePrice = document.createElement('div');
      salePrice.className = 'price__sale';
      var currentPrice = document.createElement('span');
      currentPrice.className = 'price-item price-item--sale h5';
      currentPrice.textContent = product.price;
      salePrice.appendChild(currentPrice);
      if (onSale) {
        var comparePriceWrapper = document.createElement('span');
        comparePriceWrapper.className = 'price__regular';
        var comparePrice = document.createElement('s');
        comparePrice.className = 'price-item price-item--regular';
        comparePrice.textContent = product.compareAtPrice;
        comparePriceWrapper.appendChild(comparePrice);
        salePrice.appendChild(comparePriceWrapper);
      }
      priceContainer.appendChild(salePrice);
    }
    price.appendChild(priceContainer);
    body.appendChild(price);

    var featureLabels = collectionGridFeatureLabels(product);
    if (featureLabels.length) {
      var glance = document.createElement('div');
      glance.className = 'sa-card-glance';
      glance.setAttribute('aria-label', 'Product At a Glance highlights');
      featureLabels.forEach(function (label) {
        var badge = document.createElement('span');
        badge.className = 'sa-feature-badge sa-feature-badge--' + featureBadgeRole(label);
        badge.textContent = label;
        glance.appendChild(badge);
      });
      body.appendChild(glance);
    }

    var actions = document.createElement('div');
    actions.className = 'sa-card-actions';
    if (product.available === false) {
      var soldOut = document.createElement('button');
      soldOut.type = 'button';
      soldOut.disabled = true;
      soldOut.className = 'quick-add__submit btn btn_zoom btn--add-to-cart w-full-sp';
      soldOut.textContent = 'Sold out';
      actions.appendChild(soldOut);
    } else if (product.hasOnlyDefaultVariant && product.variantId) {
      var form = document.createElement('form');
      form.method = 'post';
      form.action = '/cart/add';
      form.className = 'product-form';
      form.acceptCharset = 'UTF-8';
      form.enctype = 'multipart/form-data';
      form.setAttribute('data-type', 'add-to-cart-form');
      var idInput = document.createElement('input');
      idInput.type = 'hidden';
      idInput.name = 'id';
      idInput.value = product.variantId;
      var quantityInput = document.createElement('input');
      quantityInput.type = 'hidden';
      quantityInput.name = 'quantity';
      quantityInput.value = '1';
      var addButton = document.createElement('button');
      addButton.type = 'submit';
      addButton.name = 'add';
      addButton.className = 'quick-add__submit btn btn_zoom btn--add-to-cart w-full-sp';
      addButton.textContent = 'Add to cart';
      form.appendChild(idInput);
      form.appendChild(quantityInput);
      form.appendChild(addButton);
      actions.appendChild(form);
    } else {
      var choose = document.createElement('a');
      choose.href = product.url || '#';
      choose.className = 'quick-add__submit btn btn_zoom btn--add-to-cart w-full-sp';
      choose.textContent = product.available ? 'Choose options' : 'View product';
      actions.appendChild(choose);
    }

    var details = document.createElement('a');
    details.className = 'sa-card-view-details';
    details.href = product.url || '#';
    details.textContent = 'View details \u2192';
    actions.appendChild(details);
    body.appendChild(actions);

    article.appendChild(body);
    return article;
  }

  function buildProductCard(root, product) {
    var article = document.createElement('article');
    article.className = 'sa-collection-selector__product-card';
    article.dataset.productId = product.id;
    article.dataset.productHandle = productHandle(product);

    if (product._recommendationLabel) {
      var label = document.createElement('div');
      label.className = 'sa-collection-selector__match-label';
      label.textContent = product._recommendationLabel;
      article.appendChild(label);
    }

    var imageLink = document.createElement('a');
    imageLink.className = 'sa-collection-selector__product-image';
    imageLink.href = product.url;
    if (product.image) {
      var img = document.createElement('img');
      img.src = product.image;
      img.alt = product.imageAlt || product.title;
      img.loading = 'lazy';
      imageLink.appendChild(img);
    }

    var body = document.createElement('div');
    var title = document.createElement('a');
    title.className = 'sa-collection-selector__product-title';
    title.href = product.url;
    title.textContent = product.title;

    var brand = document.createElement('div');
    brand.className = 'sa-collection-selector__product-brand';
    brand.textContent = customerFacingBrandLabel(product);

    var price = document.createElement('div');
    price.className = 'sa-collection-selector__product-price';
    price.textContent = product.price || '';
    if (product.compareAtPrice) {
      var compare = document.createElement('span');
      compare.className = 'sa-collection-selector__product-compare';
      compare.textContent = product.compareAtPrice;
      price.appendChild(compare);
    }

    var availability = document.createElement('div');
    availability.className = 'sa-collection-selector__availability';
    availability.textContent = product.available ? 'In stock' : 'Sold out';

    var badges = document.createElement('div');
    badges.className = 'sa-collection-selector__badges';
    (product.badges || []).filter(isCustomerFacingFeatureBadge).slice(0, 4).forEach(function (badge) {
      var badgeNode = document.createElement('span');
      badgeNode.textContent = compactBadge(badge);
      badgeNode.title = badge;
      badges.appendChild(badgeNode);
    });

    var actions = document.createElement('div');
    actions.className = 'sa-collection-selector__product-actions';
    if (product.available && product.hasOnlyDefaultVariant && product.variantId) {
      var form = document.createElement('form');
      form.method = 'post';
      form.action = '/cart/add';
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'id';
      input.value = product.variantId;
      var button = document.createElement('button');
      button.type = 'submit';
      button.textContent = 'Add to cart';
      form.appendChild(input);
      form.appendChild(button);
      actions.appendChild(form);
    } else {
      var choose = document.createElement('a');
      choose.href = product.url;
      choose.textContent = product.available ? 'Choose options' : 'View product';
      actions.appendChild(choose);
    }

    body.appendChild(title);
    if (brand.textContent) body.appendChild(brand);
    body.appendChild(price);
    body.appendChild(availability);
    if (badges.children.length) body.appendChild(badges);

    if (product._matchReasons && product._matchReasons.length) {
      var reasons = document.createElement('div');
      reasons.className = 'sa-collection-selector__match-reasons';
      var reasonsTitle = document.createElement('strong');
      reasonsTitle.textContent = 'Why it matches';
      reasons.appendChild(reasonsTitle);
      var list = document.createElement('ul');
      product._matchReasons.slice(0, 3).forEach(function (reason) {
        var item = document.createElement('li');
        item.textContent = reason;
        list.appendChild(item);
      });
      reasons.appendChild(list);
      body.appendChild(reasons);
    }

    body.appendChild(actions);

    article.appendChild(imageLink);
    article.appendChild(body);
    return article;
  }

  function applyCarousel(root, cards) {
    var controls = root.querySelector('[data-sa-carousel-controls]');
    var status = root.querySelector('[data-sa-carousel-status]');
    var prev = root.querySelector('[data-sa-carousel-prev]');
    var next = root.querySelector('[data-sa-carousel-next]');
    if (!controls || !status || !prev || !next) return;
    if (cards.length < 2) {
      controls.hidden = true;
      cards.forEach(function (card) { card.hidden = false; });
      return;
    }

    var index = 0;
    function show() {
      cards.forEach(function (card, cardIndex) {
        card.hidden = cardIndex !== index;
      });
      status.textContent = (index + 1) + ' / ' + cards.length;
      controls.hidden = false;
    }
    prev.onclick = function () {
      index = (index - 1 + cards.length) % cards.length;
      show();
    };
    next.onclick = function () {
      index = (index + 1) % cards.length;
      show();
    };
    show();
  }

  function renderRecommendationProducts(root, products, emptyMessage, emptyTitle) {
    var list = root.querySelector('[data-sa-product-list]');
    var controls = root.querySelector('[data-sa-carousel-controls]');
    if (!list) return;
    list.innerHTML = '';
    root.classList.toggle('has-selector-recommendations', Boolean(products.length));
    if (!products.length) {
      if (controls) controls.hidden = true;
      var empty = document.createElement('div');
      empty.className = 'sa-collection-selector__no-match';
      var title = emptyTitle || 'We could not find an exact product match for every requirement.';
      var message = emptyMessage || 'A product expert can help check compatibility or suggest the closest available option.';
      var actions = title === 'Recommended products will appear here' ? '' : '<div class="sa-collection-selector__no-match-actions"><button type="button" data-sa-selector-reset>Start over</button><button type="button" data-sa-expert-help>Get expert advice</button></div>';
      empty.innerHTML = '<strong>' + title + '</strong><p>' + message + '</p>' + actions;
      list.appendChild(empty);
      return;
    }
    var cards = products.slice(0, 3).map(function (product) {
      var card = buildProductCard(root, product);
      list.appendChild(card);
      return card;
    });
    if (root.getAttribute('data-active-mode') === 'help') {
      if (controls) controls.hidden = true;
      cards.forEach(function (card) { card.hidden = false; });
      return;
    }
    applyCarousel(root, cards);
  }

  function publishDestinationRecommendations(root, products, meta) {
    if (!root || (!isAreaSelector(root) && !isIndustrySelector(root))) return;
    var settings = meta || {};
    var recommendations = Array.isArray(products) ? products.slice(0, 12) : [];
    root._selectorLastRecommendations = {
      mode: root.getAttribute('data-active-mode') || '',
      title: settings.title || '',
      note: settings.note || '',
      products: recommendations,
      productIds: recommendations.map(function (product) { return String(product.id || ''); }).filter(Boolean),
      productHandles: recommendations.map(function (product) { return productHandleFromUrl(product.url) || ''; }).filter(Boolean)
    };
  }

  function popularProducts(products, max) {
    return products.filter(function (product) {
      return product.source === 'current' && product.available;
    }).sort(function (a, b) {
      return Number(b.priority || 0) - Number(a.priority || 0);
    }).slice(0, max || 1);
  }

  function productHandle(product) {
    return productHandleFromUrl(product && product.url);
  }

  function canonicalRecommendationMatches(matches, snapshot) {
    if (!snapshot || !snapshot.handles || !snapshot.handles.length) return matches;
    var handles = snapshot.handles;
    return matches.filter(function (product) {
      return handles.indexOf(productHandle(product)) !== -1;
    });
  }

  function productsFromNativeSnapshot(products, snapshot, answers) {
    if (!snapshot || !snapshot.handles || !snapshot.handles.length) return [];
    return products.filter(function (product) {
      return product.source === 'current' && snapshot.handles.indexOf(productHandle(product)) !== -1;
    }).sort(function (a, b) {
      if (answers) return scoreProduct(b, answers) - scoreProduct(a, answers);
      return Number(b.priority || 0) - Number(a.priority || 0);
    });
  }

  function matchReasonsForProduct(product, answers) {
    var text = productSearchText(product);
    var facts = productFacts(product);
    var reasons = [];
    var add = function (condition, reason) {
      if (condition && reasons.indexOf(reason) === -1) reasons.push(reason);
    };
    var has = function () {
      return Array.prototype.slice.call(arguments).some(function (term) {
        return text.indexOf(normalise(term)) !== -1;
      });
    };
    var shapeLabels = {
      bullet: 'Bullet form factor',
      dome: 'Dome form factor',
      fisheye: 'Fisheye form factor',
      ptz: 'PTZ form factor',
      turret: 'Turret form factor'
    };
    var brandLabel = customerFacingBrandLabel(product);
    var selectedBrand = (answers.brand_preference || [])[0] || '';
    var selectedShape = (answers.camera_shape || [])[0] || '';
    var shapeLabel = shapeLabels[facts.cameraShape] || '';

    add((answers.product_type || [])[0] === 'kit' && has('kit', 'package', 'bundle'), 'Complete kit with cameras and recorder together');
    add((answers.product_type || [])[0] === 'camera' && has('camera', 'turret', 'bullet', 'dome', 'ptz'), 'Single camera option for an existing system');
    add(selectedBrand && selectedBrand !== 'all' && facts.brand === selectedBrand && brandLabel, 'Matches selected ' + brandLabel + ' brand');
    add((answers.product_type || [])[0] === 'kit' && facts.completeKitVerified && facts.cameraCount && facts.recorderChannels, facts.cameraCount + ' cameras with ' + facts.recorderChannels + 'CH recorder included');
    add(shapeLabel && selectedShape === facts.cameraShape, shapeLabel + ' matches your shape preference');
    add(shapeLabel && !selectedShape, shapeLabel + ' for this camera range');
    add(facts.resolutionMp >= 8, facts.resolutionMp + 'MP / 4K detail for identification');
    add(facts.resolutionMp >= 6 && facts.resolutionMp < 8, facts.resolutionMp + 'MP detail for clearer evidence');
    add(facts.resolutionMp === 5, '5MP detail for practical coverage');
    add(facts.resolutionMp === 4, '4MP specialist/value option where ultra-high resolution is not required');
    add(facts.resolutionMp > 0 && facts.resolutionMp < 4 && facts.cameraShape === 'ptz', 'Specialist PTZ model where zoom reach matters');
    add(facts.capabilities && facts.capabilities.opticalZoom, 'Optical zoom or varifocal control for flexible coverage');
    add(facts.capabilities && facts.capabilities.aiDetection, 'Human and vehicle detection for smarter alerts');
    add(facts.capabilities && facts.capabilities.activeDeterrence, 'Active deterrence helps warn off intruders');
    add(facts.capabilities && facts.capabilities.fullColourNight, 'Full-colour night vision for clearer detail');
    add(facts.capabilities && facts.capabilities.audio, 'Audio support for richer event context');
    add((answers.area || []).indexOf('indoors') !== -1 && has('indoor', 'dome', 'turret'), 'Suited to indoor coverage');
    add((answers.area || []).indexOf('outdoors') !== -1 && has('outdoor', 'ip67', 'weather', 'bullet', 'turret'), 'Suited to outdoor installation');
    add((answers.area || []).indexOf('outdoors') !== -1 && (facts.environment === 'outdoors' || facts.environment === 'mixed'), 'Verified outdoor or weather-rated fit');
    add((answers.area || []).indexOf('indoors') !== -1 && (facts.environment === 'indoors' || facts.environment === 'mixed'), 'Suitable for indoor use');
    add((answers.use_case || []).indexOf('wide-room-360') !== -1 && has('fisheye', '360', 'panoramic'), 'Wide-area coverage for open indoor spaces');
    add((answers.use_case || []).indexOf('driveway-vehicle-entry') !== -1 && has('driveway', 'vehicle', 'bullet', 'outdoor'), 'Suitable for driveway and vehicle entry monitoring');
    add((answers.use_case || []).indexOf('perimeter-boundary') !== -1 && has('perimeter', 'boundary', 'bullet', 'active deterrence'), 'Suitable for perimeter and boundary coverage');
    add((answers.priority || []).indexOf('night-colour') !== -1 && has('colorvu', 'full colour', 'full-colour', 'dual light', 'hybrid'), 'Full-colour night vision for clearer detail');
    add((answers.priority || []).indexOf('deterrence') !== -1 && has('active deterrence', 'tioc', 'strobe', 'siren', 'liveguard'), 'Active deterrence helps warn off intruders');
    add((answers.priority || []).indexOf('false-alerts') !== -1 && has('acusense', 'wizsense', 'human', 'vehicle', 'ai'), 'Human and vehicle detection helps reduce false alerts');
    add((answers.priority || []).indexOf('faces') !== -1 && has('8mp', '4k', '12mp'), 'Higher resolution supports clearer identification');
    add((answers.priority || []).indexOf('coverage') !== -1 && has('kit', 'package', 'wide', 'ptz', 'varifocal'), 'Suited to covering larger areas');
    add((answers.priority || []).indexOf('remote') !== -1 && has('remote', 'mobile', 'app', 'poe', 'network'), 'Supports remote monitoring or networked setup');
    var rightSize = recorderRightSizeScore(product, answers);
    add(rightSize.label === 'right-sized', rightSize.reason);
    add(rightSize.label === 'expansion-friendly', rightSize.reason);
    return reasons.slice(0, 4);
  }

  function productHasTerms(product, terms) {
    var text = productSearchText(product);
    return terms.some(function (term) {
      var value = normalise(term);
      if (!value) return false;
      if (/^\d+$/.test(value)) {
        return new RegExp('(^|\\s)' + value + '(\\s|$)').test(text);
      }
      return text.indexOf(value) !== -1;
    });
  }

  function productConflictsWithIntent(product, answers) {
    var text = productSearchText(product);
    var area = (answers.area || [])[0] || '';
    var useCase = (answers.use_case || [])[0] || '';
    var has = function () {
      return Array.prototype.slice.call(arguments).some(function (term) {
        return productHasTerms(product, [term]);
      });
    };
    var hasOutdoorOnlySignals = has('bullet', 'outdoor', 'weatherproof', 'weather', 'ip66', 'ip67', 'ip68', '80m ir range', '60m ir range');
    var hasIndoorSignals = has('indoor', 'dome', 'turret', 'fisheye', 'panoramic');

    if (useCase === 'wide-room-360') {
      return has('bullet', 'outdoor', 'ip67', 'ip66') && !has('fisheye', 'panoramic', '360', 'dome', 'turret');
    }
    if (area === 'indoors' && hasOutdoorOnlySignals && !hasIndoorSignals) return true;
    return false;
  }

  function coreIntentTerms(answers) {
    var useCase = (answers.use_case || [])[0] || '';
    var area = (answers.area || [])[0] || '';
    var useCaseTerms = {
      'reception-entry': ['entry', 'reception', 'front door', 'turret', 'dome'],
      'retail-floor': ['retail', 'shop', 'fisheye', 'dome', 'wide'],
      'checkout-register': ['checkout', 'register', 'counter', '8mp', '4k', 'dome', 'turret'],
      'office-workplace': ['office', 'workplace', 'dome', 'turret'],
      'hallway-corridor': ['hallway', 'corridor', 'dome', 'turret'],
      'stockroom-back-office': ['stockroom', 'back office', 'storage', 'dome', 'turret'],
      'cabinet-high-value': ['cabinet', 'safe', '8mp', '4k', 'detail'],
      'wide-room-360': ['fisheye', '360', 'panoramic', 'wide angle', 'wide room'],
      'thermal-monitoring': ['thermal'],
      'home-entrance-deliveries': ['front door', 'entry', 'porch', 'doorbell', 'turret', 'dome'],
      'driveway-vehicle-entry': ['driveway', 'vehicle', 'bullet', 'varifocal', 'outdoor'],
      'long-driveway-rural': ['rural', 'long range', 'bullet', 'ptz', 'varifocal'],
      'car-park': ['car park', 'parking', 'vehicle', 'bullet', 'ptz', 'varifocal'],
      'perimeter-boundary': ['perimeter', 'boundary', 'bullet', 'active deterrence'],
      'gate-boom-gate': ['gate', 'entry', 'boom gate', 'bullet', 'varifocal'],
      'loading-dock-service-yard': ['loading', 'dock', 'service yard', 'warehouse', 'bullet'],
      'large-outdoor-area': ['outdoor', 'wide', 'ptz', 'varifocal', 'bullet'],
      'home-interior': ['home', 'indoor', 'dome', 'turret'],
      'retail-shop': ['retail', 'shop', 'dome', 'turret'],
      'office': ['office', 'dome', 'turret'],
      'warehouse-interior': ['warehouse', 'indoor', 'dome', 'turret'],
      'reception-corridors': ['reception', 'corridor', 'dome', 'turret'],
      'healthcare-clinic': ['healthcare', 'clinic', 'indoor', 'dome'],
      'home-exterior': ['home', 'outdoor', 'turret', 'dome'],
      'driveway-entrance': ['driveway', 'entrance', 'outdoor', 'bullet'],
      'warehouse-perimeter': ['warehouse', 'perimeter', 'bullet'],
      'farm-rural-property': ['farm', 'rural', 'bullet', 'ptz'],
      'loading-areas': ['loading', 'warehouse', 'service yard'],
      'large-commercial-property': ['commercial', 'outdoor', 'perimeter']
    };
    var areaTerms = {
      indoors: ['indoor', 'dome', 'turret', 'fisheye', '360'],
      outdoors: ['outdoor', 'weather', 'ip67', 'bullet', 'turret', 'dome'],
      home: ['home', 'residential', 'turret', 'dome'],
      'front-door': ['front door', 'entry', 'doorbell', 'intercom', 'turret', 'dome'],
      driveway: ['driveway', 'vehicle', 'bullet', 'outdoor'],
      farm: ['farm', 'rural', 'bullet', 'ptz', 'outdoor'],
      office: ['office', 'dome', 'intercom', 'access'],
      backyard: ['backyard', 'outdoor', 'turret', 'dome', 'wide'],
      'entry-points': ['entry', 'door', 'intercom', 'access'],
      'retail-shop': ['retail', 'shop', 'fisheye', 'dome', 'wide'],
      warehouse: ['warehouse', 'industrial', 'bullet', 'ptz', 'dome'],
      'car-park': ['car park', 'parking', 'bullet', 'ptz'],
      perimeter: ['perimeter', 'boundary', 'bullet', 'active deterrence']
    };
    return useCaseTerms[useCase] || areaTerms[area] || [];
  }

  function matchesCoreIntent(product, answers) {
    var terms = coreIntentTerms(answers);
    if (productConflictsWithIntent(product, answers)) return false;
    return !terms.length || productHasTerms(product, terms);
  }

  function requiresStrictCoreIntent(answers) {
    var area = (answers.area || [])[0] || '';
    var useCase = (answers.use_case || [])[0] || '';
    return area === 'indoors' || useCase === 'wide-room-360' || useCase === 'thermal-monitoring';
  }

  function rankedProducts(products, answers, source, options) {
    var settings = Object.assign({ minimumScore: 8, requireCoreIntent: true, allowIntentConflicts: false }, options || {});
    var brandPreference = normaliseBrandKey((answers.brand_preference || [])[0] || settings.brand || '');
    var seen = {};
    return products.filter(function (product) {
      if (brandPreference && detectedProductBrandKey(product) !== brandPreference) return false;
      return product.source === source;
    }).map(function (product) {
      return { product: product, score: scoreProduct(product, answers) };
    }).filter(function (item) {
      if (item.score < settings.minimumScore) return false;
      if (!settings.allowIntentConflicts && productConflictsWithIntent(item.product, answers)) return false;
      if (settings.requireCoreIntent && !matchesCoreIntent(item.product, answers)) return false;
      return true;
    }).sort(function (a, b) {
      return b.score - a.score;
    }).map(function (item) {
      return item.product;
    }).filter(function (product) {
      if (seen[product.id]) return false;
      seen[product.id] = true;
      return true;
    });
  }

  function recommendationGroups(matches, answers) {
    var max = 3;
    var groups = [];
    if (!matches.length) return groups;
    var sorted = matches.slice();
    var bestScore = scoreProduct(sorted[0], answers);
    var best = Object.assign({}, sorted[0], {
      _recommendationLabel: 'Best match',
      _matchReasons: matchReasonsForProduct(sorted[0], answers)
    });
    groups.push(best);

    var valueThreshold = bestScore * BEST_VALUE_MIN_RATIO;
    var value = sorted.slice(1).filter(function (product) {
      return product.available && scoreProduct(product, answers) >= valueThreshold && productFacts(product).price !== null;
    }).sort(function (a, b) {
      var priceDelta = productFacts(a).price - productFacts(b).price;
      if (priceDelta !== 0) return priceDelta;
      return scoreProduct(b, answers) - scoreProduct(a, answers);
    })[0];
    if (value && value.id !== best.id) {
      groups.push(Object.assign({}, value, {
        _recommendationLabel: 'Best value',
        _matchReasons: matchReasonsForProduct(value, answers)
      }));
    }

    var advanced = sorted.slice(1).find(function (product) {
      var rightSize = recorderRightSizeScore(product, answers);
      return product.id !== best.id && (!value || product.id !== value.id) && rightSize.label === 'expansion-friendly' && scoreProduct(product, answers) >= valueThreshold;
    }) || sorted.find(function (product) {
      var text = productSearchText(product);
      return product.id !== best.id && (!value || product.id !== value.id) && scoreProduct(product, answers) >= valueThreshold && (
        text.indexOf('ptz') !== -1 ||
        text.indexOf('varifocal') !== -1 ||
        text.indexOf('ai') !== -1 ||
        text.indexOf('active deterrence') !== -1
      );
    });
    if (advanced && groups.length < max) {
      var label = recorderRightSizeScore(advanced, answers).label === 'expansion-friendly' ? 'Best for expansion' : 'Premium option';
      groups.push(Object.assign({}, advanced, {
        _recommendationLabel: label,
        _matchReasons: matchReasonsForProduct(advanced, answers)
      }));
    }
    return groups.slice(0, max);
  }

  function availableNativeFilters(root) {
    return dedupeFilters(Array.prototype.slice.call(root.querySelectorAll('[data-sa-selector-panel="know"] input[type="checkbox"][data-filter-label]')).map(function (input) {
      return {
        name: input.name,
        value: input.value,
        label: input.getAttribute('data-label') || input.value,
        filterLabel: input.getAttribute('data-filter-label') || '',
        filterType: input.getAttribute('data-filter-type') || '',
        count: Number(input.getAttribute('data-count') || 0),
        urlToAdd: input.getAttribute('data-url-to-add') || '',
        urlToRemove: input.getAttribute('data-url-to-remove') || '',
        normalisedLabel: normalise(input.getAttribute('data-label') || input.value)
      };
    }));
  }

  function selectedBrandNativeFilters(root) {
    var brandKey = activeBrandPreference(root);
    if (!brandKey) return [];
    var brand = brandDefinitionForKey(brandKey);
    var terms = [brandKey];
    if (brand) terms = terms.concat([brand.label], brand.terms);
    var normalisedTerms = terms.map(normalise).filter(Boolean);
    var match = availableNativeFilters(root).find(function (filter) {
      var label = normalise([
        filter.label,
        filter.value,
        filter.filterLabel,
        filter.filterType
      ].join(' '));
      return normalisedTerms.some(function (term) { return label.indexOf(term) !== -1; });
    });
    return match ? [match] : [];
  }

  function productTypeNativeFilters(root, type) {
    if (!type) return [];
    var terms = {
      kit: ['kit', 'package', 'bundle'],
      camera: [],
      recorder: ['nvr', 'recorder']
    }[type] || [];
    if (!terms.length) return [];

    var filters = availableNativeFilters(root);
    var selected = [];
    terms.some(function (term) {
      var match = filters.find(function (filter) {
        var group = normalise(filter.filterLabel);
        var label = filter.normalisedLabel;
        if (type === 'kit') return group.indexOf('package') !== -1 || group.indexOf('bundle') !== -1 || label.indexOf(term) !== -1;
        if (type === 'recorder') return group.indexOf('nvr') !== -1 || group.indexOf('recorder') !== -1 || label.indexOf(term) !== -1;
        return false;
      });
      if (match) selected.push(match);
      return Boolean(match);
    });
    return selected;
  }

  function filtersForCameraCount(root, count) {
    var terms = {
      '4': ['4 camera', '4 cameras', '4 x'],
      '6': ['6 camera', '6 cameras', '6 x'],
      '8': ['8 camera', '8 cameras', '8 x'],
      '10': ['10 camera', '10 cameras', '10 x']
    }[String(count)] || [];
    if (!terms.length) return [];
    var filters = availableNativeFilters(root);
    var selected = [];
    terms.some(function (term) {
      var normalisedTerm = normalise(term);
      var match = filters.find(function (filter) {
        var group = normalise(filter.filterLabel);
        var label = filter.normalisedLabel;
        return group.indexOf('package') !== -1 && label.indexOf(normalisedTerm) !== -1 ||
          group.indexOf('bundle') !== -1 && label.indexOf(normalisedTerm) !== -1 ||
          group.indexOf('camera count') !== -1 && label.indexOf(normalisedTerm) !== -1 ||
          label.indexOf(normalisedTerm) !== -1;
      });
      if (match) selected.push(match);
      return Boolean(match);
    });
    return selected;
  }

  function isSizingNativeFilter(filter) {
    var group = normalise(filter && filter.filterLabel);
    var label = normalise(filter && filter.label);
    return group.indexOf('package') !== -1 ||
      group.indexOf('bundle') !== -1 ||
      group.indexOf('camera count') !== -1 ||
      group.indexOf('channel') !== -1 ||
      group.indexOf('nvr') !== -1 ||
      group.indexOf('recorder') !== -1 ||
      label.indexOf('channel') !== -1 ||
      label.indexOf('ch nvr') !== -1 ||
      label.indexOf('nvr') !== -1;
  }

  function isCameraShapeNativeFilter(filter) {
    var group = normalise(filter && filter.filterLabel);
    return group.indexOf('camera type') !== -1 ||
      group.indexOf('camera shape') !== -1 ||
      group.indexOf('shape') !== -1;
  }

  function termMatchesSelectedCameraShape(term, answers) {
    var selectedShapes = answers.camera_shape || [];
    if (!selectedShapes.length) return false;
    if (selectedShapes.indexOf('turret') !== -1 && (term === 'turret' || term === 'eyeball')) return true;
    if (selectedShapes.indexOf('dome') !== -1 && term === 'dome') return true;
    if (selectedShapes.indexOf('bullet') !== -1 && term === 'bullet') return true;
    if (selectedShapes.indexOf('ptz') !== -1 && term === 'ptz') return true;
    if (selectedShapes.indexOf('fisheye') !== -1 && (term === 'fisheye' || term === '360' || term === 'panoramic')) return true;
    return false;
  }

  function productTypeLabel(type) {
    if (type === 'kit') return 'Complete CCTV kits';
    if (type === 'camera') return 'Single cameras';
    return '';
  }

  function syncHelpAreaContext(root, clearHidden) {
    var type = selectedProductType(root, 'help') || defaultProductTypeForFamily(root);
    var fieldset = root.querySelector('[data-sa-contextual-area]');
    if (!fieldset) return;
    var legend = fieldset.querySelector('legend');
    if (legend) legend.textContent = 'Where will it be installed?';
    Array.prototype.slice.call(fieldset.querySelectorAll('[data-area-context]')).forEach(function (label) {
      var contexts = (label.getAttribute('data-area-context') || 'kit camera').split(/\s+/);
      var visible = contexts.indexOf(type) !== -1;
      label.hidden = !visible;
      if (!visible && clearHidden) {
        var input = label.querySelector('input');
        if (input) input.checked = false;
      }
    });
  }

  function selectedInstallation(root) {
    var checked = root.querySelector('[data-sa-selector-panel="help"] [data-sa-contextual-area] input:checked');
    return checked ? checked.value : '';
  }

  function syncHelpUseCaseContext(root, clearHidden) {
    var panel = root.querySelector('[data-sa-selector-panel="help"]');
    var fieldset = panel ? panel.querySelector('[data-sa-use-case-question]') : null;
    if (!fieldset) return;
    var type = selectedProductType(root, 'help') || defaultProductTypeForFamily(root);
    var location = selectedInstallation(root);
    var allowedUseCases = scopedAllowedUseCases(root);
    var hasVisible = false;

    Array.prototype.slice.call(fieldset.querySelectorAll('[data-use-context]')).forEach(function (label) {
      var locationContexts = (label.getAttribute('data-use-context') || 'indoors outdoors').split(/\s+/);
      var productContexts = (label.getAttribute('data-product-context') || 'kit camera').split(/\s+/);
      var input = label.querySelector('input');
      var allowedByArea = !allowedUseCases.length || allowedUseCases.indexOf(input ? input.value : '') !== -1;
      var visible = allowedByArea && Boolean(location) && locationContexts.indexOf(location) !== -1 && productContexts.indexOf(type) !== -1;
      label.hidden = !visible;
      hasVisible = hasVisible || visible;
      if (!visible && clearHidden) {
        if (input) input.checked = false;
      }
    });

    var hint = fieldset.querySelector('[data-sa-use-case-hint]');
    if (hint) {
      hint.hidden = Boolean(location);
      if (!location) {
        hint.textContent = 'Select indoor or outdoor first.';
      } else if (!hasVisible) {
        hint.hidden = false;
        hint.textContent = 'Choose the closest area option or switch product type.';
      }
    }
  }

  function syncContextualControls(root, mode, clearIncompatible) {
    var type = selectedProductType(root, mode);
    var panel = root.querySelector('[data-sa-selector-panel="' + mode + '"]');
    if (!panel) return;
    prefillKnownCollectionContext(root);

    Array.prototype.slice.call(panel.querySelectorAll('[data-sa-filter-group]')).forEach(function (group) {
      var contexts = (group.getAttribute('data-context-group') || 'kit camera recorder').split(/\s+/);
      var visible = Boolean(type) && contexts.indexOf(type) !== -1;
      group.hidden = !visible;
      if (!visible && clearIncompatible) {
        Array.prototype.slice.call(group.querySelectorAll('input')).forEach(function (input) {
          input.checked = false;
          if (input.matches('[data-sa-price-input]')) input.value = '';
        });
      }
    });

    if (mode === 'help') {
      syncHelpAreaContext(root, clearIncompatible);
      syncHelpUseCaseContext(root, clearIncompatible);
      Array.prototype.slice.call(panel.querySelectorAll('[data-sa-help-context-group]')).forEach(function (group) {
        var contexts = (group.getAttribute('data-sa-help-context-group') || 'kit camera').split(/\s+/);
        var visible = Boolean(type) && contexts.indexOf(type) !== -1;
        group.hidden = !visible;
        if (!visible) {
          group.removeAttribute('data-required');
        }
        if (!visible && clearIncompatible) {
          Array.prototype.slice.call(group.querySelectorAll('input')).forEach(function (input) { input.checked = false; });
          Array.prototype.slice.call(group.querySelectorAll('select')).forEach(function (select) { select.value = ''; });
        }
      });
      Array.prototype.slice.call(panel.querySelectorAll('[data-question-key="night"], [data-question-key="recording"]')).forEach(function (fieldset) {
        var key = fieldset.getAttribute('data-question-key');
        var visible = type !== 'recorder' || key === 'recording';
        fieldset.hidden = !visible;
        if (visible) {
          fieldset.setAttribute('data-required', 'true');
        } else {
          fieldset.removeAttribute('data-required');
        }
        if (!visible && clearIncompatible) {
          Array.prototype.slice.call(fieldset.querySelectorAll('input')).forEach(function (input) { input.checked = false; });
        }
      });
    }

    if (mode === 'know') {
      hideKnownCollectionContext(root);
      updateKnowSpecificationLayout(root, type);
      hideKnownCollectionContext(root);
    } else {
      hideKnownCollectionContext(root);
    }
  }

  function specFilterRole(label, type, isPrice) {
    var value = normalise(label);
    if (isPrice || value.indexOf('price') !== -1 || value.indexOf('budget') !== -1) return 'budget';
    if (type === 'kit' && (value.indexOf('camera count') !== -1 || value.indexOf('package') !== -1 || value.indexOf('bundle') !== -1)) return 'primary';
    if (type === 'camera' && (value.indexOf('camera type') !== -1 || value.indexOf('form factor') !== -1 || value.indexOf('type') !== -1)) return 'primary';
    if (value.indexOf('lens') !== -1 || value.indexOf('focal') !== -1 || value.indexOf('varifocal') !== -1 || value.indexOf('fixed') !== -1 || value.indexOf('mm') !== -1) return 'lens';
    if (value.indexOf('ir distance') !== -1 || value.indexOf('ir range') !== -1 || value.indexOf('infrared') !== -1 || value.indexOf('distance') !== -1 || value.indexOf('range') !== -1) return 'ir';
    if (value.indexOf('resolution') !== -1 || value.indexOf('mp') !== -1) return 'resolution';
    if (value.indexOf('night') !== -1 || value.indexOf('ir') !== -1 || value.indexOf('colour') !== -1 || value.indexOf('color') !== -1) return 'night';
    if (value.indexOf('technology') !== -1 || value.indexOf('detection') !== -1 || value.indexOf('ai') !== -1 || value.indexOf('feature') !== -1) return 'features';
    return 'secondary';
  }

  function labelForSpecPrimary(type) {
    if (type === 'camera') return 'What camera type do you want?';
    return 'How many cameras do you need?';
  }

  function updateKnowSpecificationLayout(root, type) {
    var panel = root.querySelector('[data-sa-selector-panel="know"]');
    var list = panel ? panel.querySelector('.sa-collection-selector__filter-list') : null;
    if (!panel || !list) return;

    var tip = list.querySelector('[data-sa-spec-tip]');
    if (!tip) {
      tip = document.createElement('div');
      tip.className = 'sa-collection-selector__spec-tip';
      tip.setAttribute('data-sa-spec-tip', '');
      tip.innerHTML = '<span aria-hidden="true">?</span><p><strong>Tip:</strong> <button type="button" data-sa-spec-switch-type></button></p>';
      list.insertBefore(tip, list.firstChild);
    }
    tip.hidden = Boolean(forcedProductType(root));

    var switchButton = tip.querySelector('[data-sa-spec-switch-type]');
    if (switchButton) {
      if (type === 'camera') {
        switchButton.textContent = 'Choose Complete CCTV kits to select camera count.';
        switchButton.setAttribute('data-target-type', 'kit');
      } else {
        switchButton.textContent = 'Choose Single cameras to select a camera type.';
        switchButton.setAttribute('data-target-type', 'camera');
      }
    }

    var groups = Array.prototype.slice.call(list.querySelectorAll('[data-sa-filter-group]'));
    groups.forEach(function (group) {
      group.classList.remove(
        'sa-collection-selector__filter-group--primary',
        'sa-collection-selector__filter-group--secondary',
        'sa-collection-selector__filter-group--resolution',
        'sa-collection-selector__filter-group--lens',
        'sa-collection-selector__filter-group--ir',
        'sa-collection-selector__filter-group--night',
        'sa-collection-selector__filter-group--features',
        'sa-collection-selector__filter-group--budget'
      );
      group.removeAttribute('data-sa-spec-role');
    });

    var visibleGroups = groups.filter(function (group) { return !group.hidden; });
    var primary = visibleGroups.find(function (group) {
      return specFilterRole(group.getAttribute('data-filter-label') || '', type, group.classList.contains('sa-collection-selector__filter-group--price')) === 'primary';
    }) || visibleGroups[0];

    var secondaryCandidates = visibleGroups.filter(function (group) { return group !== primary; });
    var selectedSecondaries = [];
    ['resolution', 'lens', 'ir', 'night', 'features', 'budget'].forEach(function (wantedRole) {
      var match = secondaryCandidates.find(function (group) {
        if (selectedSecondaries.indexOf(group) !== -1) return false;
        return specFilterRole(group.getAttribute('data-filter-label') || '', type, group.classList.contains('sa-collection-selector__filter-group--price')) === wantedRole;
      });
      if (match) selectedSecondaries.push(match);
    });
    secondaryCandidates.forEach(function (group) {
      if (selectedSecondaries.length >= 6 || selectedSecondaries.indexOf(group) !== -1) return;
      selectedSecondaries.push(group);
    });

    visibleGroups.forEach(function (group) {
      var shouldShow = group === primary || selectedSecondaries.indexOf(group) !== -1;
      if (!shouldShow) {
        group.hidden = true;
        return;
      }
      var isPrimary = group === primary;
      var role = isPrimary ? 'primary' : specFilterRole(group.getAttribute('data-filter-label') || '', type, group.classList.contains('sa-collection-selector__filter-group--price'));
      if (role === 'primary') {
        var legend = group.querySelector('legend');
        if (legend) legend.textContent = labelForSpecPrimary(type);
        var empty = group.querySelector('[data-sa-filter-select] option[value=""]');
        if (empty) empty.textContent = type === 'camera' ? 'Any camera type' : 'Any camera count';
      }
      group.setAttribute('data-sa-spec-role', role);
      group.classList.add('sa-collection-selector__filter-group--' + (role === 'primary' ? 'primary' : 'secondary'));
      if (role !== 'primary' && role !== 'secondary') {
        group.classList.add('sa-collection-selector__filter-group--' + role);
      }
    });
    syncPriceControls(root);
  }

  function defaultProductTypeForFamily(root) {
    var forced = forcedProductType(root);
    if (forced) return forced;
    var family = root.getAttribute('data-family') || '';
    if (family === 'cctv_kits' || family === 'home_solution' || family === 'business_solution') return 'kit';
    if (family === 'nvrs') return 'recorder';
    return 'camera';
  }

  function applyDefaultProductType(root, mode) {
    var panel = root.querySelector('[data-sa-selector-panel="' + mode + '"]');
    if (!panel) return;
    var forced = forcedProductType(root);
    if (forced) {
      var forcedInput = panel.querySelector('[data-sa-product-type-group] input[value="' + forced + '"]');
      if (forcedInput) forcedInput.checked = true;
      return;
    }
    if (selectedProductType(root, mode)) return;
    var preferred = defaultProductTypeForFamily(root);
    var input = panel.querySelector('[data-sa-product-type-group] input[value="' + preferred + '"]') || panel.querySelector('[data-sa-product-type-group] input');
    if (input) input.checked = true;
  }

  function enhanceNativeFilterGroups(root) {
    Array.prototype.slice.call(root.querySelectorAll('[data-sa-selector-panel="know"] [data-sa-filter-group]:not(.sa-collection-selector__filter-group--price)')).forEach(function (group) {
      if (group.querySelector('[data-sa-filter-select]')) return;
      var legend = group.querySelector('legend');
      var inputs = Array.prototype.slice.call(group.querySelectorAll('input[type="checkbox"]'));
      if (!legend || !inputs.length) return;

      var select = document.createElement('select');
      select.className = 'sa-collection-selector__select';
      select.setAttribute('data-sa-filter-select', '');
      select.setAttribute('data-filter-label', group.getAttribute('data-filter-label') || legend.textContent || '');
      select.setAttribute('data-filter-type', group.getAttribute('data-filter-type') || '');

      var empty = document.createElement('option');
      empty.value = '';
      empty.textContent = 'Any ' + (legend.textContent || 'option').toLowerCase();
      select.appendChild(empty);

      inputs.forEach(function (input) {
        var option = document.createElement('option');
        option.value = input.value;
        option.textContent = (input.getAttribute('data-label') || input.value) + ' (' + (input.getAttribute('data-count') || '0') + ')';
        option.setAttribute('data-param-name', input.name);
        option.setAttribute('data-count', input.getAttribute('data-count') || '0');
        option.setAttribute('data-url-to-add', input.getAttribute('data-url-to-add') || '');
        option.setAttribute('data-url-to-remove', input.getAttribute('data-url-to-remove') || '');
        if (input.checked) option.selected = true;
        select.appendChild(option);
      });

      group.insertBefore(select, group.querySelector('.sa-collection-selector__choices'));
      group.classList.add('sa-collection-selector__filter-group--select');
    });
  }

  function syncSelectToNativeInput(select) {
    var group = select.closest('[data-sa-filter-group]');
    if (!group) return;
    Array.prototype.slice.call(group.querySelectorAll('input[type="checkbox"]')).forEach(function (input) {
      input.checked = input.value === select.value;
    });
  }

  function syncSelectsFromNativeInputs(root) {
    Array.prototype.slice.call(root.querySelectorAll('[data-sa-filter-select]')).forEach(function (select) {
      var group = select.closest('[data-sa-filter-group]');
      var checked = group ? group.querySelector('input[type="checkbox"]:checked') : null;
      select.value = checked ? checked.value : '';
    });
  }

  function clampNumber(value, min, max) {
    var number = Number(value);
    if (Number.isNaN(number)) number = min;
    return Math.max(min, Math.min(max, number));
  }

  function syncPriceRangeControl(control) {
    var group = control.closest('[data-sa-price-range]');
    if (!group) return;
    var max = Number(group.getAttribute('data-range-max') || 0);
    var minInput = group.querySelector('[data-sa-price-input="min"]');
    var maxInput = group.querySelector('[data-sa-price-input="max"]');
    var minSlider = group.querySelector('[data-sa-price-slider="min"]');
    var maxSlider = group.querySelector('[data-sa-price-slider="max"]');
    if (!minInput || !maxInput || !minSlider || !maxSlider || !max) return;

    var minValue = clampNumber(minInput.value || minSlider.value || 0, 0, max);
    var maxValue = clampNumber(maxInput.value || maxSlider.value || max, 0, max);

    if (control === minSlider) minValue = clampNumber(minSlider.value, 0, max);
    if (control === maxSlider) maxValue = clampNumber(maxSlider.value, 0, max);
    if (control === minInput && minInput.value !== '') minValue = clampNumber(minInput.value, 0, max);
    if (control === maxInput && maxInput.value !== '') maxValue = clampNumber(maxInput.value, 0, max);

    if (minValue > maxValue) {
      if (control === minSlider || control === minInput) {
        maxValue = minValue;
      } else {
        minValue = maxValue;
      }
    }

    minSlider.value = minValue;
    maxSlider.value = maxValue;
    minInput.value = minValue > 0 ? String(Math.round(minValue)) : '';
    maxInput.value = maxValue < max ? String(Math.round(maxValue)) : '';

    var minPercent = max ? (minValue / max) * 100 : 0;
    var maxPercent = max ? (maxValue / max) * 100 : 100;
    group.style.setProperty('--sa-price-min', minPercent + '%');
    group.style.setProperty('--sa-price-max', maxPercent + '%');
  }

  function syncPriceControls(root) {
    Array.prototype.slice.call(root.querySelectorAll('[data-sa-price-range]')).forEach(function (group) {
      syncPriceRangeControl(group.querySelector('[data-sa-price-slider="min"]') || group);
    });
  }

  function resetPriceControls(root) {
    Array.prototype.slice.call(root.querySelectorAll('[data-sa-price-range]')).forEach(function (group) {
      var max = Number(group.getAttribute('data-range-max') || 0);
      var minInput = group.querySelector('[data-sa-price-input="min"]');
      var maxInput = group.querySelector('[data-sa-price-input="max"]');
      var minSlider = group.querySelector('[data-sa-price-slider="min"]');
      var maxSlider = group.querySelector('[data-sa-price-slider="max"]');
      if (minInput) minInput.value = '';
      if (maxInput) maxInput.value = '';
      if (minSlider) minSlider.value = 0;
      if (maxSlider) maxSlider.value = max;
      group.style.setProperty('--sa-price-min', '0%');
      group.style.setProperty('--sa-price-max', '100%');
    });
  }

  function updateQuickFilterSummaries(root) {
    Array.prototype.slice.call(root.querySelectorAll('[data-sa-native-quick-filter], [data-sa-help-quick-filter]')).forEach(function (group) {
      var summary = group.querySelector('[data-sa-menu-summary]');
      if (!summary) return;
      var base = group.getAttribute('data-filter-label') || 'Must haves';
      var checked = Array.prototype.slice.call(group.querySelectorAll('input:checked')).filter(function (input) {
        return !isInHiddenContext(input) && input.value !== '';
      });
      if (!checked.length) {
        summary.textContent = base;
      } else if (checked.length === 1) {
        summary.textContent = checked[0].getAttribute('data-label') || checked[0].value;
      } else {
        summary.textContent = checked.length + ' selected';
      }
      group.classList.toggle('is-active', checked.length > 0);
    });
  }

  function helpFiltersForAnswers(root, answers) {
    var nativeFilters = availableNativeFilters(root);
    var wantedTerms = [];
    var selected = [];
    var usedNames = {};
    var addTerms = function (terms) {
      terms.forEach(function (term) {
        var value = normalise(term);
        if (value && wantedTerms.indexOf(value) === -1) wantedTerms.push(value);
      });
    };

    if (((answers.product_type || [])[0] || '') === 'kit') {
      (answers.camera_count || []).forEach(function (count) {
        selected = selected.concat(filtersForCameraCount(root, count));
        if (count === '4') addTerms(['4 camera', '4 cameras', '4 x']);
        if (count === '6') addTerms(['6 camera', '6 cameras', '6 x']);
        if (count === '8') addTerms(['8 camera', '8 cameras', '8 x']);
        if (count === '10') addTerms(['10 camera', '10 cameras', '10 x']);
      });
    }

    (answers.camera_shape || []).forEach(function (shape) {
      if (shape === 'turret') addTerms(['turret', 'eyeball']);
      if (shape === 'dome') addTerms(['dome']);
      if (shape === 'bullet') addTerms(['bullet']);
      if (shape === 'ptz') addTerms(['ptz']);
      if (shape === 'fisheye') addTerms(['fisheye', '360', 'panoramic']);
    });

    (answers.area || []).forEach(function (area) {
      if (area === 'home') addTerms(['turret', 'dome', 'kit', 'camera']);
      if (area === 'farm') addTerms(['bullet', 'ptz', 'varifocal', 'outdoor']);
      if (area === 'office') addTerms(['dome', 'turret', 'intercom']);
      if (area === 'retail-shop') addTerms(['dome', 'fisheye', 'indoor']);
      if (area === 'retail-floor') addTerms(['dome', 'fisheye', 'indoor', 'retail']);
      if (area === 'warehouse') addTerms(['package', 'nvr', 'recorder', 'bullet']);
      if (area === 'front-door') addTerms(['front door', 'entry', 'turret', 'dome']);
      if (area === 'driveway') addTerms(['driveway', 'perimeter', 'bullet', 'outdoor']);
      if (area === 'backyard') addTerms(['outdoor', 'turret', 'dome']);
      if (area === 'car-park') addTerms(['car park', 'parking', 'bullet', 'ptz', 'varifocal']);
      if (area === 'perimeter') addTerms(['perimeter', 'driveway', 'bullet', 'ptz', 'active deterrence']);
      if (area === 'indoors') addTerms(['indoor', 'dome', 'turret']);
      if (area === 'outdoors') addTerms(['outdoor', 'weather', 'ip67', 'bullet', 'turret']);
      if (area === 'other') addTerms(['camera', 'kit']);
    });

    (answers.use_case || []).forEach(function (useCase) {
      if (useCase === 'reception-entry') addTerms(['entry', 'reception', 'indoor', 'turret', 'dome']);
      if (useCase === 'retail-floor') addTerms(['retail', 'shop', 'fisheye', 'dome', 'indoor']);
      if (useCase === 'checkout-register') addTerms(['retail', 'register', 'counter', 'dome', 'turret']);
      if (useCase === 'office-workplace') addTerms(['office', 'workplace', 'indoor', 'dome', 'turret']);
      if (useCase === 'hallway-corridor') addTerms(['hallway', 'corridor', 'dome', 'turret']);
      if (useCase === 'stockroom-back-office') addTerms(['stockroom', 'back office', 'indoor', 'dome']);
      if (useCase === 'cabinet-high-value') addTerms(['cabinet', 'safe', 'high value', '8mp', '4k']);
      if (useCase === 'wide-room-360') addTerms(['fisheye', '360', 'wide', 'panoramic']);
      if (useCase === 'thermal-monitoring') addTerms(['thermal']);
      if (useCase === 'home-entrance-deliveries') addTerms(['front door', 'entry', 'porch', 'turret', 'dome']);
      if (useCase === 'driveway-vehicle-entry') addTerms(['driveway', 'vehicle', 'bullet', 'outdoor', 'varifocal']);
      if (useCase === 'long-driveway-rural') addTerms(['rural', 'long range', 'bullet', 'ptz', 'varifocal']);
      if (useCase === 'car-park') addTerms(['car park', 'parking', 'bullet', 'ptz', 'varifocal']);
      if (useCase === 'perimeter-boundary') addTerms(['perimeter', 'boundary', 'bullet', 'active deterrence']);
      if (useCase === 'gate-boom-gate') addTerms(['gate', 'boom gate', 'entry', 'bullet', 'varifocal']);
      if (useCase === 'loading-dock-service-yard') addTerms(['loading', 'dock', 'service yard', 'warehouse', 'bullet']);
      if (useCase === 'large-outdoor-area') addTerms(['outdoor', 'wide', 'ptz', 'varifocal', 'bullet']);
      if (useCase === 'home-interior') addTerms(['home', 'indoor', 'kit', 'dome', 'turret']);
      if (useCase === 'retail-shop') addTerms(['retail', 'shop', 'kit', 'dome']);
      if (useCase === 'office') addTerms(['office', 'kit', 'dome', 'turret']);
      if (useCase === 'warehouse-interior') addTerms(['warehouse', 'kit', 'dome', 'bullet']);
      if (useCase === 'reception-corridors') addTerms(['reception', 'corridor', 'kit', 'dome']);
      if (useCase === 'healthcare-clinic') addTerms(['healthcare', 'clinic', 'indoor', 'dome']);
      if (useCase === 'home-exterior') addTerms(['home', 'outdoor', 'kit', 'turret', 'dome']);
      if (useCase === 'driveway-entrance') addTerms(['driveway', 'entrance', 'kit', 'outdoor']);
      if (useCase === 'warehouse-perimeter') addTerms(['warehouse', 'perimeter', 'kit', 'bullet']);
      if (useCase === 'farm-rural-property') addTerms(['farm', 'rural', 'kit', 'bullet', 'ptz']);
      if (useCase === 'loading-areas') addTerms(['loading', 'service yard', 'kit', 'warehouse']);
      if (useCase === 'large-commercial-property') addTerms(['commercial', 'kit', 'outdoor', 'perimeter']);
    });

    (answers.priority || []).forEach(function (priority) {
      if (priority === 'faces') addTerms(['8mp', '4k', '6mp']);
      if (priority === 'night-colour') addTerms(['colorvu', 'full colour', 'full-colour', 'hybrid']);
      if (priority === 'deterrence') addTerms(['active deterrence', 'tioc', 'strobe']);
      if (priority === 'false-alerts') addTerms(['acusense', 'wizsense', 'human', 'vehicle', 'ai']);
      if (priority === 'remote') addTerms(['poe', 'network']);
    });

    (answers.night || []).forEach(function (night) {
      if (night === 'full-colour') addTerms(['colorvu', 'full colour', 'full-colour', 'hybrid']);
      if (night === 'standard-ir') addTerms(['darkfighter', 'ir', 'exir']);
    });

    (answers.ir_distance || []).forEach(function (distance) {
      if (distance === 'lt-40') addTerms(['20m', '30m', '30 m', 'ir']);
      if (distance === 'gte-40') addTerms(['40m', '50m', '60m', '80m', '100m', 'long range']);
    });

    selectedBrandNativeFilters(root).forEach(function (filter) {
      selected.push(filter);
      usedNames[filter.name] = true;
    });

    wantedTerms.forEach(function (term) {
      var match = nativeFilters.find(function (filter) {
        if (isSizingNativeFilter(filter)) return false;
        if (isCameraShapeNativeFilter(filter) && !termMatchesSelectedCameraShape(term, answers)) return false;
        return !usedNames[filter.name] && filter.normalisedLabel.indexOf(term) !== -1;
      });
      if (match) {
        selected.push(match);
        usedNames[match.name] = true;
      }
    });

    return dedupeFilters(selected).slice(0, 7);
  }

  function selectedHelpAnswers(root) {
    var answers = {};
    Array.prototype.slice.call(root.querySelectorAll('[data-sa-selector-panel="help"] fieldset')).forEach(function (fieldset) {
      var key = fieldset.getAttribute('data-question-key');
      if (!key) return;
      if (isInHiddenContext(fieldset)) return;
      var checkedValues = Array.prototype.slice.call(fieldset.querySelectorAll('input:checked')).filter(function (input) {
        return input.value !== '' && !isInHiddenContext(input);
      }).map(function (input) {
        return input.value;
      });
      var selectValues = Array.prototype.slice.call(fieldset.querySelectorAll('select')).filter(function (select) {
        return select.value && !isInHiddenContext(select);
      }).map(function (select) {
        return select.value;
      });
      answers[key] = (answers[key] || []).concat(checkedValues, selectValues);
    });
    var forcedType = forcedProductType(root);
    if (forcedType) answers.product_type = [forcedType];
    var known = knownCollectionContext(root);
    if (known.installation) answers.area = [known.installation];
    if (known.cameraStyle) answers.camera_shape = [known.cameraStyle];
    if (known.resolution) answers.resolution = [known.resolution];
    if (known.brandPreference) answers.brand_preference = [known.brandPreference];
    Object.keys(root._selectorExternalAnswers || {}).forEach(function (key) {
      var values = root._selectorExternalAnswers[key];
      if (values && values.length) answers[key] = values.slice();
    });
    if (((answers.product_type || [])[0] || selectedProductType(root, 'help') || defaultProductTypeForFamily(root)) !== 'kit') {
      delete answers.camera_count;
    }
    return answers;
  }

  function requiredHelpStatus(root) {
    var required = Array.prototype.slice.call(root.querySelectorAll('[data-sa-selector-panel="help"] fieldset[data-required="true"]')).filter(function (fieldset) {
      return !isInHiddenContext(fieldset);
    });
    var answered = required.filter(function (fieldset) {
      var hasCheckedInput = Array.prototype.slice.call(fieldset.querySelectorAll('input:checked')).some(function (input) {
        return !isInHiddenContext(input);
      });
      var hasSelectedValue = Array.prototype.slice.call(fieldset.querySelectorAll('select')).some(function (select) {
        return Boolean(select.value) && !isInHiddenContext(select);
      });
      return hasCheckedInput || hasSelectedValue;
    });
    return { total: required.length, answered: answered.length, complete: required.length === answered.length };
  }

  function isEligibleForPrimaryRecommendation(product, answers) {
    var selectedType = (answers.product_type || [])[0] || '';
    var text = productSearchText(product);
    var facts = productFacts(product);
    var roleSlug = facts.productRole || canonicalRoleSlug(product.canonicalRole || product.productRole || '');
    var eligibility = normalise(product.merchandisingEligibility || '');
    var confidence = product.roleConfidence === '' || product.roleConfidence === null || typeof product.roleConfidence === 'undefined' ? null : Number(product.roleConfidence);
    var selectedShape = (answers.camera_shape || [])[0] || '';
    var hasText = function () {
      return Array.prototype.slice.call(arguments).some(function (term) {
        return text.indexOf(normalise(term)) !== -1;
      });
    };

    if (facts.isAccessory) return false;
    if (hasText('encoder', 'decoder')) return false;
    if (eligibility && eligibility !== 'primary') return false;
    if (product.manualReviewRequired === true || product.manualReviewRequired === 'true') return false;
    if (confidence !== null && !Number.isNaN(confidence) && confidence < 0.7) return false;
    if (['supporting-product', 'accessory-component', 'software-licence', 'other-supporting', 'unresolved', 'excluded', 'review', 'storage', 'network-switch', 'networking-peripheral', 'nvr', 'recorder'].indexOf(roleSlug) !== -1) return false;
    if (facts.expansionHeadroom !== null && facts.expansionHeadroom < 0) return false;
    if (selectedShape && (selectedType === 'kit' || selectedType === 'camera')) {
      if (!facts.cameraShape || facts.cameraShape === 'unknown') return false;
      if (facts.cameraShape !== selectedShape) return false;
    }
    if ((answers.area || []).indexOf('outdoors') !== -1 && ['outdoors', 'mixed'].indexOf(facts.environment) === -1) return false;
    if ((answers.area || []).indexOf('indoors') !== -1 && facts.environment === 'outdoors') return false;
    if (selectedType === 'kit') {
      var requested = selectedCameraCount(answers);
      if (!facts.completeKitVerified) return false;
      if (requested && facts.cameraCount !== null) {
        if (requested >= 10 && facts.cameraCount < 10) return false;
        if (requested < 10 && facts.cameraCount !== requested) return false;
      }
      return roleSlug === 'cctv-kit';
    }
    if (selectedType === 'camera') return ['fixed-camera', 'ptz-camera', 'wide-area-camera'].indexOf(roleSlug) !== -1 || (roleSlug === 'camera' && hasText('camera', 'bullet', 'dome', 'turret', 'eyeball', 'ptz', 'fisheye') && !hasText('kit', 'package', 'bundle', 'nvr', 'recorder'));
    return true;
  }

  function scoreProduct(product, answers) {
    if (!isEligibleForPrimaryRecommendation(product, answers)) return -999;
    var score = Number(product.priority || 0);
    var text = productSearchText(product);
    var has = function () {
      return Array.prototype.slice.call(arguments).some(function (term) {
        return text.indexOf(normalise(term)) !== -1;
      });
    };
    var selectedType = (answers.product_type || [])[0] || '';
    var isKitProduct = has('cctv kit', 'security kit', 'camera kit', 'package', 'bundle');
    var isRecorderProduct = has('nvr', 'recorder', 'channel');
    var isIntercomProduct = has('intercom', 'door station', 'doorbell');
    var isCameraProduct = has('camera', 'bullet', 'dome', 'turret', 'eyeball', 'ptz', 'fisheye');
    var facts = productFacts(product);

    if (product.available) score += SELECTOR_SCORE_WEIGHTS.availability;
    if (selectedType === 'kit' || selectedType === 'camera') score += SELECTOR_SCORE_WEIGHTS.productRole;
    if ((answers.audience || []).indexOf('business') !== -1 && has('business', 'commercial', 'warehouse', 'retail', 'office')) score += 2;
    if ((answers.audience || []).indexOf('home') !== -1 && has('home', 'residential', 'front door', 'driveway')) score += 2;
    if (isIntercomProduct) score -= 4;

    (answers.camera_count || []).forEach(function (count) {
      if (selectedType !== 'kit') return;
      var requested = count === '10' ? 10 : Number(count);
      if (!requested) return;
      if (facts.cameraCount === null) {
        score -= 4;
        return;
      }
      if (requested >= 10 && facts.cameraCount >= 10) {
        score += SELECTOR_SCORE_WEIGHTS.exactCameraCount;
      } else if (facts.cameraCount === requested) {
        score += SELECTOR_SCORE_WEIGHTS.exactCameraCount;
      }
      score += recorderRightSizeScore(product, answers).score;
    });

    (answers.camera_shape || []).forEach(function (shape) {
      if (shape === 'turret' && has('turret', 'eyeball')) score += 5;
      if (shape === 'dome' && has('dome')) score += 5;
      if (shape === 'bullet' && has('bullet')) score += 5;
      if (shape === 'ptz' && has('ptz')) score += 6;
      if (shape === 'fisheye' && has('fisheye', '360', 'panoramic')) score += 8;
      if (shape === 'fisheye' && !has('fisheye', '360', 'panoramic') && has('dome', 'turret', 'wide angle', '2.8mm')) score += 2;
    });

    (answers.ir_distance || []).forEach(function (distance) {
      if (distance === 'lt-40' && has('20m', '20 m', '30m', '30 m', '30 meter', '30 metre')) score += 4;
      if (distance === 'lt-40' && has('60m', '60 m', '80m', '80 m', '100m', '100 m')) score -= 2;
      if (distance === 'gte-40' && has('40m', '40 m', '50m', '50 m', '60m', '60 m', '80m', '80 m', '100m', '100 m', 'long range')) score += 4;
      if (distance === 'gte-40' && has('20m', '20 m', '30m', '30 m') && !has('40m', '50m', '60m', '80m', '100m')) score -= 2;
    });

    (answers.area || []).forEach(function (area) {
      if (area === 'home' && has('home', 'residential', 'turret', 'dome', 'kit')) score += 3;
      if (area === 'front-door' && has('front door', 'doorbell', 'intercom', 'entry', 'turret', 'dome')) score += 4;
      if (area === 'driveway' && has('driveway', 'perimeter', 'bullet', 'varifocal', 'outdoor')) score += 4;
      if (area === 'farm' && has('farm', 'rural', 'bullet', 'ptz', 'long range', 'outdoor')) score += 4;
      if (area === 'office' && has('office', 'dome', 'intercom', 'access')) score += 3;
      if (area === 'backyard' && has('outdoor', 'turret', 'dome', 'wide')) score += 3;
      if (area === 'entry-points' && has('entry', 'door', 'intercom', 'access')) score += 3;
      if (area === 'retail-shop' && has('retail', 'shop', 'fisheye', 'dome', 'wide')) score += 4;
      if (area === 'retail-floor' && has('retail', 'shop', 'fisheye', 'dome', 'wide', 'indoor')) score += 4;
      if (area === 'warehouse' && has('warehouse', 'industrial', 'bullet', 'ptz', 'varifocal', 'nvr', 'kit')) score += 4;
      if (area === 'car-park' && has('car park', 'parking', 'bullet', 'ptz', 'varifocal', 'outdoor')) score += 4;
      if (area === 'indoors' && (facts.environment === 'indoors' || facts.environment === 'mixed' || has('indoor', 'dome', 'turret'))) score += SELECTOR_SCORE_WEIGHTS.environmentFit;
      if (area === 'outdoors' && (facts.environment === 'outdoors' || facts.environment === 'mixed' || has('outdoor', 'weather', 'ip67', 'bullet', 'turret', 'dome'))) score += SELECTOR_SCORE_WEIGHTS.environmentFit;
      if (area === 'perimeter' && has('perimeter', 'bullet', 'ptz', 'active deterrence', 'tioc', 'strobe')) score += 4;
    });

    (answers.use_case || []).forEach(function (useCase) {
      if (useCase === 'reception-entry' && has('entry', 'reception', 'turret', 'dome')) score += 4;
      if (useCase === 'retail-floor' && has('retail', 'shop', 'fisheye', 'dome', 'wide')) score += 4;
      if (useCase === 'checkout-register' && has('retail', 'register', 'counter', 'dome', 'turret', '8mp', '4k')) score += 4;
      if (useCase === 'office-workplace' && has('office', 'workplace', 'dome', 'turret')) score += 3;
      if (useCase === 'hallway-corridor' && has('hallway', 'corridor', 'dome', 'turret')) score += 4;
      if (useCase === 'stockroom-back-office' && has('stockroom', 'back office', 'dome', 'turret')) score += 3;
      if (useCase === 'cabinet-high-value' && has('cabinet', 'safe', '8mp', '4k', 'detail')) score += 3;
      if (useCase === 'wide-room-360' && has('fisheye', '360', 'panoramic', 'wide')) score += 5;
      if (useCase === 'thermal-monitoring' && has('thermal')) score += 6;
      if (useCase === 'home-entrance-deliveries' && has('front door', 'entry', 'porch', 'turret', 'dome')) score += 4;
      if (useCase === 'driveway-vehicle-entry' && has('driveway', 'vehicle', 'bullet', 'outdoor', 'varifocal')) score += 4;
      if (useCase === 'long-driveway-rural' && has('rural', 'long range', 'bullet', 'ptz', 'varifocal')) score += 5;
      if (useCase === 'car-park' && has('car park', 'parking', 'bullet', 'ptz', 'varifocal')) score += 4;
      if (useCase === 'perimeter-boundary' && has('perimeter', 'boundary', 'bullet', 'active deterrence')) score += 4;
      if (useCase === 'gate-boom-gate' && has('gate', 'entry', 'bullet', 'varifocal')) score += 4;
      if (useCase === 'loading-dock-service-yard' && has('loading', 'dock', 'warehouse', 'bullet')) score += 4;
      if (useCase === 'large-outdoor-area' && has('outdoor', 'wide', 'ptz', 'varifocal', 'bullet')) score += 4;
      if (useCase === 'home-interior' && has('home', 'indoor', 'kit', 'dome', 'turret')) score += 4;
      if (useCase === 'retail-shop' && has('retail', 'shop', 'kit', 'dome')) score += 4;
      if (useCase === 'office' && has('office', 'kit', 'dome', 'turret')) score += 3;
      if (useCase === 'warehouse-interior' && has('warehouse', 'kit', 'dome', 'bullet')) score += 4;
      if (useCase === 'reception-corridors' && has('reception', 'corridor', 'kit', 'dome')) score += 4;
      if (useCase === 'healthcare-clinic' && has('healthcare', 'clinic', 'indoor', 'dome')) score += 3;
      if (useCase === 'home-exterior' && has('home', 'outdoor', 'kit', 'turret', 'dome')) score += 4;
      if (useCase === 'driveway-entrance' && has('driveway', 'entrance', 'kit', 'outdoor')) score += 4;
      if (useCase === 'warehouse-perimeter' && has('warehouse', 'perimeter', 'kit', 'bullet')) score += 4;
      if (useCase === 'farm-rural-property' && has('farm', 'rural', 'kit', 'bullet', 'ptz')) score += 4;
      if (useCase === 'loading-areas' && has('loading', 'warehouse', 'kit')) score += 4;
      if (useCase === 'large-commercial-property' && has('commercial', 'kit', 'outdoor', 'perimeter')) score += 4;
    });

    (answers.priority || []).forEach(function (priority) {
      if (priority === 'faces' && (facts.resolutionMp >= 8 || has('8mp', '4k', '12mp', 'face', 'detail'))) score += SELECTOR_SCORE_WEIGHTS.highResolution;
      if (priority === 'coverage' && has('kit', 'package', 'wide', 'varifocal', 'ptz', 'fisheye')) score += 3;
      if (priority === 'night-colour' && (facts.capabilities.fullColourNight || has('colorvu', 'colourvu', 'full colour', 'full-colour', 'dual light', 'tioc', 'hybrid'))) score += SELECTOR_SCORE_WEIGHTS.featureFit;
      if (priority === 'deterrence' && (facts.capabilities.activeDeterrence || has('active deterrence', 'tioc', 'strobe', 'siren', 'liveguard'))) score += SELECTOR_SCORE_WEIGHTS.featureFit;
      if (priority === 'false-alerts' && (facts.capabilities.aiDetection || has('acusense', 'wizsense', 'human', 'vehicle', 'smd'))) score += SELECTOR_SCORE_WEIGHTS.featureFit;
      if (priority === 'remote' && has('remote', 'mobile', 'app', 'poe', 'network')) score += 2;
    });

    (answers.night || []).forEach(function (night) {
      if (night === 'full-colour' && (facts.capabilities.fullColourNight || has('colorvu', 'colourvu', 'full colour', 'full-colour', 'dual light', 'tioc', 'hybrid'))) score += SELECTOR_SCORE_WEIGHTS.featureFit;
      if (night === 'standard-ir' && has('ir', 'infrared', 'darkfighter', 'exir')) score += 3;
    });

    var indoorUseCases = [
      'reception-entry',
      'retail-floor',
      'checkout-register',
      'office-workplace',
      'hallway-corridor',
      'stockroom-back-office',
      'cabinet-high-value',
      'wide-room-360',
      'home-interior',
      'retail-shop',
      'office',
      'warehouse-interior',
      'reception-corridors',
      'healthcare-clinic'
    ];
    var requestedDeterrence = (answers.priority || []).indexOf('deterrence') !== -1;
    var indoorRequest = (answers.area || []).indexOf('indoors') !== -1 || (answers.use_case || []).some(function (useCase) {
      return indoorUseCases.indexOf(useCase) !== -1;
    });
    if (indoorRequest && !requestedDeterrence && (facts.capabilities.activeDeterrence || has('active deterrence', 'tioc', 'strobe', 'siren', 'red blue', 'red & blue', 'blue red'))) score += SELECTOR_SCORE_WEIGHTS.indoorDeterrencePenalty;
    if (indoorRequest && has('dome', 'turret', 'fisheye', 'panoramic', '360')) score += 2;

    return score;
  }

  function recommendationTitle(answers, products) {
    var priority = answers.priority || [];
    var night = answers.night || [];
    var area = answers.area || [];
    var useCase = answers.use_case || [];
    var type = (answers.product_type || [])[0] || '';
    var countText = products.some(function (product) { return productSearchText(product).indexOf('8 channel') !== -1 || productSearchText(product).indexOf('8ch') !== -1; }) ? '4-8 camera PoE' : 'practical';
    if (type === 'camera') countText = 'single-camera';
    if (type === 'kit' && products.some(function (product) { return productSearchText(product).indexOf('6 x') !== -1 || productSearchText(product).indexOf('8 x') !== -1; })) countText = '6-8 camera PoE';
    if ((answers.camera_count || []).length && type === 'kit') countText = answers.camera_count[0] + ' camera';
    if (useCase.indexOf('driveway-vehicle-entry') !== -1 || useCase.indexOf('driveway-entrance') !== -1) return countText + ' setup for driveway and vehicle-entry monitoring';
    if (useCase.indexOf('home-entrance-deliveries') !== -1) return countText + ' setup for front entry and delivery monitoring';
    if (useCase.indexOf('perimeter-boundary') !== -1 || useCase.indexOf('warehouse-perimeter') !== -1) return countText + ' perimeter security setup';
    if (useCase.indexOf('retail-floor') !== -1 || useCase.indexOf('retail-shop') !== -1) return countText + ' setup for retail floor coverage';
    if (useCase.indexOf('checkout-register') !== -1) return countText + ' setup for checkout and register monitoring';
    if (useCase.indexOf('wide-room-360') !== -1) return 'wide-area indoor camera setup';
    if (useCase.indexOf('thermal-monitoring') !== -1) return 'specialised thermal monitoring setup';
    if (area.indexOf('indoors') !== -1) return type === 'camera' ? 'indoor camera starting point' : countText + ' indoor CCTV kit';
    if (area.indexOf('outdoors') !== -1) return type === 'camera' ? 'outdoor camera starting point' : countText + ' outdoor CCTV kit';
    if (priority.indexOf('deterrence') !== -1 && night.indexOf('full-colour') !== -1) return countText + ' setup with full-colour night vision and active deterrence';
    if (priority.indexOf('deterrence') !== -1) return countText + ' setup with active deterrence';
    if (night.indexOf('full-colour') !== -1) return countText + ' full-colour night setup';
    if (area.indexOf('front-door') !== -1) return 'front-entry security setup';
    return countText + ' security starting point';
  }

  function selectorTraceForProduct(product, answers) {
    var facts = productFacts(product);
    var rightSize = recorderRightSizeScore(product, answers || {});
    var eligible = isEligibleForPrimaryRecommendation(product, answers || {});
    return {
      id: product && product.id,
      handle: productHandle(product),
      title: product && product.title,
      collectionGate: product && product.source === 'current' ? 'PASS' : 'OUTER_SCOPE',
      productRole: facts.productRole,
      brand: facts.brand,
      cameraCount: facts.cameraCount,
      recorderChannels: facts.recorderChannels,
      expansionHeadroom: facts.expansionHeadroom,
      recorderRightSize: rightSize.label || 'none',
      recorderRightSizeReason: rightSize.reason || '',
      resolutionMp: facts.resolutionMp,
      cameraShape: facts.cameraShape,
      environment: facts.environment,
      hardEligibility: eligible ? 'PASS' : 'FAIL',
      finalScore: eligible ? scoreProduct(product, answers || {}) : -999
    };
  }

  function updateHelp(root, products) {
    var answers = selectedHelpAnswers(root);
    var status = requiredHelpStatus(root);
    var heading = root.querySelector('[data-sa-recommendation-heading]');
    var note = root.querySelector('[data-sa-recommendation-note]');
    var summary = root.querySelector('[data-sa-selector-summary]');
    var title = root.querySelector('[data-sa-summary-title]');
    var body = root.querySelector('[data-sa-summary-body]');
    var equipment = root.querySelector('[data-sa-summary-equipment]');
    var link = root.querySelector('[data-sa-show-matches]');
    var remaining = Math.max(0, status.total - status.answered);

    summary.classList.remove('is-warning');
    summary.classList.toggle('is-ready', status.complete);

    if (!isSubmitted(root)) {
      heading.textContent = 'Your best matches';
      note.textContent = status.complete ? 'Ready when you are. Submit to update recommendations and products below.' : 'Answer the required questions, then submit to see matching products.';
      title.textContent = status.complete ? 'Ready to recommend' : status.answered + ' of ' + status.total + ' answered';
      body.textContent = status.complete ? 'Your selections are ready. We will use them to rank recommendations and filter the product grid.' : (remaining === 1 ? 'Choose 1 more answer to continue.' : 'Choose ' + remaining + ' more answers to continue.');
      equipment.textContent = '';
      renderRecommendationProducts(root, [], status.complete ? 'Click Show my recommendations to see the best matches for your selections.' : 'Complete the required questions and your recommendations will appear here.', 'Recommended products will appear here');
      setCtaState(link, status.complete, status.complete ? 'Show my recommendations' : 'Complete the questions', '#collection-products');
      setViewMoreState(root, false, 0, []);
      return;
    }

    if (!status.complete) {
      var partialMatches = [];
      if (status.answered >= 2) {
        partialMatches = rankedProducts(products, answers, 'current', {
          minimumScore: 6,
          requireCoreIntent: false
        });
      }
      if (partialMatches.length) {
        heading.textContent = 'Good starting points';
        note.textContent = 'These update as you answer. Choose what you need to monitor to refine the recommendation.';
        title.textContent = status.answered + ' of ' + status.total + ' answered';
        body.textContent = 'Here are suitable starting points based on your product type and installation location.';
        equipment.textContent = '';
        renderRecommendationProducts(root, recommendationGroups(partialMatches, answers));
        setCtaState(link, false, 'Finish questions to filter', '#collection-products');
        setViewMoreState(root, false, 0, []);
        return;
      }
      heading.textContent = 'Recommended products will appear here';
      note.textContent = 'Complete the first three questions to see suitable options.';
      title.textContent = status.answered + ' of ' + status.total + ' answered';
      body.textContent = remaining === 1 ? 'Choose 1 more answer to see suitable products.' : 'Choose ' + remaining + ' more answers to see suitable products.';
      equipment.textContent = '';
      renderRecommendationProducts(root, [], 'Complete the first three questions and we will show suitable products from this range.', 'Recommended products will appear here');
      setCtaState(link, false, 'Complete the questions', '#collection-products');
      setViewMoreState(root, false, 0, []);
      return;
    }

    if (!root._selectorFullCatalogueLoaded && !root._selectorFullCatalogueLoadingMessageShown) {
      root._selectorFullCatalogueLoadingMessageShown = true;
      heading.textContent = 'Checking this full range';
      note.textContent = 'We are validating products in this collection before showing recommendations.';
      title.textContent = 'Checking product roles';
      body.textContent = 'Only products that satisfy the selected product type and shape will be shown.';
      equipment.textContent = '';
      renderRecommendationProducts(root, [], 'Checking this full collection for exact matches.', 'Checking final matches');
      setCtaState(link, false, 'Checking suitable products...', '#collection-products');
      setViewMoreState(root, false, 0, []);
      ensureFullCurrentCatalogue(root, products).then(function (catalogueProducts) {
        if (root.getAttribute('data-active-mode') !== 'help') return;
        root._selectorFullCatalogueLoadingMessageShown = false;
        updateHelp(root, catalogueProducts);
      });
      return;
    }

    var currentMatches = rankedProducts(products, answers, 'current', {
      minimumScore: 8,
      requireCoreIntent: true
    });
    if (!currentMatches.length) {
      currentMatches = rankedProducts(products, answers, 'current', {
        minimumScore: 8,
        requireCoreIntent: false
      });
    }

    var matches = currentMatches;
    var helpFilters = dedupeFilters(helpFiltersForAnswers(root, answers).concat(selectedNativeQuickFilters(root, 'help')));

    if (!matches.length) {
      summary.classList.remove('is-ready');
      summary.classList.add('is-warning');
      heading.textContent = 'No exact matches found';
      note.textContent = 'We could not find a product that satisfies every selected requirement.';
      title.textContent = 'No exact matches found';
      body.textContent = 'Try changing one requirement or ask our product team for guidance.';
      equipment.textContent = '';
      renderRecommendationProducts(root, [], 'Try changing one requirement or ask our team for help.', 'We could not find an exact match for every requirement.');
      setCtaState(link, false, 'Adjust selections', '#collection-products');
      setViewMoreState(root, false, 0, []);
      dispatchAnalytics(root, 'selector_no_match', { match_count: 0, broadened: false });
      return;
    }

    heading.textContent = 'Recommended for you';
    note.textContent = 'Based on the areas and priorities you selected.';
    title.textContent = 'Suggested starting point';
    body.textContent = recommendationTitle(answers, matches) + ' is a practical starting point for your selected areas and priorities.';
    equipment.textContent = 'Checking final matching products...';
    renderRecommendationProducts(root, [], 'Checking the product grid before showing recommendations.', 'Checking final matches');
    if (!helpFilters.length) {
      setCtaState(link, false, 'Recommendations ready', '#collection-products');
      setPrimaryCtaHidden(link, true);
      var directRecommendations = recommendationGroups(matches, answers);
      var directHandles = productHandlesFromProducts(matches);
      renderRecommendationProducts(root, directRecommendations);
      publishDestinationRecommendations(root, directRecommendations, {
        title: 'Refined recommendations',
        note: 'Based on the areas and priorities you selected.'
      });
      equipment.textContent = 'These recommendation-based matches are ready below.';
      renderActiveFilterState(root, selectedHelpLabelFilters(root), directHandles.length);
      setPersonalisedGridSubset(root, directHandles, directHandles.length);
      setViewMoreState(root, false, 0, [], null, directRecommendations);
      scrollToRecommendations(root);
    } else {
      var resolutionToken = Date.now() + '-' + Math.random().toString(36).slice(2);
      pendingHelpResolutions.set(root, resolutionToken);
      setCtaState(link, false, 'Checking suitable products...', buildFilterUrl(root, helpFilters));
      resolveNativeFilterSet(root, helpFilters, function (validFilters, nativeCount) {
        if (pendingHelpResolutions.get(root) !== resolutionToken) return;
        if (root.getAttribute('data-active-mode') !== 'help') return;
        if (!validFilters.length || nativeCount === 0) {
          var fallbackRecommendations = recommendationGroups(matches, answers);
          var fallbackHandles = productHandlesFromProducts(matches);
          renderRecommendationProducts(root, fallbackRecommendations);
          publishDestinationRecommendations(root, fallbackRecommendations, {
            title: 'Refined recommendations',
            note: 'Based on your selector answers and the current destination.'
          });
          setCtaState(link, false, 'Recommendations ready', '#collection-products');
          setPrimaryCtaHidden(link, true);
          renderActiveFilterState(root, selectedHelpLabelFilters(root), fallbackHandles.length);
          setPersonalisedGridSubset(root, fallbackHandles, fallbackHandles.length);
          setViewMoreState(root, false, 0, [], null, fallbackRecommendations);
          equipment.textContent = 'These recommendation-based matches are ready below.';
          scrollToRecommendations(root);
          return;
        }
        fetchNativeSnapshot(root, validFilters).then(function (snapshot) {
          if (pendingHelpResolutions.get(root) !== resolutionToken) return;
          if (root.getAttribute('data-active-mode') !== 'help') return;
          var finalMatches = matches.filter(function (product) {
            return isEligibleForPrimaryRecommendation(product, answers) && scoreProduct(product, answers) >= 0;
          });
          var finalHandles = productHandlesFromProducts(finalMatches);
          var count = finalHandles.length;
          if (!count) {
            summary.classList.remove('is-ready');
            summary.classList.add('is-warning');
            heading.textContent = 'No exact matches found';
            note.textContent = 'We could not find a product that satisfies every selected requirement.';
            title.textContent = 'No exact matches found';
            body.textContent = 'Try changing one requirement or ask our product team for guidance.';
            equipment.textContent = '';
            renderRecommendationProducts(root, [], 'Try changing one requirement or ask our team for help.', 'We could not find an exact match for every requirement.');
            renderActiveFilterState(root, selectedHelpLabelFilters(root), 0);
            restorePersonalisedGridSubset(root);
            setViewMoreState(root, false, 0, []);
            setCtaState(link, false, 'Adjust selections', '#collection-products');
            setPrimaryCtaHidden(link, false);
            return;
          }
          var recommendationProducts = recommendationGroups(finalMatches, answers);
          var finalSnapshot = {
            handles: finalHandles,
            count: count
          };
          renderRecommendationProducts(root, recommendationProducts);
          publishDestinationRecommendations(root, recommendationProducts, {
            title: 'Refined recommendations',
            note: 'Based on your selector answers and the current destination.'
          });
          equipment.textContent = productCountLabel(count) + ' match your selections.';
          if (validFilters.length < helpFilters.length) {
            equipment.textContent += ' Unavailable storefront filters were skipped; the validated selector set is shown below.';
          }
          renderActiveFilterState(root, validFilters.concat(selectedHelpLabelFilters(root)), count);
          setPersonalisedGridSubset(root, finalHandles, count);
          setViewMoreState(root, true, count, validFilters, finalSnapshot, recommendationProducts);
          setCtaState(link, false, 'Recommendations ready', buildFilterUrl(root, validFilters));
          setPrimaryCtaHidden(link, true);
          applyNativeFilters(root, validFilters, { scroll: false, replace: true });
          scrollToRecommendations(root);
        });
      });
    }
    dispatchAnalytics(root, 'selector_completed', { match_count: matches.length, broadened: false });
  }

  function updateKnow(root) {
    var filters = selectedKnowFilters(root);
    if (!isSubmitted(root)) {
      var heading = root.querySelector('[data-sa-recommendation-heading]');
      var note = root.querySelector('[data-sa-recommendation-note]');
      var list = root.querySelector('[data-sa-product-list]');
      var controls = root.querySelector('[data-sa-carousel-controls]');
      var summary = root.querySelector('[data-sa-selector-summary]');
      var title = root.querySelector('[data-sa-summary-title]');
      var body = root.querySelector('[data-sa-summary-body]');
      var equipment = root.querySelector('[data-sa-summary-equipment]');
      var link = root.querySelector('[data-sa-show-matches]');
      if (controls) controls.hidden = true;
      if (list) list.innerHTML = '';
      if (summary) {
        summary.classList.toggle('is-ready', filters.length > 0);
        summary.classList.remove('is-warning');
      }
      if (heading) heading.textContent = 'Your best matches';
      if (note) note.textContent = filters.length ? 'Submit to update recommendations and the products below.' : 'Choose any specs you know. Blank fields mean Any.';
      if (title) title.textContent = filters.length ? 'Ready to filter' : 'Choose your specs';
      if (body) body.textContent = filters.length ? readableFilterLabels(filters).slice(0, 4).join(', ') : 'Select product type, quantity, resolution, lens, night vision, price or other supported filters.';
      if (equipment) equipment.textContent = '';
      renderRecommendationProducts(root, [], filters.length ? 'Click Show matching products to apply these specs.' : 'Your matching products will appear here after you choose specs and submit.', 'Recommended products will appear here');
      setCtaState(link, filters.length > 0, filters.length ? 'Show matching products' : 'Choose specs first', '#collection-products');
      setViewMoreState(root, false, 0, []);
      return;
    }
    renderKnowSummary(root, filters, null, filters.length > 0);
    if (!filters.length) {
      setViewMoreState(root, false, 0, []);
      return;
    }
    var resolutionToken = Date.now() + '-' + Math.random().toString(36).slice(2);
    pendingKnowResolutions.set(root, resolutionToken);
    var knowAnswers = selectedKnowAnswers(root, filters);
    fetchNativeSnapshot(root, filters).then(function (snapshot) {
      if (pendingKnowResolutions.get(root) !== resolutionToken) return;
      if (root.getAttribute('data-active-mode') !== 'know') return;
      var products = productsFromNativeSnapshot(root._selectorProducts || [], snapshot, knowAnswers).filter(function (product) {
        return isEligibleForPrimaryRecommendation(product, knowAnswers) && scoreProduct(product, knowAnswers) >= 0;
      });
      var handles = productHandlesFromProducts(products);
      var count = handles.length;
      renderKnowSummary(root, filters, count, false);
      if (count > 0) {
        var recommendationProducts = products;
        var finalSnapshot = {
          handles: handles,
          count: count
        };
        renderRecommendationProducts(root, recommendationProducts);
        publishDestinationRecommendations(root, recommendationProducts, {
          title: 'Refined recommendations',
          note: 'Based on the specifications you selected.'
        });
        renderActiveFilterState(root, filters, count);
        setPersonalisedGridSubset(root, handles, count);
        setViewMoreState(root, true, count, filters, finalSnapshot, recommendationProducts);
        applyNativeFilters(root, filters, { scroll: false, replace: true });
        scrollToRecommendations(root);
      } else {
        setViewMoreState(root, false, 0, []);
      }
    });
  }

  function syncAreaOptions(root) {
    syncHelpAreaContext(root, true);
    syncHelpUseCaseContext(root, true);
  }

  function enforceLimits(root) {
    Array.prototype.slice.call(root.querySelectorAll('[data-max]')).forEach(function (fieldset) {
      var max = Number(fieldset.getAttribute('data-max'));
      var checked = Array.prototype.slice.call(fieldset.querySelectorAll('input:checked'));
      var limit = fieldset.querySelector('.sa-collection-selector__limit');
      Array.prototype.slice.call(fieldset.querySelectorAll('input:not(:checked)')).forEach(function (input) {
        input.disabled = checked.length >= max;
      });
      if (limit) limit.hidden = checked.length < max;
    });
  }

  function restoreKnowFromUrl(root) {
    var params = new URLSearchParams(window.location.search);
    Array.prototype.slice.call(root.querySelectorAll('[data-sa-selector-panel="know"] input[type="checkbox"]')).forEach(function (input) {
      input.checked = params.getAll(input.name).indexOf(input.value) !== -1;
    });
    Array.prototype.slice.call(root.querySelectorAll('[data-sa-price-input]')).forEach(function (input) {
      input.value = params.get(input.name) || input.value || '';
    });
  }

  function reset(root, products) {
    setSubmitted(root, false);
    removeActiveFilterState();
    setViewMoreState(root, false, 0, []);
    restorePersonalisedGridSubset(root);
    clearCommonNeedNotice(root);
    root._selectorExternalAnswers = {};
    root.removeAttribute('data-sa-prefill-priority');
    root.removeAttribute('data-sa-prefill-night');
    applyNativeQuery(root, '', { scroll: false, replace: true });
    Array.prototype.slice.call(root.querySelectorAll('input')).forEach(function (input) {
      input.checked = false;
      if (input.matches('[data-sa-price-input]')) input.value = '';
      input.disabled = false;
    });
    resetPriceControls(root);
    Array.prototype.slice.call(root.querySelectorAll('select')).forEach(function (select) {
      select.value = '';
    });
    syncAreaOptions(root);
    enforceLimits(root);
    syncSelectsFromNativeInputs(root);
    updateQuickFilterSummaries(root);
    applyDefaultProductType(root, 'know');
    applyDefaultProductType(root, 'help');
    syncContextualControls(root, 'know', true);
    syncContextualControls(root, 'help', true);
    root.getAttribute('data-active-mode') === 'help' ? updateHelp(root, products) : updateKnow(root);
    setCompactOpen(root, false);
    dispatchAnalytics(root, 'selector_reset');
  }

  function setMode(root, mode, products) {
    if (isSubmitted(root)) clearSelectorResults(root);
    setSubmitted(root, false);
    root.setAttribute('data-active-mode', mode);
    Array.prototype.slice.call(root.querySelectorAll('[data-sa-selector-tab]')).forEach(function (tab) {
      var selected = tab.getAttribute('data-sa-selector-tab') === mode;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
    });
    Array.prototype.slice.call(root.querySelectorAll('[data-sa-selector-panel]')).forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-sa-selector-panel') !== mode;
    });
    applyDefaultProductType(root, mode);
    syncContextualControls(root, mode, false);
    updateQuickFilterSummaries(root);
    if (mode === 'help') {
      updateHelp(root, products);
    } else {
      updateKnow(root);
    }
    if (isCompactPresentation(root) && root.getAttribute('data-compact-open') === 'true') setCompactOpen(root, true);
    dispatchAnalytics(root, 'selector_mode_selected', { selector_mode: mode });
  }

  function init(root) {
    var dataNode = root.querySelector('[data-sa-selector-products]');
    var products = [];
    try {
      products = dataNode ? JSON.parse(dataNode.textContent) : [];
    } catch (error) {
      products = [];
    }

    products.forEach(function (product) {
      product._search = productSearchText(product);
    });
    root._selectorProducts = products;
    var currentProducts = function () {
      return root._selectorProducts || products || [];
    };
    setSubmitted(root, false);
    applyIndustrySchema(root);

    restoreKnowFromUrl(root);
    enhanceNativeFilterGroups(root);
    syncSelectsFromNativeInputs(root);
    applyDefaultProductType(root, 'know');
    applyDefaultProductType(root, 'help');
    syncContextualControls(root, 'know', false);
    syncContextualControls(root, 'help', false);
    syncAreaOptions(root);
    enforceLimits(root);
    updateQuickFilterSummaries(root);

    var defaultMode = 'help';
    var appliedCommonNeed = applyCommonNeedFromUrl(root, products);
    if (!appliedCommonNeed) {
      setMode(root, defaultMode, products);
    }
    setCompactOpen(root, false);

    Array.prototype.slice.call(root.querySelectorAll('[data-sa-selector-tab]')).forEach(function (tab, index, tabs) {
      tab.addEventListener('click', function () {
        setMode(root, tab.getAttribute('data-sa-selector-tab'), currentProducts());
      });
      tab.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        var nextIndex = event.key === 'ArrowRight' ? (index + 1) % tabs.length : (index - 1 + tabs.length) % tabs.length;
        tabs[nextIndex].focus();
        setMode(root, tabs[nextIndex].getAttribute('data-sa-selector-tab'), currentProducts());
      });
    });

    root.addEventListener('change', function (event) {
      if (event.target.matches('[data-sa-filter-select]')) {
        syncSelectToNativeInput(event.target);
      } else if (event.target.matches('[data-sa-price-slider], [data-sa-price-input]')) {
        syncPriceRangeControl(event.target);
      } else if (!event.target.matches('input, select')) {
        return;
      }
      if (isSubmitted(root)) clearSelectorResults(root);
      setSubmitted(root, false);
      var isProductType = Boolean(event.target.closest('[data-sa-product-type-group]'));
      var isInstallation = Boolean(event.target.closest('[data-sa-contextual-area]'));
      syncContextualControls(root, root.getAttribute('data-active-mode') || defaultMode, isProductType || isInstallation);
      syncAreaOptions(root);
      enforceLimits(root);
      updateQuickFilterSummaries(root);
      if (root.getAttribute('data-active-mode') === 'help') {
        updateHelp(root, currentProducts());
      } else {
        updateKnow(root);
      }
      dispatchAnalytics(root, 'selector_answer_selected', {
        question_key: event.target.closest('fieldset') ? event.target.closest('fieldset').getAttribute('data-question-key') || event.target.name : event.target.name,
        selected_value: event.target.value
      });
    });

    root.addEventListener('input', function (event) {
      if (!event.target.matches('[data-sa-price-slider], [data-sa-price-input]')) return;
      if (isSubmitted(root)) clearSelectorResults(root);
      setSubmitted(root, false);
      syncPriceRangeControl(event.target);
      if (root.getAttribute('data-active-mode') === 'know') updateKnow(root);
    });

    root.addEventListener('click', function (event) {
      var compactOpen = event.target.closest('[data-sa-compact-open]');
      if (compactOpen) {
        openCompactSelector(root, compactOpen.getAttribute('data-sa-compact-open'), currentProducts(), { focus: true });
        return;
      }
      var compactClose = event.target.closest('[data-sa-compact-close]');
      if (compactClose) {
        event.preventDefault();
        setCompactOpen(root, false);
        return;
      }
      var commonNeedClear = event.target.closest('[data-sa-common-need-clear]');
      if (commonNeedClear) {
        reset(root, currentProducts());
        return;
      }
      var noMatchReset = event.target.closest('.sa-collection-selector__no-match [data-sa-selector-reset]');
      if (noMatchReset) {
        reset(root, currentProducts());
        return;
      }
      var noMatchExpert = event.target.closest('.sa-collection-selector__no-match [data-sa-expert-help]');
      if (noMatchExpert) {
        openExpertHelp(root, noMatchExpert);
        return;
      }
      var switchButton = event.target.closest('[data-sa-spec-switch-type]');
      if (!switchButton) return;
      var targetType = switchButton.getAttribute('data-target-type');
      var targetInput = root.querySelector('[data-sa-selector-panel="know"] [data-sa-product-type-group] input[value="' + targetType + '"]');
      if (!targetInput) return;
      targetInput.checked = true;
      setSubmitted(root, false);
      syncContextualControls(root, 'know', true);
      syncSelectsFromNativeInputs(root);
      updateKnow(root);
      dispatchAnalytics(root, 'selector_answer_selected', {
        question_key: 'product_type',
        selected_value: targetType
      });
    });

    var refineButton = root.querySelector('[data-sa-refine-setup]');
    if (refineButton) {
      refineButton.addEventListener('click', function () {
        var target = document.getElementById('collection-products') || document.querySelector('[data-id="collection-products"], facet-filters-form, #FacetFiltersForm, #FacetFiltersFormMobile');
        if (target) {
          target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          if (typeof target.focus === 'function') target.focus({ preventScroll: true });
        } else {
          window.location.hash = 'collection-products';
        }
      });
    }

    var resetButton = root.querySelector('[data-sa-selector-reset]');
    if (resetButton) {
      resetButton.addEventListener('click', function () {
        reset(root, currentProducts());
      });
    }

    var showMatches = root.querySelector('[data-sa-show-matches]');
    if (showMatches) {
      showMatches.addEventListener('click', function (event) {
        if (showMatches.getAttribute('aria-disabled') === 'true') {
          event.preventDefault();
          return;
        }
        event.preventDefault();
        setSubmitted(root, true);
        var mode = root.getAttribute('data-active-mode') || defaultMode;
        if (mode === 'help') {
          updateHelp(root, currentProducts());
          dispatchAnalytics(root, 'selector_show_matches_clicked', { selector_mode: 'help' });
          return;
        }
        updateKnow(root);
        dispatchAnalytics(root, 'selector_show_matches_clicked', { selector_mode: 'know' });
      });
    }

    var viewMore = root.querySelector('[data-sa-view-matching-products]');
    if (viewMore) {
      viewMore.addEventListener('click', function () {
        var state = root._selectorCanonicalState;
        if (!state || !state.filters || !state.filters.length) return;
        applyNativeFilters(root, state.filters, { scroll: true, replace: false });
        dispatchAnalytics(root, 'selector_view_more_clicked', { filter_count: state.filters.length, native_count: state.count });
      });
    }

    var expert = root.querySelector('[data-sa-expert-help]');
    if (expert) {
      expert.addEventListener('click', function () {
        openExpertHelp(root, expert);
      });
    }

    document.addEventListener('sa:collection-grid:rendered', function (event) {
      var searchParams = event && event.detail ? event.detail.searchParams : '';
      applyPersonalisedGridSubset(root, { nativeFiltersActive: searchParamsHaveNativeFilters(searchParams) });
    });

    dispatchAnalytics(root, 'selector_opened');
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll(SELECTOR)).forEach(function (root) {
      if (root.dataset.saSelectorReady === 'true') return;
      root.dataset.saSelectorReady = 'true';
      init(root);
    });
  }

  window.saCollectionSelectorIndustryApi = window.saCollectionSelectorIndustryApi || {};
  Object.assign(window.saCollectionSelectorIndustryApi, {
    aliases: COMMON_NEED_ALIASES,
    presets: COMMON_NEED_PRESETS,
    canonicalCommonNeedSlug: canonicalCommonNeedSlug,
    answersForCommonNeed: answersForCommonNeedSlug,
    recommendProductsForCommonNeed: recommendProductsForCommonNeed,
    applyCommonNeed: function (slug, options) {
      var settings = options || {};
      var root = settings.root;
      if (typeof root === 'string') root = document.querySelector(root);
      if (!root) root = document.querySelector(SELECTOR);
      if (!root) return false;
      return applyCommonNeedSlugToRoot(root, root._selectorProducts || [], slug, settings);
    },
    setBrandPreference: function (brand, options) {
      var settings = options || {};
      var root = settings.root;
      if (typeof root === 'string') root = document.querySelector(root);
      if (!root) root = document.querySelector(SELECTOR);
      if (!root) return false;
      setBrandPreference(root, brand);
      if (root.getAttribute('data-active-mode') === 'help') updateHelp(root, root._selectorProducts || []);
      if (root.getAttribute('data-active-mode') === 'know') updateKnow(root);
      return true;
    }
  });

  window.saCollectionSelectorApi = window.saCollectionSelectorApi || {};
  Object.assign(window.saCollectionSelectorApi, {
    scoreWeights: SELECTOR_SCORE_WEIGHTS,
    collectionIntents: COLLECTION_INTENTS,
    productFacts: productFacts,
    traceProduct: selectorTraceForProduct,
    open: function (mode, options) {
      var settings = options || {};
      var root = settings.root;
      if (typeof root === 'string') root = document.querySelector(root);
      if (!root) root = document.querySelector(SELECTOR);
      if (!root) return false;
      openCompactSelector(root, mode, root._selectorProducts || [], settings);
      return true;
    },
    close: function (options) {
      var settings = options || {};
      var root = settings.root;
      if (typeof root === 'string') root = document.querySelector(root);
      if (!root) root = document.querySelector(SELECTOR);
      if (!root) return false;
      setCompactOpen(root, false);
      return true;
    },
    clearPersonalisation: function (options) {
      var settings = options || {};
      var root = settings.root;
      if (typeof root === 'string') root = document.querySelector(root);
      if (!root) root = document.querySelector(SELECTOR);
      if (!root) return false;
      setSubmitted(root, false);
      if (settings.resetAnswers) {
        clearHelpSelections(root);
        syncContextualControls(root, 'help', true);
        syncAreaOptions(root);
        enforceLimits(root);
        updateQuickFilterSummaries(root);
      }
      clearSelectorResults(root, {
        resetNative: settings.resetNative !== false,
        preserveContext: settings.preserveContext !== false,
        clearCommonNeed: settings.clearCommonNeed === true
      });
      if (settings.collapse) setCompactOpen(root, false);
      root.getAttribute('data-active-mode') === 'help' ? updateHelp(root, root._selectorProducts || []) : updateKnow(root);
      return true;
    },
    applyCollectionIntent: function (slug, options) {
      var settings = options || {};
      var root = settings.root;
      if (typeof root === 'string') root = document.querySelector(root);
      if (!root) root = document.querySelector(SELECTOR);
      if (!root) return false;
      return applyCollectionIntentToRoot(root, root._selectorProducts || [], slug, settings);
    },
    applyAnswers: function (answers, options) {
      var settings = options || {};
      var root = settings.root;
      if (typeof root === 'string') root = document.querySelector(root);
      if (!root) root = document.querySelector(SELECTOR);
      if (!root) return false;
      return applyAnswersToRoot(root, root._selectorProducts || [], answers, settings);
    }
  });

  window.saCollectionSelectorDebug = window.saCollectionSelectorDebug || {
    roots: function () {
      return Array.prototype.slice.call(document.querySelectorAll(SELECTOR)).map(function (root) {
        return {
          handle: root.getAttribute('data-collection-handle') || '',
          mode: selectorMode(root),
          context: root.getAttribute('data-selector-context') || '',
          presentation: root.getAttribute('data-selector-presentation') || '',
          activeMode: root.getAttribute('data-active-mode') || '',
          productType: selectedProductType(root, root.getAttribute('data-active-mode') || 'help'),
          assertion: root._selectorCanonicalState ? root._selectorCanonicalState.assertion : null
        };
      });
    },
    assertCurrent: function (selector) {
      var root = typeof selector === 'string' ? document.querySelector(selector) : selector;
      if (!root) root = document.querySelector(SELECTOR);
      return root && root._selectorCanonicalState ? root._selectorCanonicalState.assertion : null;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    Array.prototype.slice.call(event.target.querySelectorAll(SELECTOR)).forEach(init);
  });
})();
